// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AddCompanyContactTagData, AddCompanyContactTagErrors, AddCompanyContactTagResponses, AddPersonContactTagData, AddPersonContactTagErrors, AddPersonContactTagResponses, AppVersionData, AppVersionResponses, CloseMarketSearchData, CloseMarketSearchErrors, CloseMarketSearchResponses, CreateEmailTemplateData, CreateEmailTemplateErrors, CreateEmailTemplateResponses, CreateEventEmailTemplateData, CreateEventEmailTemplateErrors, CreateEventEmailTemplateResponses, CreateMarketSearchData, CreateMarketSearchErrors, CreateMarketSearchResponses, CreatePersonContactTagDefinitionData, CreatePersonContactTagDefinitionErrors, CreatePersonContactTagDefinitionResponses, DeleteAllCandidatePathwayActivityTargetsData, DeleteAllCandidatePathwayActivityTargetsErrors, DeleteAllCandidatePathwayActivityTargetsResponses, DeleteAPipelineData, DeleteAPipelineErrors, DeleteAPipelineResponses, DeleteCandidateCompanyMetadataData, DeleteCandidateCompanyMetadataErrors, DeleteCandidateCompanyMetadataResponses, DeleteCandidateFavoriteData, DeleteCandidateFavoriteErrors, DeleteCandidateFavoriteResponses, DeleteCandidateFeedbackData, DeleteCandidateFeedbackErrors, DeleteCandidateFeedbackResponses, DeleteCandidateGoalActivityData, DeleteCandidateGoalActivityErrors, DeleteCandidateGoalActivityResponses, DeleteCandidateGoalData, DeleteCandidateGoalErrors, DeleteCandidateGoalResponses, DeleteCandidatePathwayActivityTargetData, DeleteCandidatePathwayActivityTargetErrors, DeleteCandidatePathwayActivityTargetResponses, DeleteCandidateReferrerData, DeleteCandidateReferrerErrors, DeleteCandidateReferrerResponses, DeleteCommentData, DeleteCommentErrors, DeleteCommentResponses, DeleteCompanyData, DeleteCompanyErrors, DeleteCompanyResponses, DeleteEmailTemplateData, DeleteEmailTemplateDefaultData, DeleteEmailTemplateDefaultErrors, DeleteEmailTemplateDefaultResponses, DeleteEmailTemplateErrors, DeleteEmailTemplateResponses, DeleteEventData, DeleteEventEmailTemplateData, DeleteEventEmailTemplateErrors, DeleteEventEmailTemplateResponses, DeleteEventErrors, DeleteEventGuestData, DeleteEventGuestErrors, DeleteEventGuestResponses, DeleteEventLandingImageData, DeleteEventLandingImageErrors, DeleteEventLandingImageResponses, DeleteEventResponses, DeleteExecutiveActivationData, DeleteExecutiveActivationErrors, DeleteExecutiveActivationResponses, DeleteHighlightData, DeleteHighlightErrors, DeleteHighlightResponses, DeleteIdentityCandidateData, DeleteIdentityCandidateErrors, DeleteIdentityCandidateResponses, DeleteIdentityPersonData, DeleteIdentityPersonErrors, DeleteIdentityPersonResponses, DeleteInternalCommentData, DeleteInternalCommentErrors, DeleteInternalCommentResponses, DeleteIntroductionTemplateData, DeleteIntroductionTemplateErrors, DeleteIntroductionTemplateResponses, DeleteMarketSearchData, DeleteMarketSearchErrors, DeleteMarketSearchResponses, DeletePeerCommentData, DeletePeerCommentErrors, DeletePeerCommentResponses, DeletePeerData, DeletePeerErrors, DeletePeerResponses, DeletePersonContactTagDefinitionData, DeletePersonContactTagDefinitionErrors, DeletePersonContactTagDefinitionResponses, DeletePersonImageData, DeletePersonImageErrors, DeletePersonImageResponses, DeleteRecommendationAssigneeData, DeleteRecommendationAssigneeErrors, DeleteRecommendationAssigneeResponses, DeleteRecommendationData, DeleteRecommendationErrors, DeleteRecommendationResponses, DeleteSubmissionData, DeleteSubmissionErrors, DeleteSubmissionResponses, DeleteTaskData, DeleteTaskErrors, DeleteTaskModuleData, DeleteTaskModuleErrors, DeleteTaskModuleResponses, DeleteTaskResponses, DeleteTeamContactCommentData, DeleteTeamContactCommentErrors, DeleteTeamContactCommentResponses, DeleteTeamData, DeleteTeamErrors, DeleteTeamMemberData, DeleteTeamMemberErrors, DeleteTeamMemberResponses, DeleteTeamResponses, DeleteUserV2Data, DeleteUserV2Errors, DeleteUserV2Responses, FindIdentityData, FindIdentityErrors, FindIdentityResponses, GetAllEventGuestsData, GetAllEventGuestsErrors, GetAllEventGuestsResponses, GetAutotagPreviewStatusData, GetAutotagPreviewStatusErrors, GetAutotagPreviewStatusResponses, GetCandidateActivityLogsData, GetCandidateActivityLogsErrors, GetCandidateActivityLogsResponses, GetCandidateActivityLogsSearchData, GetCandidateActivityLogsSearchErrors, GetCandidateActivityLogsSearchResponses, GetCandidateCommentaryData, GetCandidateCommentaryErrors, GetCandidateCommentaryResponses, GetCandidateCompanyMetadataData, GetCandidateCompanyMetadataErrors, GetCandidateCompanyMetadataResponses, GetCandidateGoalsData, GetCandidateGoalsErrors, GetCandidateGoalsResponses, GetCandidateGoalsWithActivitiesData, GetCandidateGoalsWithActivitiesErrors, GetCandidateGoalsWithActivitiesResponses, GetCandidateGoalV2Data, GetCandidateGoalV2Errors, GetCandidateGoalV2Responses, GetCandidateImageData, GetCandidateImageErrors, GetCandidateImageResponses, GetCandidateIntroductionsTeamHistoryData, GetCandidateIntroductionsTeamHistoryErrors, GetCandidateIntroductionsTeamHistoryResponses, GetCandidateIntroductionTemplatesData, GetCandidateIntroductionTemplatesErrors, GetCandidateIntroductionTemplatesResponses, GetCandidateOffLimitsCompaniesData, GetCandidateOffLimitsCompaniesErrors, GetCandidateOffLimitsCompaniesResponses, GetCandidateOffLimitsIdentitiesData, GetCandidateOffLimitsIdentitiesErrors, GetCandidateOffLimitsIdentitiesResponses, GetCandidatePathwayActivityTargetsData, GetCandidatePathwayActivityTargetsErrors, GetCandidatePathwayActivityTargetsResponses, GetCandidateRecommendationsCompareBackgroundData, GetCandidateRecommendationsCompareBackgroundErrors, GetCandidateRecommendationsCompareBackgroundResponses, GetCandidateRecommendationsComparePerformanceData, GetCandidateRecommendationsComparePerformanceErrors, GetCandidateRecommendationsComparePerformanceResponses, GetCandidateRecommendationsComparePipelinesData, GetCandidateRecommendationsComparePipelinesErrors, GetCandidateRecommendationsComparePipelinesResponses, GetCandidateRecommendationsCompareRecommendationsData, GetCandidateRecommendationsCompareRecommendationsErrors, GetCandidateRecommendationsCompareRecommendationsResponses, GetCandidateRecommendationsData, GetCandidateRecommendationsErrors, GetCandidateRecommendationsResponses, GetCandidateResumeData, GetCandidateResumeErrors, GetCandidateResumeResponses, GetCandidatesFindData, GetCandidatesFindErrors, GetCandidatesFindResponses, GetCandidateStatsData, GetCandidateStatsErrors, GetCandidateStatsResponses, GetCandidateTasksOnboardingData, GetCandidateTasksOnboardingErrors, GetCandidateTasksOnboardingResponses, GetCandidateV2Data, GetCandidateV2Errors, GetCandidateV2Responses, GetCompaniesData, GetCompaniesErrors, GetCompaniesFindData, GetCompaniesFindErrors, GetCompaniesFindResponses, GetCompaniesResponses, GetCompaniesSectorsData, GetCompaniesSectorsErrors, GetCompaniesSectorsResponses, GetCompanyByNameData, GetCompanyByNameErrors, GetCompanyByNameResponses, GetCompanyData, GetCompanyErrors, GetCompanyMembersData, GetCompanyMembersErrors, GetCompanyMembersResponses, GetCompanyResponses, GetContactsFindData, GetContactsFindErrors, GetContactsFindResponses, GetCountriesData, GetCountriesResponses, GetEmailPreviewData, GetEmailPreviewErrors, GetEmailPreviewResponses, GetEmailTemplateData, GetEmailTemplateErrors, GetEmailTemplateResponses, GetEsIndexData, GetEsIndexErrors, GetEsIndexResponses, GetEventData, GetEventEmailBatchesData, GetEventEmailBatchesErrors, GetEventEmailBatchesResponses, GetEventEmailEventsData, GetEventEmailEventsErrors, GetEventEmailEventsResponses, GetEventErrors, GetEventGuestsData, GetEventGuestsErrors, GetEventGuestsResponses, GetEventLandingImagePublicData, GetEventLandingImagePublicErrors, GetEventLandingImagePublicResponses, GetEventResponses, GetEventRsvpLandingData, GetEventRsvpLandingErrors, GetEventRsvpLandingImageData, GetEventRsvpLandingImageErrors, GetEventRsvpLandingImageResponses, GetEventRsvpLandingResponses, GetEventRsvpPreviewData, GetEventRsvpPreviewErrors, GetEventRsvpPreviewResponses, GetEventsData, GetEventsErrors, GetEventsResponses, GetExecutiveClientCandidateData, GetExecutiveClientCandidateErrors, GetExecutiveClientCandidateResponses, GetExecutiveClientContactData, GetExecutiveClientContactErrors, GetExecutiveClientContactResponses, GetExecutiveClientEventData, GetExecutiveClientEventErrors, GetExecutiveClientEventResponses, GetExecutiveClientPersonDetailData, GetExecutiveClientPersonDetailErrors, GetExecutiveClientPersonDetailResponses, GetExecutiveClientSettingsData, GetExecutiveClientSettingsErrors, GetExecutiveClientSettingsResponses, GetExecutiveClientTeamData, GetExecutiveClientTeamErrors, GetExecutiveClientTeamResponses, GetExecutiveClientTrendingData, GetExecutiveClientTrendingErrors, GetExecutiveClientTrendingRecommendationData, GetExecutiveClientTrendingRecommendationErrors, GetExecutiveClientTrendingRecommendationResponses, GetExecutiveClientTrendingResponses, GetExecutiveData, GetExecutiveErrors, GetExecutiveResponses, GetExecutivesData, GetExecutivesResponses, GetFilesImageData, GetFilesImageErrors, GetFilesImageResponses, GetFindData, GetFindErrors, GetFindResponses, GetHomeActivityLogsData, GetHomeActivityLogsErrors, GetHomeActivityLogsResponses, GetHomeAllIntrosData, GetHomeAllIntrosErrors, GetHomeAllIntrosResponses, GetHomeCandidatesDownvotesData, GetHomeCandidatesDownvotesResponses, GetHomeTeamActivityData, GetHomeTeamActivityErrors, GetHomeTeamActivityResponses, GetHomeTeamCandidatesData, GetHomeTeamCandidatesErrors, GetHomeTeamCandidatesResponses, GetHomeTeamStatsData, GetHomeTeamStatsErrors, GetHomeTeamStatsResponses, GetIdentityData, GetIdentityEmailEventsData, GetIdentityEmailEventsErrors, GetIdentityEmailEventsResponses, GetIdentityErrors, GetIdentityResponses, GetJobsAutoIntroductionsData, GetJobsAutoIntroductionsResponses, GetJobsDraftStatusChangeEmailsData, GetJobsDraftStatusChangeEmailsErrors, GetJobsDraftStatusChangeEmailsResponses, GetJobsFacilitatedIntroReminderData, GetJobsFacilitatedIntroReminderErrors, GetJobsFacilitatedIntroReminderResponses, GetJobsHubspotFieldSyncData, GetJobsHubspotFieldSyncErrors, GetJobsHubspotFieldSyncResponses, GetJobsLinkedinBatchSyncData, GetJobsLinkedinBatchSyncErrors, GetJobsLinkedinBatchSyncResponses, GetJobsMarketSearchClassificationCatchupData, GetJobsMarketSearchClassificationCatchupErrors, GetJobsMarketSearchClassificationCatchupResponses, GetJobsMarketSearchClosureVerificationData, GetJobsMarketSearchClosureVerificationErrors, GetJobsMarketSearchClosureVerificationResponses, GetJobsMarketSearchResolveSweepData, GetJobsMarketSearchResolveSweepErrors, GetJobsMarketSearchResolveSweepResponses, GetJobsRefreshTeamInsightsData, GetJobsRefreshTeamInsightsErrors, GetJobsRefreshTeamInsightsResponses, GetJobsResendinviteData, GetJobsResendinviteErrors, GetJobsResendinviteResponses, GetJobsScheduledIntrosData, GetJobsScheduledIntrosErrors, GetJobsScheduledIntrosResponses, GetJobsScheduledP2pIntrosData, GetJobsScheduledP2pIntrosErrors, GetJobsScheduledP2pIntrosResponses, GetMarketSearchContactOptionsData, GetMarketSearchContactOptionsErrors, GetMarketSearchContactOptionsResponses, GetMarketSearchData, GetMarketSearchErrors, GetMarketSearchPipelineOptionsData, GetMarketSearchPipelineOptionsErrors, GetMarketSearchPipelineOptionsResponses, GetMarketSearchResponses, GetMarketSearchTeamOptionsData, GetMarketSearchTeamOptionsErrors, GetMarketSearchTeamOptionsResponses, GetNewCandidatesData, GetNewCandidatesErrors, GetNewCandidatesResponses, GetPathwayActivityDefaultsData, GetPathwayActivityDefaultsResponses, GetPeerActivityData, GetPeerActivityErrors, GetPeerActivityResponses, GetPeerData, GetPeerErrors, GetPeerResponses, GetPeopleAdvisorsData, GetPeopleAdvisorsErrors, GetPeopleAdvisorsResponses, GetPeopleCurrentData, GetPeopleCurrentResponses, GetPeopleCurrentTeamsData, GetPeopleCurrentTeamsResponses, GetPeopleFindData, GetPeopleFindErrors, GetPeopleFindResponses, GetPeopleInternalData, GetPeopleInternalResponses, GetPersonImageData, GetPersonImageErrors, GetPersonImageResponses, GetPipelinesFindData, GetPipelinesFindErrors, GetPipelinesFindResponses, GetRecommendationData, GetRecommendationErrors, GetRecommendationResponses, GetRecommendationsFindData, GetRecommendationsFindErrors, GetRecommendationsFindResponses, GetRecsysAssigneesData, GetRecsysAssigneesResponses, GetRecsysCandidateOpportunitiesData, GetRecsysCandidateOpportunitiesErrors, GetRecsysCandidateOpportunitiesResponses, GetRecsysOpportunityRationaleData, GetRecsysOpportunityRationaleErrors, GetRecsysOpportunityRationaleResponses, GetRecsysPipelineRecommendationsData, GetRecsysPipelineRecommendationsErrors, GetRecsysPipelineRecommendationsResponses, GetReindexStatusData, GetReindexStatusErrors, GetReindexStatusResponses, GetSubmissionData, GetSubmissionErrors, GetSubmissionResponses, GetTailoredHighlightsStatusData, GetTailoredHighlightsStatusErrors, GetTailoredHighlightsStatusResponses, GetTaskData, GetTaskErrors, GetTaskModuleData, GetTaskModuleErrors, GetTaskModuleResponses, GetTaskResponses, GetTeamCandidateActivityData, GetTeamCandidateActivityErrors, GetTeamCandidateActivityResponses, GetTeamCandidateData, GetTeamCandidateErrors, GetTeamCandidateRecommendationsData, GetTeamCandidateRecommendationsErrors, GetTeamCandidateRecommendationsResponses, GetTeamCandidateResponses, GetTeamContactCommentsData, GetTeamContactCommentsErrors, GetTeamContactCommentsResponses, GetTeamData, GetTeamErrors, GetTeamIntroInsightData, GetTeamIntroInsightErrors, GetTeamIntroInsightResponses, GetTeamMembersData, GetTeamMembersErrors, GetTeamMembersResponses, GetTeamPipelineCandidatesData, GetTeamPipelineCandidatesErrors, GetTeamPipelineCandidatesOffLimitsData, GetTeamPipelineCandidatesOffLimitsErrors, GetTeamPipelineCandidatesOffLimitsResponses, GetTeamPipelineCandidatesResponses, GetTeamPipelineData, GetTeamPipelineErrors, GetTeamPipelineRecommendationBioData, GetTeamPipelineRecommendationBioErrors, GetTeamPipelineRecommendationBioResponses, GetTeamPipelineRecommendationChecksSharedData, GetTeamPipelineRecommendationChecksSharedErrors, GetTeamPipelineRecommendationChecksSharedResponses, GetTeamPipelineRecommendationData, GetTeamPipelineRecommendationErrors, GetTeamPipelineRecommendationInternalCommentsData, GetTeamPipelineRecommendationInternalCommentsErrors, GetTeamPipelineRecommendationInternalCommentsResponses, GetTeamPipelineRecommendationIntroductionData, GetTeamPipelineRecommendationIntroductionErrors, GetTeamPipelineRecommendationIntroductionResponses, GetTeamPipelineRecommendationResponses, GetTeamPipelineResponses, GetTeamPipelinesData, GetTeamPipelinesErrors, GetTeamPipelinesResponses, GetTeamRecommendationBioData, GetTeamRecommendationBioErrors, GetTeamRecommendationBioResponses, GetTeamRecommendationIntroductionData, GetTeamRecommendationIntroductionErrors, GetTeamRecommendationIntroductionResponses, GetTeamResponses, GetTeamsFindData, GetTeamsFindErrors, GetTeamsFindResponses, GetTeamTrendingData, GetTeamTrendingErrors, GetTeamTrendingRecommendationActivityData, GetTeamTrendingRecommendationActivityErrors, GetTeamTrendingRecommendationActivityResponses, GetTeamTrendingRecommendationCommentsData, GetTeamTrendingRecommendationCommentsErrors, GetTeamTrendingRecommendationCommentsResponses, GetTeamTrendingRecommendationData, GetTeamTrendingRecommendationErrors, GetTeamTrendingRecommendationResponses, GetTeamTrendingResponses, GetTrendingMessageKeysData, GetTrendingMessageKeysResponses, GetTrendingMessagesData, GetTrendingMessagesErrors, GetTrendingMessagesResponses, GetUserEventsData, GetUserEventsErrors, GetUserEventsResponses, GetUserV2Data, GetUserV2Errors, GetUserV2Responses, GetV1RecommendationData, GetV1RecommendationErrors, GetV1RecommendationPreviewData, GetV1RecommendationPreviewErrors, GetV1RecommendationPreviewResponses, GetV1RecommendationResponses, GetVerifyEmailOneTimeCodeData, GetVerifyEmailOneTimeCodeErrors, GetVerifyEmailOneTimeCodeResponses, HealthCheckData, HealthCheckResponses, ImportCandidateCompanyMetadataData, ImportCandidateCompanyMetadataErrors, ImportCandidateCompanyMetadataResponses, LinkMarketSearchData, LinkMarketSearchErrors, LinkMarketSearchResponses, ListCandidateCompanyMetadataData, ListCandidateCompanyMetadataErrors, ListCandidateCompanyMetadataResponses, ListCompanyContactTagsData, ListCompanyContactTagsErrors, ListCompanyContactTagsResponses, ListEmailTemplateDefaultsData, ListEmailTemplateDefaultsErrors, ListEmailTemplateDefaultsResponses, ListEmailTemplatesData, ListEmailTemplatesErrors, ListEmailTemplatesResponses, ListEmailTypesData, ListEmailTypesResponses, ListEventEmailTemplatesData, ListEventEmailTemplatesErrors, ListEventEmailTemplatesResponses, ListExecutiveClientEventsData, ListExecutiveClientEventsErrors, ListExecutiveClientEventsResponses, ListPersonContactTagsData, ListPersonContactTagsErrors, ListPersonContactTagsResponses, PatchAliasToEsIndexData, PatchAliasToEsIndexErrors, PatchAliasToEsIndexResponses, PatchCandidateData, PatchCandidateErrors, PatchCandidateGoalsData, PatchCandidateGoalsErrors, PatchCandidateGoalsResponses, PatchCandidateGoalV2Data, PatchCandidateGoalV2Errors, PatchCandidateGoalV2Responses, PatchCandidateResponses, PatchCandidateV2Data, PatchCandidateV2Errors, PatchCandidateV2Responses, PatchCompanyData, PatchCompanyErrors, PatchCompanyResponses, PatchEventData, PatchEventErrors, PatchEventGuestData, PatchEventGuestErrors, PatchEventGuestResponses, PatchEventGuestsData, PatchEventGuestsErrors, PatchEventGuestsResponses, PatchEventResponses, PatchEventRsvpData, PatchEventRsvpErrors, PatchEventRsvpResponses, PatchExecutiveClientSettingsData, PatchExecutiveClientSettingsErrors, PatchExecutiveClientSettingsResponses, PatchExecutiveSettingsData, PatchExecutiveSettingsErrors, PatchExecutiveSettingsResponses, PatchPeopleCurrentData, PatchPeopleCurrentErrors, PatchPeopleCurrentResponses, PatchPersonContactTagDefinitionData, PatchPersonContactTagDefinitionErrors, PatchPersonContactTagDefinitionResponses, PatchPersonData, PatchPersonEmailNotificationsData, PatchPersonEmailNotificationsErrors, PatchPersonEmailNotificationsResponses, PatchPersonErrors, PatchPersonResponses, PatchTeamData, PatchTeamErrors, PatchTeamPipelineData, PatchTeamPipelineErrors, PatchTeamPipelineResponses, PatchTeamResponses, PatchUserData, PatchUserErrors, PatchUserResponses, PatchUserRoleRemoveCompanyData, PatchUserRoleRemoveCompanyErrors, PatchUserRoleRemoveCompanyResponses, PostActivateExecutiveData, PostActivateExecutiveErrors, PostActivateExecutiveResponses, PostAdminExecutiveClientActivityData, PostAdminExecutiveClientActivityErrors, PostAdminExecutiveClientActivityResponses, PostAdminPeersCandidatesFilterData, PostAdminPeersCandidatesFilterErrors, PostAdminPeersCandidatesFilterResponses, PostAdminPeersFilterData, PostAdminPeersFilterErrors, PostAdminPeersFilterResponses, PostAdminPeersMatchesData, PostAdminPeersMatchesErrors, PostAdminPeersMatchesResponses, PostAdminPeersPublishData, PostAdminPeersPublishErrors, PostAdminPeersPublishResponses, PostAdminPipelineCandidatesFilterData, PostAdminPipelineCandidatesFilterErrors, PostAdminPipelineCandidatesFilterResponses, PostAutotagPreviewData, PostAutotagPreviewErrors, PostAutotagPreviewResponses, PostBulkActivateExecutivesData, PostBulkActivateExecutivesErrors, PostBulkActivateExecutivesResponses, PostCandidateActivityLogData, PostCandidateActivityLogErrors, PostCandidateActivityLogResponses, PostCandidateCompareAboutData, PostCandidateCompareAboutErrors, PostCandidateCompareAboutResponses, PostCandidateCompareGoalsData, PostCandidateCompareGoalsErrors, PostCandidateCompareGoalsResponses, PostCandidateCompareP2pData, PostCandidateCompareP2pErrors, PostCandidateCompareP2pResponses, PostCandidateFavoriteData, PostCandidateFavoriteErrors, PostCandidateFavoriteResponses, PostCandidateFeedbackFilterData, PostCandidateFeedbackFilterErrors, PostCandidateFeedbackFilterResponses, PostCandidateFeedbackV2Data, PostCandidateFeedbackV2Errors, PostCandidateFeedbackV2Responses, PostCandidateGoalActivityData, PostCandidateGoalActivityErrors, PostCandidateGoalActivityResponses, PostCandidateGoalTasksData, PostCandidateGoalTasksErrors, PostCandidateGoalTasksResponses, PostCandidateHighlightsData, PostCandidateHighlightsErrors, PostCandidateHighlightsResponses, PostCandidateHighlightsV2Data, PostCandidateHighlightsV2Errors, PostCandidateHighlightsV2Responses, PostCandidateIntroTemplatesData, PostCandidateIntroTemplatesErrors, PostCandidateIntroTemplatesResponses, PostCandidateMergeData, PostCandidateMergeErrors, PostCandidateMergeResponses, PostCandidateRecommendationsFilterData, PostCandidateRecommendationsFilterErrors, PostCandidateRecommendationsFilterResponses, PostCandidatesData, PostCandidatesErrors, PostCandidatesExportFailedData, PostCandidatesExportFailedErrors, PostCandidatesExportFailedResponses, PostCandidatesFilterData, PostCandidatesFilterErrors, PostCandidatesFilterResponses, PostCandidatesGoalsV2Data, PostCandidatesGoalsV2Errors, PostCandidatesGoalsV2Responses, PostCandidateShowOnboardingSectionData, PostCandidateShowOnboardingSectionErrors, PostCandidateShowOnboardingSectionResponses, PostCandidatesImportFromCsvData, PostCandidatesImportFromCsvErrors, PostCandidatesImportFromCsvResponses, PostCandidatesPerformanceFilterData, PostCandidatesPerformanceFilterErrors, PostCandidatesPerformanceFilterResponses, PostCandidatesPerformanceInRedData, PostCandidatesPerformanceInRedErrors, PostCandidatesPerformanceInRedResponses, PostCandidatesResponses, PostCandidatesTrendingFilterData, PostCandidatesTrendingFilterErrors, PostCandidatesTrendingFilterResponses, PostCandidateTasksFilterData, PostCandidateTasksFilterErrors, PostCandidateTasksFilterResponses, PostClerkWebhookData, PostClerkWebhookResponses, PostCompaniesData, PostCompaniesErrors, PostCompaniesResponses, PostCompaniesSearchV2Data, PostCompaniesSearchV2Errors, PostCompaniesSearchV2Responses, PostCompanyPeopleFilterData, PostCompanyPeopleFilterErrors, PostCompanyPeopleFilterResponses, PostCompanyTeamsData, PostCompanyTeamsErrors, PostCompanyTeamsResponses, PostContactListsData, PostContactListsErrors, PostContactListsResponses, PostEmailResponseFeedbackData, PostEmailResponseFeedbackErrors, PostEmailResponseFeedbackResponses, PostEsReindexData, PostEsReindexErrors, PostEsReindexResponses, PostEventAnnouncementSendData, PostEventAnnouncementSendErrors, PostEventAnnouncementSendResponses, PostEventData, PostEventErrors, PostEventGuestsData, PostEventGuestsErrors, PostEventGuestsResponses, PostEventGuestsSelectionData, PostEventGuestsSelectionErrors, PostEventGuestsSelectionResponses, PostEventInvitePreviewData, PostEventInvitePreviewErrors, PostEventInvitePreviewResponses, PostEventInviteSendData, PostEventInviteSendErrors, PostEventInviteSendResponses, PostEventLandingImageData, PostEventLandingImageErrors, PostEventLandingImageResponses, PostEventReminderPreviewData, PostEventReminderPreviewErrors, PostEventReminderPreviewResponses, PostEventReminderSendData, PostEventReminderSendErrors, PostEventReminderSendResponses, PostEventResponses, PostEventRsvpPreviewData, PostEventRsvpPreviewErrors, PostEventRsvpPreviewResponses, PostExecutiveClientActivityData, PostExecutiveClientActivityErrors, PostExecutiveClientActivityResponses, PostExecutiveClientContactPipelinesData, PostExecutiveClientContactPipelinesErrors, PostExecutiveClientContactPipelinesResponses, PostExecutiveClientPeopleSearchData, PostExecutiveClientPeopleSearchErrors, PostExecutiveClientPeopleSearchResponses, PostFilesImageData, PostFilesImageErrors, PostFilesImageResponses, PostFilesLinkedinResumeData, PostFilesLinkedinResumeErrors, PostFilesLinkedinResumeResponses, PosthogJsData, PosthogJsErrors, PosthogJsResponses, PosthogProxyData, PosthogProxyErrors, PosthogProxyResponses, PostHomeCandidatesData, PostHomeCandidatesResponses, PostHomepageCandidatesData, PostHomepageCandidatesResponses, PostHomeTeamCandidateFeedbackData, PostHomeTeamCandidateFeedbackErrors, PostHomeTeamCandidateFeedbackResponses, PostHomeTeamViewsData, PostHomeTeamViewsErrors, PostHomeTeamViewsResponses, PostIdentityData, PostIdentityErrors, PostIdentityLoginData, PostIdentityLoginErrors, PostIdentityLoginResponses, PostIdentityMergeData, PostIdentityMergeErrors, PostIdentityMergeResponses, PostIdentityPersonData, PostIdentityPersonErrors, PostIdentityPersonResponses, PostIdentityResponses, PostLinkedinPreviewData, PostLinkedinPreviewErrors, PostLinkedinPreviewResponses, PostLinkedinSyncCandidateData, PostLinkedinSyncCandidateErrors, PostLinkedinSyncCandidateResponses, PostPeerCommentData, PostPeerCommentErrors, PostPeerCommentResponses, PostPeopleV2Data, PostPeopleV2Errors, PostPeopleV2Responses, PostPersonClerkUserData, PostPersonClerkUserErrors, PostPersonClerkUserResponses, PostPersonContactFavoriteData, PostPersonContactFavoriteErrors, PostPersonContactFavoriteResponses, PostPersonImageData, PostPersonImageErrors, PostPersonImageResponses, PostPipelineCandidatesData, PostPipelineCandidatesErrors, PostPipelineCandidatesResponses, PostPipelinesFilterData, PostPipelinesFilterErrors, PostPipelinesFilterResponses, PostPipelineTransferToTeamData, PostPipelineTransferToTeamErrors, PostPipelineTransferToTeamResponses, PostPotentialGuestsData, PostPotentialGuestsErrors, PostPotentialGuestsResponses, PostPotentialGuestsSelectionData, PostPotentialGuestsSelectionErrors, PostPotentialGuestsSelectionResponses, PostRecommendationOffLimitsData, PostRecommendationOffLimitsErrors, PostRecommendationOffLimitsResponses, PostRecsysCandidateContextData, PostRecsysCandidateContextErrors, PostRecsysCandidateContextResponses, PostRecsysOpportunityBadMatchData, PostRecsysOpportunityBadMatchErrors, PostRecsysOpportunityBadMatchResponses, PostRecsysOpportunityReviewedData, PostRecsysOpportunityReviewedErrors, PostRecsysOpportunityReviewedResponses, PostRecsysRecommendationFeedbackData, PostRecsysRecommendationFeedbackErrors, PostRecsysRecommendationFeedbackResponses, PostRecsysRecommendationsData, PostRecsysRecommendationsErrors, PostRecsysRecommendationsResponses, PostSendExecutiveInvitationData, PostSendExecutiveInvitationErrors, PostSendExecutiveInvitationResponses, PostShareRecommendationsData, PostShareRecommendationsErrors, PostShareRecommendationsResponses, PostSubmissionCancelRecommendationsData, PostSubmissionCancelRecommendationsErrors, PostSubmissionCancelRecommendationsResponses, PostSubmissionEmailPreviewData, PostSubmissionEmailPreviewErrors, PostSubmissionEmailPreviewResponses, PostSubmissionFilterData, PostSubmissionFilterErrors, PostSubmissionFilterResponses, PostSubmissionsData, PostSubmissionsErrors, PostSubmissionsFilterData, PostSubmissionsFilterErrors, PostSubmissionsFilterResponses, PostSubmissionsResponses, PostTailoredHighlightsData, PostTailoredHighlightsErrors, PostTailoredHighlightsResponses, PostTaskModulesData, PostTaskModulesErrors, PostTaskModulesResponses, PostTasksData, PostTasksErrors, PostTasksFilterData, PostTasksFilterErrors, PostTasksFilterResponses, PostTasksResponses, PostTeamCandidateFavoriteData, PostTeamCandidateFavoriteErrors, PostTeamCandidateFavoriteResponses, PostTeamCandidatePipelinesData, PostTeamCandidatePipelinesErrors, PostTeamCandidatePipelinesResponses, PostTeamCandidatesFilterV3Data, PostTeamCandidatesFilterV3Errors, PostTeamCandidatesFilterV3Responses, PostTeamCandidateStatusData, PostTeamCandidateStatusErrors, PostTeamCandidateStatusResponses, PostTeamCandidateViewsData, PostTeamCandidateViewsErrors, PostTeamCandidateViewsResponses, PostTeamContactCommentData, PostTeamContactCommentErrors, PostTeamContactCommentResponses, PostTeamMembersBulkV2Data, PostTeamMembersBulkV2Errors, PostTeamMembersBulkV2Responses, PostTeamMembersV2Data, PostTeamMembersV2Errors, PostTeamMembersV2Responses, PostTeamMergeData, PostTeamMergeErrors, PostTeamMergeResponses, PostTeamPipelineRecommendationCommentsData, PostTeamPipelineRecommendationCommentsErrors, PostTeamPipelineRecommendationCommentsResponses, PostTeamPipelineRecommendationDislikeData, PostTeamPipelineRecommendationDislikeErrors, PostTeamPipelineRecommendationDislikeResponses, PostTeamPipelineRecommendationFavoriteData, PostTeamPipelineRecommendationFavoriteErrors, PostTeamPipelineRecommendationFavoriteResponses, PostTeamPipelineRecommendationInternalCommentsData, PostTeamPipelineRecommendationInternalCommentsErrors, PostTeamPipelineRecommendationInternalCommentsResponses, PostTeamPipelineRecommendationIntroductionData, PostTeamPipelineRecommendationIntroductionErrors, PostTeamPipelineRecommendationIntroductionResponses, PostTeamPipelineRecommendationViewsData, PostTeamPipelineRecommendationViewsErrors, PostTeamPipelineRecommendationViewsResponses, PostTeamPipelinesData, PostTeamPipelinesErrors, PostTeamPipelinesResponses, PostTeamPipelineSubmissionData, PostTeamPipelineSubmissionErrors, PostTeamPipelineSubmissionResponses, PostTeamPipelineViewsData, PostTeamPipelineViewsErrors, PostTeamPipelineViewsResponses, PostTeamRecommendationIntroductionData, PostTeamRecommendationIntroductionErrors, PostTeamRecommendationIntroductionResponses, PostTeamsData, PostTeamsErrors, PostTeamsFilterData, PostTeamsFilterErrors, PostTeamsFilterResponses, PostTeamsResponses, PostTeamsSuggestedData, PostTeamsSuggestedErrors, PostTeamsSuggestedResponses, PostTeamsV2Data, PostTeamsV2Errors, PostTeamsV2Responses, PostTeamTeamsData, PostTeamTeamsErrors, PostTeamTeamsResponses, PostTeamTransferToCompanyData, PostTeamTransferToCompanyErrors, PostTeamTransferToCompanyResponses, PostTeamTrendingRecommendationCommentsData, PostTeamTrendingRecommendationCommentsErrors, PostTeamTrendingRecommendationCommentsResponses, PostTeamTrendingRecommendationDislikeData, PostTeamTrendingRecommendationDislikeErrors, PostTeamTrendingRecommendationDislikeResponses, PostTeamTrendingRecommendationFavoriteData, PostTeamTrendingRecommendationFavoriteErrors, PostTeamTrendingRecommendationFavoriteResponses, PostTeamTrendingRecommendationViewsData, PostTeamTrendingRecommendationViewsErrors, PostTeamTrendingRecommendationViewsResponses, PostTokenData, PostTokenErrors, PostTokenResponses, PostTrendingScheduleData, PostTrendingScheduleErrors, PostTrendingScheduleResponses, PostUserCompanyData, PostUserCompanyErrors, PostUserCompanyResponses, PostUsersBulkDeleteV2Data, PostUsersBulkDeleteV2Errors, PostUsersBulkDeleteV2Responses, PostUsersSearchV2Data, PostUsersSearchV2Errors, PostUsersSearchV2Responses, PostUserTeamData, PostUserTeamErrors, PostUserTeamResponses, PostUtilsMailSendData, PostUtilsMailSendErrors, PostUtilsMailSendResponses, PostWebhooksEsEventsData, PostWebhooksEsEventsErrors, PostWebhooksEsEventsResponses, PreviewEventEmailData, PreviewEventEmailErrors, PreviewEventEmailResponses, PutCandidateCommentaryData, PutCandidateCommentaryErrors, PutCandidateCommentaryResponses, PutCandidateData, PutCandidateErrors, PutCandidateFeedbackData, PutCandidateFeedbackErrors, PutCandidateFeedbackResponses, PutCandidateOffLimitsCompaniesData, PutCandidateOffLimitsCompaniesErrors, PutCandidateOffLimitsCompaniesResponses, PutCandidateOffLimitsIdentitiesData, PutCandidateOffLimitsIdentitiesErrors, PutCandidateOffLimitsIdentitiesResponses, PutCandidatePathwayActivityTargetsData, PutCandidatePathwayActivityTargetsErrors, PutCandidatePathwayActivityTargetsResponses, PutCandidateReferrerData, PutCandidateReferrerErrors, PutCandidateReferrerResponses, PutCandidateResponses, PutCommentData, PutCommentErrors, PutCommentResponses, PutCompaniesData, PutCompaniesErrors, PutCompaniesResponses, PutEmailTemplateDefaultData, PutEmailTemplateDefaultErrors, PutEmailTemplateDefaultResponses, PutEvaluationHistoryIntroductionData, PutEvaluationHistoryIntroductionErrors, PutEvaluationHistoryIntroductionResponses, PutHighlightData, PutHighlightErrors, PutHighlightResponses, PutIdentityCandidateData, PutIdentityCandidateErrors, PutIdentityCandidateResponses, PutInternalCommentData, PutInternalCommentErrors, PutInternalCommentResponses, PutIntroductionTemplateData, PutIntroductionTemplateErrors, PutIntroductionTemplateResponses, PutMultipleRecommendationDraftsData, PutMultipleRecommendationDraftsErrors, PutMultipleRecommendationDraftsResponses, PutPathwayActivityDefaultsData, PutPathwayActivityDefaultsErrors, PutPathwayActivityDefaultsResponses, PutPeerAssigneesData, PutPeerAssigneesErrors, PutPeerAssigneesResponses, PutPeerIntroductionData, PutPeerIntroductionErrors, PutPeerIntroductionResponses, PutPeerStatusData, PutPeerStatusErrors, PutPeerStatusResponses, PutPeopleCurrentPasswordData, PutPeopleCurrentPasswordErrors, PutPeopleCurrentPasswordResponses, PutPersonPasswordData, PutPersonPasswordErrors, PutPersonPasswordResponses, PutRecommendationCommentaryData, PutRecommendationCommentaryErrors, PutRecommendationCommentaryResponses, PutRecommendationStatusData, PutRecommendationStatusErrors, PutRecommendationStatusResponses, PutRecommendationStatusV2Data, PutRecommendationStatusV2Errors, PutRecommendationStatusV2Responses, PutSubmissionData, PutSubmissionErrors, PutSubmissionResponses, PutSubmissionStatusData, PutSubmissionStatusErrors, PutSubmissionStatusResponses, PutTaskData, PutTaskErrors, PutTaskModuleData, PutTaskModuleErrors, PutTaskModuleResponses, PutTaskModuleStatusData, PutTaskModuleStatusErrors, PutTaskModuleStatusResponses, PutTaskResponses, PutTaskStatusData, PutTaskStatusErrors, PutTaskStatusResponses, PutTeamCandidateStatusData, PutTeamCandidateStatusErrors, PutTeamCandidateStatusResponses, PutTeamContactCommentData, PutTeamContactCommentErrors, PutTeamContactCommentResponses, PutTeamData, PutTeamErrors, PutTeamPipelineData, PutTeamPipelineErrors, PutTeamPipelineRecommendationIntroEmailTypeData, PutTeamPipelineRecommendationIntroEmailTypeErrors, PutTeamPipelineRecommendationIntroEmailTypeResponses, PutTeamPipelineResponses, PutTeamResponses, RemoveCompanyContactTagData, RemoveCompanyContactTagErrors, RemoveCompanyContactTagResponses, RemovePersonContactTagData, RemovePersonContactTagErrors, RemovePersonContactTagResponses, ResolvePersonCandidateByEmailData, ResolvePersonCandidateByEmailErrors, ResolvePersonCandidateByEmailResponses, RevertEvaluationHistoryData, RevertEvaluationHistoryErrors, RevertEvaluationHistoryResponses, SearchMarketSearchesData, SearchMarketSearchesErrors, SearchMarketSearchesResponses, UpdateEmailTemplateData, UpdateEmailTemplateErrors, UpdateEmailTemplateResponses, UpdateEventEmailTemplateData, UpdateEventEmailTemplateErrors, UpdateEventEmailTemplateResponses, UpdateExecutiveClientEventRsvpData, UpdateExecutiveClientEventRsvpErrors, UpdateExecutiveClientEventRsvpResponses, UpdateMarketSearchData, UpdateMarketSearchErrors, UpdateMarketSearchResponses, UpdatePersonMetadataV2Data, UpdatePersonMetadataV2Errors, UpdatePersonMetadataV2Responses, UpsertCandidateCompanyMetadataData, UpsertCandidateCompanyMetadataErrors, UpsertCandidateCompanyMetadataResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * App Version
 *
 * GET /
 */
export const appVersion = <ThrowOnError extends boolean = false>(options?: Options<AppVersionData, ThrowOnError>): RequestResult<AppVersionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AppVersionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/',
    ...options
});

/**
 * Health Check
 *
 * GET /health
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>): RequestResult<HealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthCheckResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/health',
    ...options
});

/**
 * Get Verify Email One Time Code
 *
 * GET /api/email-response
 */
export const getVerifyEmailOneTimeCode = <ThrowOnError extends boolean = false>(options: Options<GetVerifyEmailOneTimeCodeData, ThrowOnError>): RequestResult<GetVerifyEmailOneTimeCodeResponses, GetVerifyEmailOneTimeCodeErrors, ThrowOnError> => (options.client ?? client).get<GetVerifyEmailOneTimeCodeResponses, GetVerifyEmailOneTimeCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/email-response',
    ...options
});

/**
 * Post Email Response Feedback
 *
 * POST /api/email-response/feedback
 *
 * Check the email code and find appropriate recommendation for the user associated with the email
 * code. Mark the introduction as not facilitated and add evaluation history event.
 */
export const postEmailResponseFeedback = <ThrowOnError extends boolean = false>(options: Options<PostEmailResponseFeedbackData, ThrowOnError>): RequestResult<PostEmailResponseFeedbackResponses, PostEmailResponseFeedbackErrors, ThrowOnError> => (options.client ?? client).post<PostEmailResponseFeedbackResponses, PostEmailResponseFeedbackErrors, ThrowOnError>({
    responseType: 'json',
    url: '/email-response/feedback',
    ...options
});

/**
 * Get Countries
 *
 * GET /api/v1/countries
 */
export const getCountries = <ThrowOnError extends boolean = false>(options?: Options<GetCountriesData, ThrowOnError>): RequestResult<GetCountriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCountriesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/countries',
    ...options
});

/**
 * Post Token
 *
 * POST /api/v1/token
 */
export const postToken = <ThrowOnError extends boolean = false>(options: Options<PostTokenData, ThrowOnError>): RequestResult<PostTokenResponses, PostTokenErrors, ThrowOnError> => (options.client ?? client).post<PostTokenResponses, PostTokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    url: '/api/v1/token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Posthog Proxy
 *
 * POST /api/v1/ingest/{path}/
 *
 * This is a proxy endpoint for PostHog event ingestion, to avoid browser blocking
 * of product metrics tracking.
 *
 * It's labeled 'ingest' instead of 'posthog' or 'analytics' to avoid term-based blocking.
 */
export const posthogProxy = <ThrowOnError extends boolean = false>(options: Options<PosthogProxyData, ThrowOnError>): RequestResult<PosthogProxyResponses, PosthogProxyErrors, ThrowOnError> => (options.client ?? client).post<PosthogProxyResponses, PosthogProxyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ingest/{posthog_path}/',
    ...options
});

/**
 * Posthog Js
 *
 * GET /api/v1/ingest/status/{filename:path}
 *
 * This endpoint, an extension of the one above, serves static files from PostHog
 */
export const posthogJs = <ThrowOnError extends boolean = false>(options: Options<PosthogJsData, ThrowOnError>): RequestResult<PosthogJsResponses, PosthogJsErrors, ThrowOnError> => (options.client ?? client).get<PosthogJsResponses, PosthogJsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/ingest/static/{filename}',
    ...options
});

/**
 * Post Candidates Filter
 *
 * POST /api/v1/candidates/filter
 */
export const postCandidatesFilter = <ThrowOnError extends boolean = false>(options: Options<PostCandidatesFilterData, ThrowOnError>): RequestResult<PostCandidatesFilterResponses, PostCandidatesFilterErrors, ThrowOnError> => (options.client ?? client).post<PostCandidatesFilterResponses, PostCandidatesFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidates Find
 *
 * GET /api/v1/candidates/find
 */
export const getCandidatesFind = <ThrowOnError extends boolean = false>(options?: Options<GetCandidatesFindData, ThrowOnError>): RequestResult<GetCandidatesFindResponses, GetCandidatesFindErrors, ThrowOnError> => (options?.client ?? client).get<GetCandidatesFindResponses, GetCandidatesFindErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/find',
    ...options
});

/**
 * Post Candidates Performance In Red
 *
 * POST /api/v1/candidates/performance/in-red
 */
export const postCandidatesPerformanceInRed = <ThrowOnError extends boolean = false>(options: Options<PostCandidatesPerformanceInRedData, ThrowOnError>): RequestResult<PostCandidatesPerformanceInRedResponses, PostCandidatesPerformanceInRedErrors, ThrowOnError> => (options.client ?? client).post<PostCandidatesPerformanceInRedResponses, PostCandidatesPerformanceInRedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/performance/in-red',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidates Performance Filter
 *
 * POST /api/v1/candidates/performance/filter
 */
export const postCandidatesPerformanceFilter = <ThrowOnError extends boolean = false>(options: Options<PostCandidatesPerformanceFilterData, ThrowOnError>): RequestResult<PostCandidatesPerformanceFilterResponses, PostCandidatesPerformanceFilterErrors, ThrowOnError> => (options.client ?? client).post<PostCandidatesPerformanceFilterResponses, PostCandidatesPerformanceFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/performance/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate Commentary
 *
 * GET /api/v1/candidates/{candidate_uuid}/commentary
 */
export const getCandidateCommentary = <ThrowOnError extends boolean = false>(options: Options<GetCandidateCommentaryData, ThrowOnError>): RequestResult<GetCandidateCommentaryResponses, GetCandidateCommentaryErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateCommentaryResponses, GetCandidateCommentaryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/commentary',
    ...options
});

/**
 * Put Candidate Commentary
 *
 * PUT /api/v1/candidates/{candidate_uuid}/commentary
 *
 * @deprecated
 */
export const putCandidateCommentary = <ThrowOnError extends boolean = false>(options: Options<PutCandidateCommentaryData, ThrowOnError>): RequestResult<PutCandidateCommentaryResponses, PutCandidateCommentaryErrors, ThrowOnError> => (options.client ?? client).put<PutCandidateCommentaryResponses, PutCandidateCommentaryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/commentary',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Highlights
 *
 * POST /api/v1/candidates/{candidate_uuid}/highlights
 */
export const postCandidateHighlights = <ThrowOnError extends boolean = false>(options: Options<PostCandidateHighlightsData, ThrowOnError>): RequestResult<PostCandidateHighlightsResponses, PostCandidateHighlightsErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateHighlightsResponses, PostCandidateHighlightsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/highlights',
    ...options
});

/**
 * Get Candidate Image
 */
export const getCandidateImage = <ThrowOnError extends boolean = false>(options: Options<GetCandidateImageData, ThrowOnError>): RequestResult<GetCandidateImageResponses, GetCandidateImageErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateImageResponses, GetCandidateImageErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/image',
    ...options
});

/**
 * Get Candidate Introductions Team History
 *
 * GET /candidates/{candidate_uuid}/introductions/{team_slug}/history
 */
export const getCandidateIntroductionsTeamHistory = <ThrowOnError extends boolean = false>(options: Options<GetCandidateIntroductionsTeamHistoryData, ThrowOnError>): RequestResult<GetCandidateIntroductionsTeamHistoryResponses, GetCandidateIntroductionsTeamHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateIntroductionsTeamHistoryResponses, GetCandidateIntroductionsTeamHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/introductions/{team_slug}/history',
    ...options
});

/**
 * Get Candidate Introduction Templates
 *
 * GET /candidates/{candidate_uuid}/introduction_templates
 */
export const getCandidateIntroductionTemplates = <ThrowOnError extends boolean = false>(options: Options<GetCandidateIntroductionTemplatesData, ThrowOnError>): RequestResult<GetCandidateIntroductionTemplatesResponses, GetCandidateIntroductionTemplatesErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateIntroductionTemplatesResponses, GetCandidateIntroductionTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/introduction_templates',
    ...options
});

/**
 * Get Candidate Off Limits Companies
 *
 * GET /candidates/{candidate_uuid}/off_limits/companies
 *
 * The companies this candidate's human must not be shown to.
 */
export const getCandidateOffLimitsCompanies = <ThrowOnError extends boolean = false>(options: Options<GetCandidateOffLimitsCompaniesData, ThrowOnError>): RequestResult<GetCandidateOffLimitsCompaniesResponses, GetCandidateOffLimitsCompaniesErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateOffLimitsCompaniesResponses, GetCandidateOffLimitsCompaniesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/off_limits/companies',
    ...options
});

/**
 * Put Candidate Off Limits Companies
 *
 * PUT /candidates/{candidate_uuid}/off_limits/companies
 *
 * Replaces the whole list. The same company listed twice keeps its first
 * reason.
 */
export const putCandidateOffLimitsCompanies = <ThrowOnError extends boolean = false>(options: Options<PutCandidateOffLimitsCompaniesData, ThrowOnError>): RequestResult<PutCandidateOffLimitsCompaniesResponses, PutCandidateOffLimitsCompaniesErrors, ThrowOnError> => (options.client ?? client).put<PutCandidateOffLimitsCompaniesResponses, PutCandidateOffLimitsCompaniesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/off_limits/companies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate Off Limits Identities
 *
 * GET /candidates/{candidate_uuid}/off_limits/identities
 *
 * The humans this candidate's human is off-limits to.
 */
export const getCandidateOffLimitsIdentities = <ThrowOnError extends boolean = false>(options: Options<GetCandidateOffLimitsIdentitiesData, ThrowOnError>): RequestResult<GetCandidateOffLimitsIdentitiesResponses, GetCandidateOffLimitsIdentitiesErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateOffLimitsIdentitiesResponses, GetCandidateOffLimitsIdentitiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/off_limits/identities',
    ...options
});

/**
 * Put Candidate Off Limits Identities
 *
 * PUT /candidates/{candidate_uuid}/off_limits/identities
 *
 * Replaces the whole list. The same identity listed twice keeps its first
 * reason. Unknown identities are a 404.
 */
export const putCandidateOffLimitsIdentities = <ThrowOnError extends boolean = false>(options: Options<PutCandidateOffLimitsIdentitiesData, ThrowOnError>): RequestResult<PutCandidateOffLimitsIdentitiesResponses, PutCandidateOffLimitsIdentitiesErrors, ThrowOnError> => (options.client ?? client).put<PutCandidateOffLimitsIdentitiesResponses, PutCandidateOffLimitsIdentitiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/off_limits/identities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate Recommendations
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations
 */
export const getCandidateRecommendations = <ThrowOnError extends boolean = false>(options: Options<GetCandidateRecommendationsData, ThrowOnError>): RequestResult<GetCandidateRecommendationsResponses, GetCandidateRecommendationsErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateRecommendationsResponses, GetCandidateRecommendationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/recommendations',
    ...options
});

/**
 * Get Candidate Recommendations Compare Background
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations/compare/background?peer_uuid={peer_uuid}
 */
export const getCandidateRecommendationsCompareBackground = <ThrowOnError extends boolean = false>(options: Options<GetCandidateRecommendationsCompareBackgroundData, ThrowOnError>): RequestResult<GetCandidateRecommendationsCompareBackgroundResponses, GetCandidateRecommendationsCompareBackgroundErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateRecommendationsCompareBackgroundResponses, GetCandidateRecommendationsCompareBackgroundErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/recommendations/compare/background',
    ...options
});

/**
 * Get Candidate Recommendations Compare Performance
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations/    compare/performance?peer={peer_uuid}
 */
export const getCandidateRecommendationsComparePerformance = <ThrowOnError extends boolean = false>(options: Options<GetCandidateRecommendationsComparePerformanceData, ThrowOnError>): RequestResult<GetCandidateRecommendationsComparePerformanceResponses, GetCandidateRecommendationsComparePerformanceErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateRecommendationsComparePerformanceResponses, GetCandidateRecommendationsComparePerformanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/recommendations/compare/performance',
    ...options
});

/**
 * Get Candidate Recommendations Compare Recommendations
 *
 * GET /api/v1/candidates/{candidate_uuid}/recommendations/    compare/recommendations?peer={peer_uuid}
 */
export const getCandidateRecommendationsCompareRecommendations = <ThrowOnError extends boolean = false>(options: Options<GetCandidateRecommendationsCompareRecommendationsData, ThrowOnError>): RequestResult<GetCandidateRecommendationsCompareRecommendationsResponses, GetCandidateRecommendationsCompareRecommendationsErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateRecommendationsCompareRecommendationsResponses, GetCandidateRecommendationsCompareRecommendationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/recommendations/compare/recommendations',
    ...options
});

/**
 * Get Candidate Recommendations Compare Pipelines
 */
export const getCandidateRecommendationsComparePipelines = <ThrowOnError extends boolean = false>(options: Options<GetCandidateRecommendationsComparePipelinesData, ThrowOnError>): RequestResult<GetCandidateRecommendationsComparePipelinesResponses, GetCandidateRecommendationsComparePipelinesErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateRecommendationsComparePipelinesResponses, GetCandidateRecommendationsComparePipelinesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/recommendations/compare/pipelines',
    ...options
});

/**
 * Get Candidate Resume
 *
 * GET /api/v1/candidates/{candidate_uuid}/resume
 */
export const getCandidateResume = <ThrowOnError extends boolean = false>(options: Options<GetCandidateResumeData, ThrowOnError>): RequestResult<GetCandidateResumeResponses, GetCandidateResumeErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateResumeResponses, GetCandidateResumeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}/resume',
    ...options
});

/**
 * Patch Candidate
 *
 * PATCH /api/v1/candidates/{candidate_uuid}
 *
 * @deprecated
 */
export const patchCandidate = <ThrowOnError extends boolean = false>(options: Options<PatchCandidateData, ThrowOnError>): RequestResult<PatchCandidateResponses, PatchCandidateErrors, ThrowOnError> => (options.client ?? client).patch<PatchCandidateResponses, PatchCandidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/{candidate_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Companies
 *
 * GET /api/v1/companies
 */
export const getCompanies = <ThrowOnError extends boolean = false>(options?: Options<GetCompaniesData, ThrowOnError>): RequestResult<GetCompaniesResponses, GetCompaniesErrors, ThrowOnError> => (options?.client ?? client).get<GetCompaniesResponses, GetCompaniesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies',
    ...options
});

/**
 * Post Companies
 *
 * POST /api/v1/companies
 *
 * Create a new company. Name, type, slug, and payment_status can be set.
 * Also reachable by the Contender Actions connector (service key + acting
 * user).
 */
export const postCompanies = <ThrowOnError extends boolean = false>(options: Options<PostCompaniesData, ThrowOnError>): RequestResult<PostCompaniesResponses, PostCompaniesErrors, ThrowOnError> => (options.client ?? client).post<PostCompaniesResponses, PostCompaniesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Companies
 *
 * PUT /api/v1/companies
 */
export const putCompanies = <ThrowOnError extends boolean = false>(options: Options<PutCompaniesData, ThrowOnError>): RequestResult<PutCompaniesResponses, PutCompaniesErrors, ThrowOnError> => (options.client ?? client).put<PutCompaniesResponses, PutCompaniesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company By Name
 *
 * GET /api/v1/companies/by-name?name={company_name}&case_insensitive={boolean}
 */
export const getCompanyByName = <ThrowOnError extends boolean = false>(options: Options<GetCompanyByNameData, ThrowOnError>): RequestResult<GetCompanyByNameResponses, GetCompanyByNameErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyByNameResponses, GetCompanyByNameErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/by-name',
    ...options
});

/**
 * Get Companies Find
 *
 * GET /api/v1/companies/find
 */
export const getCompaniesFind = <ThrowOnError extends boolean = false>(options?: Options<GetCompaniesFindData, ThrowOnError>): RequestResult<GetCompaniesFindResponses, GetCompaniesFindErrors, ThrowOnError> => (options?.client ?? client).get<GetCompaniesFindResponses, GetCompaniesFindErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/find',
    ...options
});

/**
 * Get Companies Sectors
 *
 * GET /api/v1/companies/sectors
 */
export const getCompaniesSectors = <ThrowOnError extends boolean = false>(options: Options<GetCompaniesSectorsData, ThrowOnError>): RequestResult<GetCompaniesSectorsResponses, GetCompaniesSectorsErrors, ThrowOnError> => (options.client ?? client).get<GetCompaniesSectorsResponses, GetCompaniesSectorsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/sectors',
    ...options
});

/**
 * Delete Company
 *
 * DELETE /api/v1/companies/{company_slug}
 */
export const deleteCompany = <ThrowOnError extends boolean = false>(options: Options<DeleteCompanyData, ThrowOnError>): RequestResult<DeleteCompanyResponses, DeleteCompanyErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCompanyResponses, DeleteCompanyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/{company_slug}',
    ...options
});

/**
 * Get Company
 *
 * GET /api/v1/companies/{company_slug}
 */
export const getCompany = <ThrowOnError extends boolean = false>(options: Options<GetCompanyData, ThrowOnError>): RequestResult<GetCompanyResponses, GetCompanyErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyResponses, GetCompanyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/{company_slug}',
    ...options
});

/**
 * Patch Company
 *
 * PATCH /api/v1/companies/{company_slug}
 */
export const patchCompany = <ThrowOnError extends boolean = false>(options: Options<PatchCompanyData, ThrowOnError>): RequestResult<PatchCompanyResponses, PatchCompanyErrors, ThrowOnError> => (options.client ?? client).patch<PatchCompanyResponses, PatchCompanyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/{company_slug}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Members
 *
 * GET /api/v1/companies/{company_slug}/members
 */
export const getCompanyMembers = <ThrowOnError extends boolean = false>(options: Options<GetCompanyMembersData, ThrowOnError>): RequestResult<GetCompanyMembersResponses, GetCompanyMembersErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyMembersResponses, GetCompanyMembersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/{company_slug}/members',
    ...options
});

/**
 * Get Contacts Find
 *
 * GET /api/v1/contacts/find
 *
 * Merged person+candidate typeahead search. With a phrase, sorted by best
 * match (ES relevance) so an exactly-typed name surfaces first (BAN-5912);
 * without one, sorted alphabetically by full name. One row per human:
 * when a linked candidate and its person both match, the candidate row
 * wins. Each row carries only the identity it stands for.
 */
export const getContactsFind = <ThrowOnError extends boolean = false>(options?: Options<GetContactsFindData, ThrowOnError>): RequestResult<GetContactsFindResponses, GetContactsFindErrors, ThrowOnError> => (options?.client ?? client).get<GetContactsFindResponses, GetContactsFindErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/contacts/find',
    ...options
});

/**
 * Get Files Image
 *
 * GET /api/v1/files/image
 */
export const getFilesImage = <ThrowOnError extends boolean = false>(options: Options<GetFilesImageData, ThrowOnError>): RequestResult<GetFilesImageResponses, GetFilesImageErrors, ThrowOnError> => (options.client ?? client).get<GetFilesImageResponses, GetFilesImageErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/v1/files/image',
    ...options
});

/**
 * Post Files Image
 *
 * POST /api/v1/files/image
 */
export const postFilesImage = <ThrowOnError extends boolean = false>(options: Options<PostFilesImageData, ThrowOnError>): RequestResult<PostFilesImageResponses, PostFilesImageErrors, ThrowOnError> => (options.client ?? client).post<PostFilesImageResponses, PostFilesImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/files/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Post Files Linkedin Resume
 *
 * POST /api/v1/files/linkedin_resume
 */
export const postFilesLinkedinResume = <ThrowOnError extends boolean = false>(options: Options<PostFilesLinkedinResumeData, ThrowOnError>): RequestResult<PostFilesLinkedinResumeResponses, PostFilesLinkedinResumeErrors, ThrowOnError> => (options.client ?? client).post<PostFilesLinkedinResumeResponses, PostFilesLinkedinResumeErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/files/linkedin_resume',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Find
 *
 * POST /find
 */
export const getFind = <ThrowOnError extends boolean = false>(options?: Options<GetFindData, ThrowOnError>): RequestResult<GetFindResponses, GetFindErrors, ThrowOnError> => (options?.client ?? client).post<GetFindResponses, GetFindErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/find',
    ...options
});

/**
 * Get Home Team Activity
 *
 * GET /api/v1/home/teams/{team_uuid}/activity
 */
export const getHomeTeamActivity = <ThrowOnError extends boolean = false>(options: Options<GetHomeTeamActivityData, ThrowOnError>): RequestResult<GetHomeTeamActivityResponses, GetHomeTeamActivityErrors, ThrowOnError> => (options.client ?? client).get<GetHomeTeamActivityResponses, GetHomeTeamActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/home/teams/{team_uuid}/activity',
    ...options
});

/**
 * Get Home Team Candidates
 *
 * GET /api/v1/home/teams/{team_uuid}/candidates
 */
export const getHomeTeamCandidates = <ThrowOnError extends boolean = false>(options: Options<GetHomeTeamCandidatesData, ThrowOnError>): RequestResult<GetHomeTeamCandidatesResponses, GetHomeTeamCandidatesErrors, ThrowOnError> => (options.client ?? client).get<GetHomeTeamCandidatesResponses, GetHomeTeamCandidatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/home/teams/{team_uuid}/candidates',
    ...options
});

/**
 * Post Home Candidates
 *
 * POST /api/v1/home/candidates
 */
export const postHomeCandidates = <ThrowOnError extends boolean = false>(options?: Options<PostHomeCandidatesData, ThrowOnError>): RequestResult<PostHomeCandidatesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostHomeCandidatesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/home/candidates',
    ...options
});

/**
 * Get Home Candidates Downvotes
 *
 * GET /api/v1/home/candidates/downvotes
 */
export const getHomeCandidatesDownvotes = <ThrowOnError extends boolean = false>(options?: Options<GetHomeCandidatesDownvotesData, ThrowOnError>): RequestResult<GetHomeCandidatesDownvotesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetHomeCandidatesDownvotesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/home/candidates/downvotes',
    ...options
});

/**
 * Post Home Team Candidate Feedback
 *
 * POST /api/v1/home/teams/{team_uuid}/candidates/{candidate_uuid}/feedback
 */
export const postHomeTeamCandidateFeedback = <ThrowOnError extends boolean = false>(options: Options<PostHomeTeamCandidateFeedbackData, ThrowOnError>): RequestResult<PostHomeTeamCandidateFeedbackResponses, PostHomeTeamCandidateFeedbackErrors, ThrowOnError> => (options.client ?? client).post<PostHomeTeamCandidateFeedbackResponses, PostHomeTeamCandidateFeedbackErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/home/teams/{team_uuid}/candidates/{candidate_uuid}/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Home Team Stats
 *
 * GET /api/v1/home/teams/{team_uuid}/stats
 */
export const getHomeTeamStats = <ThrowOnError extends boolean = false>(options: Options<GetHomeTeamStatsData, ThrowOnError>): RequestResult<GetHomeTeamStatsResponses, GetHomeTeamStatsErrors, ThrowOnError> => (options.client ?? client).get<GetHomeTeamStatsResponses, GetHomeTeamStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/home/teams/{team_uuid}/stats',
    ...options
});

/**
 * Post Home Team Views
 *
 * POST /api/v1/home/teams/{team_uuid}/views
 */
export const postHomeTeamViews = <ThrowOnError extends boolean = false>(options: Options<PostHomeTeamViewsData, ThrowOnError>): RequestResult<PostHomeTeamViewsResponses, PostHomeTeamViewsErrors, ThrowOnError> => (options.client ?? client).post<PostHomeTeamViewsResponses, PostHomeTeamViewsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/home/teams/{team_uuid}/views',
    ...options
});

/**
 * Get Jobs Facilitated Intro Reminder
 *
 * GET /api/v1/jobs/facilitated_intro_reminder
 */
export const getJobsFacilitatedIntroReminder = <ThrowOnError extends boolean = false>(options?: Options<GetJobsFacilitatedIntroReminderData, ThrowOnError>): RequestResult<GetJobsFacilitatedIntroReminderResponses, GetJobsFacilitatedIntroReminderErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsFacilitatedIntroReminderResponses, GetJobsFacilitatedIntroReminderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/facilitated_intro_reminder',
    ...options
});

/**
 * Get Jobs Resendinvite
 *
 * GET /api/v1/jobs/resendinvite
 */
export const getJobsResendinvite = <ThrowOnError extends boolean = false>(options?: Options<GetJobsResendinviteData, ThrowOnError>): RequestResult<GetJobsResendinviteResponses, GetJobsResendinviteErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsResendinviteResponses, GetJobsResendinviteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/resendinvite',
    ...options
});

/**
 * Get Jobs Scheduled Intros
 *
 * GET /api/v1/jobs/scheduled_intros
 */
export const getJobsScheduledIntros = <ThrowOnError extends boolean = false>(options?: Options<GetJobsScheduledIntrosData, ThrowOnError>): RequestResult<GetJobsScheduledIntrosResponses, GetJobsScheduledIntrosErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsScheduledIntrosResponses, GetJobsScheduledIntrosErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/scheduled_intros',
    ...options
});

/**
 * Post Homepage Candidates
 *
 * POST /api/v1/jobs/homepage-candidates
 */
export const postHomepageCandidates = <ThrowOnError extends boolean = false>(options?: Options<PostHomepageCandidatesData, ThrowOnError>): RequestResult<PostHomepageCandidatesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostHomepageCandidatesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/homepage-candidates',
    ...options
});

/**
 * Get Jobs Scheduled P2P Intros
 *
 * GET /api/v1/jobs/scheduled_p2p_intros
 */
export const getJobsScheduledP2pIntros = <ThrowOnError extends boolean = false>(options?: Options<GetJobsScheduledP2pIntrosData, ThrowOnError>): RequestResult<GetJobsScheduledP2pIntrosResponses, GetJobsScheduledP2pIntrosErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsScheduledP2pIntrosResponses, GetJobsScheduledP2pIntrosErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/scheduled_p2p_intros',
    ...options
});

/**
 * Get Jobs Auto Introductions
 *
 * Auto introduction emails have been disabled; keep endpoint for backwards compatibility.
 */
export const getJobsAutoIntroductions = <ThrowOnError extends boolean = false>(options?: Options<GetJobsAutoIntroductionsData, ThrowOnError>): RequestResult<GetJobsAutoIntroductionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetJobsAutoIntroductionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/auto_introductions',
    ...options
});

/**
 * Get Jobs Draft Status Change Emails
 *
 * GET /api/v1/jobs/draft_status_change_emails
 *
 * Send batched draft status change email notifications including assignee changes.
 *
 * Processes:
 * 1. Draft status changes from EvaluationHistory (last N minutes)
 * 2. Assignee changes from Redis queue
 *
 * Runs every 30 minutes via CRON scheduler.
 */
export const getJobsDraftStatusChangeEmails = <ThrowOnError extends boolean = false>(options?: Options<GetJobsDraftStatusChangeEmailsData, ThrowOnError>): RequestResult<GetJobsDraftStatusChangeEmailsResponses, GetJobsDraftStatusChangeEmailsErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsDraftStatusChangeEmailsResponses, GetJobsDraftStatusChangeEmailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/draft_status_change_emails',
    ...options
});

/**
 * Get Jobs Linkedin Batch Sync
 *
 * GET /api/v1/jobs/linkedin_batch_sync
 *
 * Monthly LinkedIn profile batch sync for:
 * - Tier 3 (advisor_network) candidates not updated in >6 months
 * - Tier 1b (former_executive_client) candidates not updated in >6 months
 *
 * Query params:
 * dry_run: If true, returns candidate count without syncing
 * batch_size: Number of candidates to sync (default: all, minimum: 1)
 *
 * Returns:
 * {
 * "candidates_found": int,
 * "sync_started": bool,
 * "dry_run": bool,
 * "estimated_credits": int,
 * "errors": list[dict]
 * }
 */
export const getJobsLinkedinBatchSync = <ThrowOnError extends boolean = false>(options?: Options<GetJobsLinkedinBatchSyncData, ThrowOnError>): RequestResult<GetJobsLinkedinBatchSyncResponses, GetJobsLinkedinBatchSyncErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsLinkedinBatchSyncResponses, GetJobsLinkedinBatchSyncErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/linkedin_batch_sync',
    ...options
});

/**
 * Get Jobs Hubspot Field Sync
 *
 * GET /api/v1/jobs/hubspot_field_sync
 *
 * Reconcile the HubSpot `invoice_status` contact property onto tier 1
 * (executive_client) and tier 1b (former_executive_client) candidates.
 *
 * Idempotent: the first run backfills `hubspot_id` links (matching HubSpot
 * contacts by email); every run refreshes `invoice_status`, writing only when
 * the value changed. Unmatched emails are retried next run; emails matching
 * multiple HubSpot contacts are skipped for human resolution (never guessed).
 *
 * Cadence: intended to run hourly via the Heroku Advanced Scheduler (the
 * interval lives in the scheduler, not the repo). Start hourly; tune later.
 *
 * Query params:
 * dry_run: If true, runs the reconcile in dry mode (calls HubSpot, writes
 * nothing) and reports would-link / would-update / ambiguous / unmatched
 * counts. Combine with `batch_size` to bound the HubSpot calls.
 * batch_size: Cap the number of candidates reconciled (default: all).
 *
 * Returns:
 * HubSpotFieldSyncResponse
 */
export const getJobsHubspotFieldSync = <ThrowOnError extends boolean = false>(options?: Options<GetJobsHubspotFieldSyncData, ThrowOnError>): RequestResult<GetJobsHubspotFieldSyncResponses, GetJobsHubspotFieldSyncErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsHubspotFieldSyncResponses, GetJobsHubspotFieldSyncErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/hubspot_field_sync',
    ...options
});

/**
 * Get Jobs Market Search Resolve Sweep
 *
 * GET /api/v1/jobs/market_search_resolve_sweep
 *
 * Retry the references a market search was logged without. Daily.
 *
 * A search is captured from a note, so the company it names may not be in
 * Contender yet and the client may be spelled a little differently. Those
 * columns are left NULL rather than guessed, and this is what revisits them.
 * Every row it examines is stamped `last_resolved_at`, so a name that will
 * never resolve is looked at once instead of leading the queue forever.
 */
export const getJobsMarketSearchResolveSweep = <ThrowOnError extends boolean = false>(options?: Options<GetJobsMarketSearchResolveSweepData, ThrowOnError>): RequestResult<GetJobsMarketSearchResolveSweepResponses, GetJobsMarketSearchResolveSweepErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsMarketSearchResolveSweepResponses, GetJobsMarketSearchResolveSweepErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/market_search_resolve_sweep',
    ...options
});

/**
 * Get Jobs Market Search Closure Verification
 *
 * GET /api/v1/jobs/market_search_closure_verification
 *
 * Close searches a finished Banff pipeline proves are over. Weekly.
 *
 * Nobody tells us a search ended, so the evidence has to be found. A closed
 * pipeline at the same company for the same role is that evidence; the same
 * company for a *different* role is not, which is why linking and closing sit
 * at different similarity thresholds and a conflicting function vetoes both.
 */
export const getJobsMarketSearchClosureVerification = <ThrowOnError extends boolean = false>(options?: Options<GetJobsMarketSearchClosureVerificationData, ThrowOnError>): RequestResult<GetJobsMarketSearchClosureVerificationResponses, GetJobsMarketSearchClosureVerificationErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsMarketSearchClosureVerificationResponses, GetJobsMarketSearchClosureVerificationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/market_search_closure_verification',
    ...options
});

/**
 * Get Jobs Market Search Classification Catchup
 *
 * GET /api/v1/jobs/market_search_classification_catchup
 *
 * Classify market searches still missing a role type or seniority. Hourly.
 *
 * The capture path already asks the model, under a five-second cap; this
 * picks up whatever that cap or an outage left behind, plus the backfilled
 * rows nobody ever asked about. Cheapest source first — dictionary, then
 * titles already decided on other rows, then the model in batches on distinct
 * titles only.
 */
export const getJobsMarketSearchClassificationCatchup = <ThrowOnError extends boolean = false>(options?: Options<GetJobsMarketSearchClassificationCatchupData, ThrowOnError>): RequestResult<GetJobsMarketSearchClassificationCatchupResponses, GetJobsMarketSearchClassificationCatchupErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsMarketSearchClassificationCatchupResponses, GetJobsMarketSearchClassificationCatchupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/market_search_classification_catchup',
    ...options
});

/**
 * Get Jobs Refresh Team Insights
 *
 * GET /api/v1/jobs/refresh_team_insights
 *
 * Recompute the AI intro-request summaries (the "Recent Intro Requests" pane +
 * trending search) for teams whose request set has gone stale. Nightly.
 *
 * Queues the work on the worker rather than running it in-request: the sweep
 * makes an LLM call per stale team, which does not belong in a scheduler's HTTP
 * call. Only stale/cold teams are recomputed, so a nightly run is cheap; the
 * one-time backfill stays a manual `tasks/refresh_team_insights.py` run.
 */
export const getJobsRefreshTeamInsights = <ThrowOnError extends boolean = false>(options?: Options<GetJobsRefreshTeamInsightsData, ThrowOnError>): RequestResult<GetJobsRefreshTeamInsightsResponses, GetJobsRefreshTeamInsightsErrors, ThrowOnError> => (options?.client ?? client).get<GetJobsRefreshTeamInsightsResponses, GetJobsRefreshTeamInsightsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/refresh_team_insights',
    ...options
});

/**
 * Post Utils Mail Send
 *
 * Send a SendGrid dynamic-template email with optional attachments to recipients.
 * The `recipients` form field must be a JSON array of objects:
 * [{"email": "...", "first_name": "...", "last_name": "..."}]
 */
export const postUtilsMailSend = <ThrowOnError extends boolean = false>(options: Options<PostUtilsMailSendData, ThrowOnError>): RequestResult<PostUtilsMailSendResponses, PostUtilsMailSendErrors, ThrowOnError> => (options.client ?? client).post<PostUtilsMailSendResponses, PostUtilsMailSendErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{
            in: 'query',
            name: 'jobs_api_key',
            type: 'apiKey'
        }, { scheme: 'bearer', type: 'http' }],
    url: '/api/v1/utils/mail_send',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get People Advisors
 *
 * GET /api/v1/people/advisors
 */
export const getPeopleAdvisors = <ThrowOnError extends boolean = false>(options?: Options<GetPeopleAdvisorsData, ThrowOnError>): RequestResult<GetPeopleAdvisorsResponses, GetPeopleAdvisorsErrors, ThrowOnError> => (options?.client ?? client).get<GetPeopleAdvisorsResponses, GetPeopleAdvisorsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/people/advisors',
    ...options
});

/**
 * Get People Current
 *
 * GET /api/v1/people/current
 *
 * Current user profile for the app (legacy ``Person`` shape).
 */
export const getPeopleCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetPeopleCurrentData, ThrowOnError>): RequestResult<GetPeopleCurrentResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPeopleCurrentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/people/current',
    ...options
});

/**
 * Get People Current Teams
 *
 * GET /api/v1/people/current/teams
 */
export const getPeopleCurrentTeams = <ThrowOnError extends boolean = false>(options?: Options<GetPeopleCurrentTeamsData, ThrowOnError>): RequestResult<GetPeopleCurrentTeamsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPeopleCurrentTeamsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/people/current/teams',
    ...options
});

/**
 * Get People Find
 *
 * GET /api/v1/people/find
 */
export const getPeopleFind = <ThrowOnError extends boolean = false>(options?: Options<GetPeopleFindData, ThrowOnError>): RequestResult<GetPeopleFindResponses, GetPeopleFindErrors, ThrowOnError> => (options?.client ?? client).get<GetPeopleFindResponses, GetPeopleFindErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/people/find',
    ...options
});

/**
 * Delete Person Image
 *
 * DELETE /api/v1/people/{person_uuid}/image
 */
export const deletePersonImage = <ThrowOnError extends boolean = false>(options: Options<DeletePersonImageData, ThrowOnError>): RequestResult<DeletePersonImageResponses, DeletePersonImageErrors, ThrowOnError> => (options.client ?? client).delete<DeletePersonImageResponses, DeletePersonImageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/people/{person_uuid}/image',
    ...options
});

/**
 * Get Person Image
 *
 * GET /api/v1/people/{person_uuid}/image
 */
export const getPersonImage = <ThrowOnError extends boolean = false>(options: Options<GetPersonImageData, ThrowOnError>): RequestResult<GetPersonImageResponses, GetPersonImageErrors, ThrowOnError> => (options.client ?? client).get<GetPersonImageResponses, GetPersonImageErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/v1/people/{person_uuid}/image',
    ...options
});

/**
 * Post Person Image
 *
 * POST /api/v1/people/{person_uuid}/image
 */
export const postPersonImage = <ThrowOnError extends boolean = false>(options: Options<PostPersonImageData, ThrowOnError>): RequestResult<PostPersonImageResponses, PostPersonImageErrors, ThrowOnError> => (options.client ?? client).post<PostPersonImageResponses, PostPersonImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/people/{person_uuid}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Put Person Password
 *
 * PUT /api/v1/people/{person_uuid}/password
 */
export const putPersonPassword = <ThrowOnError extends boolean = false>(options: Options<PutPersonPasswordData, ThrowOnError>): RequestResult<PutPersonPasswordResponses, PutPersonPasswordErrors, ThrowOnError> => (options.client ?? client).put<PutPersonPasswordResponses, PutPersonPasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/people/{person_uuid}/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pipelines Find
 *
 * GET /api/v1/pipelines/find
 */
export const getPipelinesFind = <ThrowOnError extends boolean = false>(options?: Options<GetPipelinesFindData, ThrowOnError>): RequestResult<GetPipelinesFindResponses, GetPipelinesFindErrors, ThrowOnError> => (options?.client ?? client).get<GetPipelinesFindResponses, GetPipelinesFindErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pipelines/find',
    ...options
});

/**
 * Delete A Pipeline
 *
 * DELETE /api/v1/pipelines/{pipeline_slug}
 */
export const deleteAPipeline = <ThrowOnError extends boolean = false>(options: Options<DeleteAPipelineData, ThrowOnError>): RequestResult<DeleteAPipelineResponses, DeleteAPipelineErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAPipelineResponses, DeleteAPipelineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pipelines/{pipeline_slug}',
    ...options
});

/**
 * Get Recommendations Find
 *
 * GET /api/v1/recommendations/find
 */
export const getRecommendationsFind = <ThrowOnError extends boolean = false>(options: Options<GetRecommendationsFindData, ThrowOnError>): RequestResult<GetRecommendationsFindResponses, GetRecommendationsFindErrors, ThrowOnError> => (options.client ?? client).get<GetRecommendationsFindResponses, GetRecommendationsFindErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/recommendations/find',
    ...options
});

/**
 * Get V1 Recommendation
 *
 * GET /api/v1/recommendations/{recommendation_uuid}
 */
export const getV1Recommendation = <ThrowOnError extends boolean = false>(options: Options<GetV1RecommendationData, ThrowOnError>): RequestResult<GetV1RecommendationResponses, GetV1RecommendationErrors, ThrowOnError> => (options.client ?? client).get<GetV1RecommendationResponses, GetV1RecommendationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/recommendations/{recommendation_uuid}',
    ...options
});

/**
 * Get V1 Recommendation Preview
 *
 * GET /api/v1/recommendations/{recommendation_uuid}/preview
 *
 * Guest/preview endpoint for accessing a recommendation via signed token.
 * Returns limited fields suitable for unauthenticated users.
 *
 * The token should be generated using generate_preview_token() and included
 * in the email link as a query parameter.
 */
export const getV1RecommendationPreview = <ThrowOnError extends boolean = false>(options: Options<GetV1RecommendationPreviewData, ThrowOnError>): RequestResult<GetV1RecommendationPreviewResponses, GetV1RecommendationPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetV1RecommendationPreviewResponses, GetV1RecommendationPreviewErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/recommendations/{recommendation_uuid}/preview',
    ...options
});

/**
 * Post Recommendation Off Limits
 *
 * POST /api/v1/recommendations/{candidate_uuid}/off_limits
 */
export const postRecommendationOffLimits = <ThrowOnError extends boolean = false>(options: Options<PostRecommendationOffLimitsData, ThrowOnError>): RequestResult<PostRecommendationOffLimitsResponses, PostRecommendationOffLimitsErrors, ThrowOnError> => (options.client ?? client).post<PostRecommendationOffLimitsResponses, PostRecommendationOffLimitsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/recommendations/{candidate_uuid}/off_limits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Recommendation Status
 *
 * PUT /api/v1/recommendations/{submission_candidate_uuid}/status
 */
export const putRecommendationStatus = <ThrowOnError extends boolean = false>(options: Options<PutRecommendationStatusData, ThrowOnError>): RequestResult<PutRecommendationStatusResponses, PutRecommendationStatusErrors, ThrowOnError> => (options.client ?? client).put<PutRecommendationStatusResponses, PutRecommendationStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/recommendations/{submission_candidate_uuid}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Share Recommendations
 *
 * POST /api/v1/share/recommendations
 */
export const postShareRecommendations = <ThrowOnError extends boolean = false>(options: Options<PostShareRecommendationsData, ThrowOnError>): RequestResult<PostShareRecommendationsResponses, PostShareRecommendationsErrors, ThrowOnError> => (options.client ?? client).post<PostShareRecommendationsResponses, PostShareRecommendationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/share/recommendations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Teams
 *
 * POST /api/v1/teams
 *
 * @deprecated
 */
export const postTeams = <ThrowOnError extends boolean = false>(options: Options<PostTeamsData, ThrowOnError>): RequestResult<PostTeamsResponses, PostTeamsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamsResponses, PostTeamsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Teams Find
 *
 * GET /api/v1/teams/find
 */
export const getTeamsFind = <ThrowOnError extends boolean = false>(options?: Options<GetTeamsFindData, ThrowOnError>): RequestResult<GetTeamsFindResponses, GetTeamsFindErrors, ThrowOnError> => (options?.client ?? client).get<GetTeamsFindResponses, GetTeamsFindErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/find',
    ...options
});

/**
 * Delete Team
 *
 * DELETE /api/v1/teams/{team_slug}
 */
export const deleteTeam = <ThrowOnError extends boolean = false>(options: Options<DeleteTeamData, ThrowOnError>): RequestResult<DeleteTeamResponses, DeleteTeamErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTeamResponses, DeleteTeamErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}',
    ...options
});

/**
 * Get Team
 *
 * GET /api/v1/teams/{team_slug}
 */
export const getTeam = <ThrowOnError extends boolean = false>(options: Options<GetTeamData, ThrowOnError>): RequestResult<GetTeamResponses, GetTeamErrors, ThrowOnError> => (options.client ?? client).get<GetTeamResponses, GetTeamErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}',
    ...options
});

/**
 * Patch Team
 *
 * PATCH /api/v1/teams/{team_slug}
 *
 * `active` is admin-only (BAN-6000): team leads can edit their team but not
 * archive it.
 */
export const patchTeam = <ThrowOnError extends boolean = false>(options: Options<PatchTeamData, ThrowOnError>): RequestResult<PatchTeamResponses, PatchTeamErrors, ThrowOnError> => (options.client ?? client).patch<PatchTeamResponses, PatchTeamErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Members
 *
 * GET /api/v1/teams/{team_slug}/members
 */
export const getTeamMembers = <ThrowOnError extends boolean = false>(options: Options<GetTeamMembersData, ThrowOnError>): RequestResult<GetTeamMembersResponses, GetTeamMembersErrors, ThrowOnError> => (options.client ?? client).get<GetTeamMembersResponses, GetTeamMembersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/members',
    ...options
});

/**
 * Delete Team Member
 *
 * DELETE /api/v1/teams/{team_slug}/members/{person_uuid}
 */
export const deleteTeamMember = <ThrowOnError extends boolean = false>(options: Options<DeleteTeamMemberData, ThrowOnError>): RequestResult<DeleteTeamMemberResponses, DeleteTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTeamMemberResponses, DeleteTeamMemberErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/members/{person_uuid}',
    ...options
});

/**
 * Get Team Pipelines
 *
 * GET /api/v1/teams/{team_slug}/pipelines
 */
export const getTeamPipelines = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelinesData, ThrowOnError>): RequestResult<GetTeamPipelinesResponses, GetTeamPipelinesErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelinesResponses, GetTeamPipelinesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/pipelines',
    ...options
});

/**
 * Patch Team Pipeline
 *
 * PATCH /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}
 */
export const patchTeamPipeline = <ThrowOnError extends boolean = false>(options: Options<PatchTeamPipelineData, ThrowOnError>): RequestResult<PatchTeamPipelineResponses, PatchTeamPipelineErrors, ThrowOnError> => (options.client ?? client).patch<PatchTeamPipelineResponses, PatchTeamPipelineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/pipelines/{pipeline_slug}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Pipeline Recommendation Bio
 *
 * GET /api/v1/api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/bio
 */
export const getTeamPipelineRecommendationBio = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelineRecommendationBioData, ThrowOnError>): RequestResult<GetTeamPipelineRecommendationBioResponses, GetTeamPipelineRecommendationBioErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelineRecommendationBioResponses, GetTeamPipelineRecommendationBioErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/bio',
    ...options
});

/**
 * Get Team Pipeline Recommendation Checks Shared
 *
 * GET /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/checks/shared
 */
export const getTeamPipelineRecommendationChecksShared = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelineRecommendationChecksSharedData, ThrowOnError>): RequestResult<GetTeamPipelineRecommendationChecksSharedResponses, GetTeamPipelineRecommendationChecksSharedErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelineRecommendationChecksSharedResponses, GetTeamPipelineRecommendationChecksSharedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/checks/shared',
    ...options
});

/**
 * Get Team Pipeline Recommendation Introduction
 *
 * GET /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/introduction
 */
export const getTeamPipelineRecommendationIntroduction = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelineRecommendationIntroductionData, ThrowOnError>): RequestResult<GetTeamPipelineRecommendationIntroductionResponses, GetTeamPipelineRecommendationIntroductionErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelineRecommendationIntroductionResponses, GetTeamPipelineRecommendationIntroductionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/introduction',
    ...options
});

/**
 * Post Team Pipeline Recommendation Introduction
 *
 * POST /api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/introduction
 */
export const postTeamPipelineRecommendationIntroduction = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelineRecommendationIntroductionData, ThrowOnError>): RequestResult<PostTeamPipelineRecommendationIntroductionResponses, PostTeamPipelineRecommendationIntroductionErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelineRecommendationIntroductionResponses, PostTeamPipelineRecommendationIntroductionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/pipelines/{pipeline_slug}/recommendations/{candidate_uuid}/introduction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Recommendation Bio
 *
 * GET /api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/bio
 */
export const getTeamRecommendationBio = <ThrowOnError extends boolean = false>(options: Options<GetTeamRecommendationBioData, ThrowOnError>): RequestResult<GetTeamRecommendationBioResponses, GetTeamRecommendationBioErrors, ThrowOnError> => (options.client ?? client).get<GetTeamRecommendationBioResponses, GetTeamRecommendationBioErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/bio',
    ...options
});

/**
 * Get Team Recommendation Introduction
 *
 * GET /api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/introduction
 */
export const getTeamRecommendationIntroduction = <ThrowOnError extends boolean = false>(options: Options<GetTeamRecommendationIntroductionData, ThrowOnError>): RequestResult<GetTeamRecommendationIntroductionResponses, GetTeamRecommendationIntroductionErrors, ThrowOnError> => (options.client ?? client).get<GetTeamRecommendationIntroductionResponses, GetTeamRecommendationIntroductionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/introduction',
    ...options
});

/**
 * Post Team Recommendation Introduction
 *
 * POST /api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/introduction
 */
export const postTeamRecommendationIntroduction = <ThrowOnError extends boolean = false>(options: Options<PostTeamRecommendationIntroductionData, ThrowOnError>): RequestResult<PostTeamRecommendationIntroductionResponses, PostTeamRecommendationIntroductionErrors, ThrowOnError> => (options.client ?? client).post<PostTeamRecommendationIntroductionResponses, PostTeamRecommendationIntroductionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/{team_slug}/recommendations/{candidate_uuid}/introduction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Trending Schedule
 *
 * POST /api/v1/trending_schedule
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTrendingSchedule = <ThrowOnError extends boolean = false>(options: Options<PostTrendingScheduleData, ThrowOnError>): RequestResult<PostTrendingScheduleResponses, PostTrendingScheduleErrors, ThrowOnError> => (options.client ?? client).post<PostTrendingScheduleResponses, PostTrendingScheduleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trending_schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Clerk Webhook
 *
 * POST /api/v1/webhooks/clerk
 */
export const postClerkWebhook = <ThrowOnError extends boolean = false>(options?: Options<PostClerkWebhookData, ThrowOnError>): RequestResult<PostClerkWebhookResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostClerkWebhookResponses, unknown, ThrowOnError>({ url: '/api/v1/webhooks/clerk', ...options });

/**
 * Post Webhooks Es Events
 *
 * POST /api/v1/webhooks/es_events
 */
export const postWebhooksEsEvents = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksEsEventsData, ThrowOnError>): RequestResult<PostWebhooksEsEventsResponses, PostWebhooksEsEventsErrors, ThrowOnError> => (options.client ?? client).post<PostWebhooksEsEventsResponses, PostWebhooksEsEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/es_events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidates Import From Csv
 *
 * POST /api/v1/candidates/import
 * Import candidates from a CSV file.
 */
export const postCandidatesImportFromCsv = <ThrowOnError extends boolean = false>(options?: Options<PostCandidatesImportFromCsvData, ThrowOnError>): RequestResult<PostCandidatesImportFromCsvResponses, PostCandidatesImportFromCsvErrors, ThrowOnError> => (options?.client ?? client).post<PostCandidatesImportFromCsvResponses, PostCandidatesImportFromCsvErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Post Candidates Export Failed
 *
 * POST /api/v1/candidates/export-failed
 * Export failed candidate imports to a CSV file.
 *
 * This endpoint accepts a list of failed candidate rows and returns a downloadable CSV file
 * containing the import errors.
 */
export const postCandidatesExportFailed = <ThrowOnError extends boolean = false>(options: Options<PostCandidatesExportFailedData, ThrowOnError>): RequestResult<PostCandidatesExportFailedResponses, PostCandidatesExportFailedErrors, ThrowOnError> => (options.client ?? client).post<PostCandidatesExportFailedResponses, PostCandidatesExportFailedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/candidates/export-failed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Es Reindex
 *
 * POST /api/v2/es-reindex
 *
 * Enqueues a Celery task to reindex the specified Elasticsearch index asynchronously.
 * All indices are reindexed asynchronously to prevent API timeouts and enable
 * progress monitoring via Flower dashboard.
 *
 * Returns 202 Accepted with task_id to poll for status and results.
 */
export const postEsReindex = <ThrowOnError extends boolean = false>(options: Options<PostEsReindexData, ThrowOnError>): RequestResult<PostEsReindexResponses, PostEsReindexErrors, ThrowOnError> => (options.client ?? client).post<PostEsReindexResponses, PostEsReindexErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/es-reindex',
    ...options
});

/**
 * Get Reindex Status
 *
 * GET /api/v2/es-reindex/status/{task_id}
 *
 * Check the status of a reindex task by its task_id.
 *
 * Returns current state, progress information, and final results when complete.
 * Task states: PENDING, PROGRESS, SUCCESS, FAILURE, RETRY
 */
export const getReindexStatus = <ThrowOnError extends boolean = false>(options: Options<GetReindexStatusData, ThrowOnError>): RequestResult<GetReindexStatusResponses, GetReindexStatusErrors, ThrowOnError> => (options.client ?? client).get<GetReindexStatusResponses, GetReindexStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/es-reindex/status/{task_id}',
    ...options
});

/**
 * Get Es Index
 *
 * GET /api/v2/current-es-index
 */
export const getEsIndex = <ThrowOnError extends boolean = false>(options: Options<GetEsIndexData, ThrowOnError>): RequestResult<GetEsIndexResponses, GetEsIndexErrors, ThrowOnError> => (options.client ?? client).get<GetEsIndexResponses, GetEsIndexErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/current-es-index',
    ...options
});

/**
 * Patch Alias To Es Index
 *
 * PATCH /api/v2/current-es-index
 */
export const patchAliasToEsIndex = <ThrowOnError extends boolean = false>(options: Options<PatchAliasToEsIndexData, ThrowOnError>): RequestResult<PatchAliasToEsIndexResponses, PatchAliasToEsIndexErrors, ThrowOnError> => (options.client ?? client).patch<PatchAliasToEsIndexResponses, PatchAliasToEsIndexErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/current-es-index',
    ...options
});

/**
 * Create Market Search
 *
 * POST /api/v2/market-searches — log one observation of a search in the market.
 *
 * Normalizes the strings, fills classification the caller left blank, resolves
 * target company / search firm / client to Contender rows where an exact match
 * exists, then applies the same-search rules: an ingestion double returns the
 * existing row (200), a confident match is linked to its search, and anything
 * fuzzier becomes its own search with the candidates returned for a person
 * to confirm via ``/link``.
 */
export const createMarketSearch = <ThrowOnError extends boolean = false>(options: Options<CreateMarketSearchData, ThrowOnError>): RequestResult<CreateMarketSearchResponses, CreateMarketSearchErrors, ThrowOnError> => (options.client ?? client).post<CreateMarketSearchResponses, CreateMarketSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link Market Search
 *
 * POST /api/v2/market-searches/{market_search_uuid}/link — confirm a same-search match.
 *
 * Attaches the observation (and any observations already grouped under it) to
 * the given hub. The hub must itself be a hub — a star, never a chain.
 */
export const linkMarketSearch = <ThrowOnError extends boolean = false>(options: Options<LinkMarketSearchData, ThrowOnError>): RequestResult<LinkMarketSearchResponses, LinkMarketSearchErrors, ThrowOnError> => (options.client ?? client).post<LinkMarketSearchResponses, LinkMarketSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/{market_search_uuid}/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close Market Search
 *
 * POST /api/v2/market-searches/{market_search_uuid}/close — close the whole search.
 *
 * Writes ``status``, ``closed_at`` and ``closed_evidence`` onto every observation
 * that shares this row's ``search_uuid``.
 */
export const closeMarketSearch = <ThrowOnError extends boolean = false>(options: Options<CloseMarketSearchData, ThrowOnError>): RequestResult<CloseMarketSearchResponses, CloseMarketSearchErrors, ThrowOnError> => (options.client ?? client).post<CloseMarketSearchResponses, CloseMarketSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/{market_search_uuid}/close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Market Searches
 *
 * POST /api/v2/market-searches/search — the market-search table.
 *
 * One row per observation, with the size of its search and the linked
 * records it needs for display. Every word of ``phrase`` must match the row's
 * title, target company, firm, contact, client or closing note, or the current name
 * of a record it links to — so a row written "H&S" is found by "Heidrick"
 * once linked. Filters combine with AND; values inside one filter with OR.
 * Newest heard first unless ``sort_rules`` say otherwise.
 */
export const searchMarketSearches = <ThrowOnError extends boolean = false>(options: Options<SearchMarketSearchesData, ThrowOnError>): RequestResult<SearchMarketSearchesResponses, SearchMarketSearchesErrors, ThrowOnError> => (options.client ?? client).post<SearchMarketSearchesResponses, SearchMarketSearchesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Market Search Contact Options
 *
 * GET /api/v2/market-searches/contact-options — people to link as a search's contact.
 *
 * One option per human: people on an active team of a search firm, investor
 * or company — at the given firm or team when narrowed — never Banff staff.
 * Each comes with the teams they sit on, so choosing one can fill in the team
 * and the firm. Declared before ``/{market_search_uuid}``, which would
 * otherwise claim the path.
 */
export const getMarketSearchContactOptions = <ThrowOnError extends boolean = false>(options?: Options<GetMarketSearchContactOptionsData, ThrowOnError>): RequestResult<GetMarketSearchContactOptionsResponses, GetMarketSearchContactOptionsErrors, ThrowOnError> => (options?.client ?? client).get<GetMarketSearchContactOptionsResponses, GetMarketSearchContactOptionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/contact-options',
    ...options
});

/**
 * Get Market Search Team Options
 *
 * GET /api/v2/market-searches/team-options — active teams to link a search to.
 *
 * Narrowed to the search's firm when given. Declared before
 * ``/{market_search_uuid}``, which would otherwise claim the path.
 */
export const getMarketSearchTeamOptions = <ThrowOnError extends boolean = false>(options?: Options<GetMarketSearchTeamOptionsData, ThrowOnError>): RequestResult<GetMarketSearchTeamOptionsResponses, GetMarketSearchTeamOptionsErrors, ThrowOnError> => (options?.client ?? client).get<GetMarketSearchTeamOptionsResponses, GetMarketSearchTeamOptionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/team-options',
    ...options
});

/**
 * Get Market Search Pipeline Options
 *
 * GET /api/v2/market-searches/pipeline-options — pipelines to link a search to.
 *
 * Active pipelines first, then the newest. Declared before
 * ``/{market_search_uuid}``, which would otherwise claim the path.
 */
export const getMarketSearchPipelineOptions = <ThrowOnError extends boolean = false>(options?: Options<GetMarketSearchPipelineOptionsData, ThrowOnError>): RequestResult<GetMarketSearchPipelineOptionsResponses, GetMarketSearchPipelineOptionsErrors, ThrowOnError> => (options?.client ?? client).get<GetMarketSearchPipelineOptionsResponses, GetMarketSearchPipelineOptionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/pipeline-options',
    ...options
});

/**
 * Delete Market Search
 *
 * DELETE /api/v2/market-searches/{market_search_uuid} — remove one observation.
 *
 * Only this report goes: the search's other reports stay, and when this one
 * was the search's hub the oldest of them takes over. The row is kept as
 * deleted rather than erased, so it drops out of every listing and job but
 * an imported row can never be imported again.
 */
export const deleteMarketSearch = <ThrowOnError extends boolean = false>(options: Options<DeleteMarketSearchData, ThrowOnError>): RequestResult<DeleteMarketSearchResponses, DeleteMarketSearchErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMarketSearchResponses, DeleteMarketSearchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/{market_search_uuid}',
    ...options
});

/**
 * Get Market Search
 *
 * GET /api/v2/market-searches/{market_search_uuid} — one observation, in full.
 *
 * Everything the row holds, the records it links to, and the other
 * observations of its search.
 */
export const getMarketSearch = <ThrowOnError extends boolean = false>(options: Options<GetMarketSearchData, ThrowOnError>): RequestResult<GetMarketSearchResponses, GetMarketSearchErrors, ThrowOnError> => (options.client ?? client).get<GetMarketSearchResponses, GetMarketSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/{market_search_uuid}',
    ...options
});

/**
 * Update Market Search
 *
 * PATCH /api/v2/market-searches/{market_search_uuid} — correct what was recorded.
 *
 * Only the fields sent change. Classification, the target company, status
 * and pipeline describe the search and are written to all of its
 * observations (``rows_updated`` says how many); the rest stay on this one.
 * Picking a record by id sets its name too; a new name without an id is
 * looked up again by exact match; an id sent as null unlinks and keeps the
 * name. 422 when a value cannot be stored — a record that does not exist, a
 * team at another firm, a contact not on the firm's teams. Open to the
 * Contender Actions connector, acting for the named team member.
 */
export const updateMarketSearch = <ThrowOnError extends boolean = false>(options: Options<UpdateMarketSearchData, ThrowOnError>): RequestResult<UpdateMarketSearchResponses, UpdateMarketSearchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMarketSearchResponses, UpdateMarketSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/market-searches/{market_search_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidates
 *
 * POST /api/v2/candidates
 *
 * Rejects the create when a candidate with the same email already exists, so
 * a re-submitted form or a retried request cannot fork a second record for
 * the same executive.
 */
export const postCandidates = <ThrowOnError extends boolean = false>(options: Options<PostCandidatesData, ThrowOnError>): RequestResult<PostCandidatesResponses, PostCandidatesErrors, ThrowOnError> => (options.client ?? client).post<PostCandidatesResponses, PostCandidatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate V2
 *
 * GET /api/v2/candidates/{candidate_uuid}
 *
 * Also answers the Contender Actions connector, which reads a profile back
 * after changing it (a LinkedIn sync, for whether a photo was set).
 */
export const getCandidateV2 = <ThrowOnError extends boolean = false>(options: Options<GetCandidateV2Data, ThrowOnError>): RequestResult<GetCandidateV2Responses, GetCandidateV2Errors, ThrowOnError> => (options.client ?? client).get<GetCandidateV2Responses, GetCandidateV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}',
    ...options
});

/**
 * Patch Candidate V2
 *
 * PATCH /api/v2/candidates/{candidate_uuid}
 *
 * A JSON merge patch: only the fields in the body are written, ``null``
 * clears a field. Referrers and blackout periods are not accepted here;
 * referrers have their own endpoints.
 *
 * Unlike ``PUT``, a pathway change keeps the candidate's
 * ``candidate_pathway_targets`` overrides.
 */
export const patchCandidateV2 = <ThrowOnError extends boolean = false>(options: Options<PatchCandidateV2Data, ThrowOnError>): RequestResult<PatchCandidateV2Responses, PatchCandidateV2Errors, ThrowOnError> => (options.client ?? client).patch<PatchCandidateV2Responses, PatchCandidateV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Candidate
 *
 * PUT /api/v2/candidates/{candidate_uuid}
 *
 * The payload is dumped without ``exclude_unset``, so ``email`` is rewritten on
 * every save; guard it so an edit cannot move a candidate onto an email another
 * candidate already uses.
 */
export const putCandidate = <ThrowOnError extends boolean = false>(options: Options<PutCandidateData, ThrowOnError>): RequestResult<PutCandidateResponses, PutCandidateErrors, ThrowOnError> => (options.client ?? client).put<PutCandidateResponses, PutCandidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Candidate Referrer
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/referrers/{identity_uuid}
 *
 * Remove every row recording that ``identity_uuid`` referred this candidate;
 * the table has no unique constraint on the pair, so there can be more than
 * one. 404 when there is none. Other referral rows are not touched.
 */
export const deleteCandidateReferrer = <ThrowOnError extends boolean = false>(options: Options<DeleteCandidateReferrerData, ThrowOnError>): RequestResult<DeleteCandidateReferrerResponses, DeleteCandidateReferrerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCandidateReferrerResponses, DeleteCandidateReferrerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/referrers/{identity_uuid}',
    ...options
});

/**
 * Put Candidate Referrer
 *
 * PUT /api/v2/candidates/{candidate_uuid}/referrers/{identity_uuid}
 *
 * Record that ``identity_uuid`` referred this candidate: 201 with the new
 * referral, or 200 with the existing one when it is already recorded, so no
 * second row is added. The candidate's other referral rows are not touched.
 */
export const putCandidateReferrer = <ThrowOnError extends boolean = false>(options: Options<PutCandidateReferrerData, ThrowOnError>): RequestResult<PutCandidateReferrerResponses, PutCandidateReferrerErrors, ThrowOnError> => (options.client ?? client).put<PutCandidateReferrerResponses, PutCandidateReferrerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/referrers/{identity_uuid}',
    ...options
});

/**
 * Delete Candidate Favorite
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/favorite
 *
 * @deprecated
 */
export const deleteCandidateFavorite = <ThrowOnError extends boolean = false>(options: Options<DeleteCandidateFavoriteData, ThrowOnError>): RequestResult<DeleteCandidateFavoriteResponses, DeleteCandidateFavoriteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCandidateFavoriteResponses, DeleteCandidateFavoriteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/favorite',
    ...options
});

/**
 * Post Candidate Favorite
 *
 * POST /api/v2/candidates/{candidate_uuid}/favorite
 *
 * @deprecated
 */
export const postCandidateFavorite = <ThrowOnError extends boolean = false>(options: Options<PostCandidateFavoriteData, ThrowOnError>): RequestResult<PostCandidateFavoriteResponses, PostCandidateFavoriteErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateFavoriteResponses, PostCandidateFavoriteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/favorite',
    ...options
});

/**
 * Get Candidate Goals
 *
 * GET /api/v2/candidates/{candidate_uuid}/goals
 *
 * @deprecated
 */
export const getCandidateGoals = <ThrowOnError extends boolean = false>(options: Options<GetCandidateGoalsData, ThrowOnError>): RequestResult<GetCandidateGoalsResponses, GetCandidateGoalsErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateGoalsResponses, GetCandidateGoalsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals',
    ...options
});

/**
 * Patch Candidate Goals
 *
 * PATCH /api/v2/candidates/{candidate_uuid}/goals
 *
 * @deprecated
 */
export const patchCandidateGoals = <ThrowOnError extends boolean = false>(options: Options<PatchCandidateGoalsData, ThrowOnError>): RequestResult<PatchCandidateGoalsResponses, PatchCandidateGoalsErrors, ThrowOnError> => (options.client ?? client).patch<PatchCandidateGoalsResponses, PatchCandidateGoalsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate Goals With Activities
 *
 * GET /api/v2/candidates/{candidate_uuid}/goals-activities
 */
export const getCandidateGoalsWithActivities = <ThrowOnError extends boolean = false>(options: Options<GetCandidateGoalsWithActivitiesData, ThrowOnError>): RequestResult<GetCandidateGoalsWithActivitiesResponses, GetCandidateGoalsWithActivitiesErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateGoalsWithActivitiesResponses, GetCandidateGoalsWithActivitiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals-activities',
    ...options
});

/**
 * Post Candidates Goals V2
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals-activities
 */
export const postCandidatesGoalsV2 = <ThrowOnError extends boolean = false>(options: Options<PostCandidatesGoalsV2Data, ThrowOnError>): RequestResult<PostCandidatesGoalsV2Responses, PostCandidatesGoalsV2Errors, ThrowOnError> => (options.client ?? client).post<PostCandidatesGoalsV2Responses, PostCandidatesGoalsV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals-activities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Show Onboarding Section
 *
 * POST /api/v2/candidates/{candidate_uuid}/show-onboarding-section
 */
export const postCandidateShowOnboardingSection = <ThrowOnError extends boolean = false>(options: Options<PostCandidateShowOnboardingSectionData, ThrowOnError>): RequestResult<PostCandidateShowOnboardingSectionResponses, PostCandidateShowOnboardingSectionErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateShowOnboardingSectionResponses, PostCandidateShowOnboardingSectionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/show-onboarding-section',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Feedback V2
 *
 * POST /api/v2/candidates/{candidate_uuid}/feedback
 */
export const postCandidateFeedbackV2 = <ThrowOnError extends boolean = false>(options: Options<PostCandidateFeedbackV2Data, ThrowOnError>): RequestResult<PostCandidateFeedbackV2Responses, PostCandidateFeedbackV2Errors, ThrowOnError> => (options.client ?? client).post<PostCandidateFeedbackV2Responses, PostCandidateFeedbackV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Feedback Filter
 *
 * POST /api/v2/candidates/{candidate_uuid}/feedback/filter
 */
export const postCandidateFeedbackFilter = <ThrowOnError extends boolean = false>(options: Options<PostCandidateFeedbackFilterData, ThrowOnError>): RequestResult<PostCandidateFeedbackFilterResponses, PostCandidateFeedbackFilterErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateFeedbackFilterResponses, PostCandidateFeedbackFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/feedback/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Candidate Feedback
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/feedback/{feedback_uuid}
 */
export const deleteCandidateFeedback = <ThrowOnError extends boolean = false>(options: Options<DeleteCandidateFeedbackData, ThrowOnError>): RequestResult<DeleteCandidateFeedbackResponses, DeleteCandidateFeedbackErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCandidateFeedbackResponses, DeleteCandidateFeedbackErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/feedback/{feedback_uuid}',
    ...options
});

/**
 * Put Candidate Feedback
 *
 * PUT /api/v2/candidates/{candidate_uuid}/feedback/{feedback_uuid}
 */
export const putCandidateFeedback = <ThrowOnError extends boolean = false>(options: Options<PutCandidateFeedbackData, ThrowOnError>): RequestResult<PutCandidateFeedbackResponses, PutCandidateFeedbackErrors, ThrowOnError> => (options.client ?? client).put<PutCandidateFeedbackResponses, PutCandidateFeedbackErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/feedback/{feedback_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Candidate Goal
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/goals/{goal_id}
 */
export const deleteCandidateGoal = <ThrowOnError extends boolean = false>(options: Options<DeleteCandidateGoalData, ThrowOnError>): RequestResult<DeleteCandidateGoalResponses, DeleteCandidateGoalErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCandidateGoalResponses, DeleteCandidateGoalErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals/{goal_id}',
    ...options
});

/**
 * Get Candidate Goal V2
 *
 * GET /api/v2/candidates/{candidate_uuid}/goals/{goal_id}
 */
export const getCandidateGoalV2 = <ThrowOnError extends boolean = false>(options: Options<GetCandidateGoalV2Data, ThrowOnError>): RequestResult<GetCandidateGoalV2Responses, GetCandidateGoalV2Errors, ThrowOnError> => (options.client ?? client).get<GetCandidateGoalV2Responses, GetCandidateGoalV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals/{goal_id}',
    ...options
});

/**
 * Patch Candidate Goal V2
 *
 * PATCH /api/v2/candidates/{candidate_uuid}/goals/{goal_id}
 */
export const patchCandidateGoalV2 = <ThrowOnError extends boolean = false>(options: Options<PatchCandidateGoalV2Data, ThrowOnError>): RequestResult<PatchCandidateGoalV2Responses, PatchCandidateGoalV2Errors, ThrowOnError> => (options.client ?? client).patch<PatchCandidateGoalV2Responses, PatchCandidateGoalV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals/{goal_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Candidate Goal Activity
 *
 * DELETE /api/v2/candidates/{candidate_uuid}/goals/{goal_id}/activity
 */
export const deleteCandidateGoalActivity = <ThrowOnError extends boolean = false>(options: Options<DeleteCandidateGoalActivityData, ThrowOnError>): RequestResult<DeleteCandidateGoalActivityResponses, DeleteCandidateGoalActivityErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCandidateGoalActivityResponses, DeleteCandidateGoalActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals/{goal_id}/activity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Goal Activity
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals/{goal_id}/activity
 */
export const postCandidateGoalActivity = <ThrowOnError extends boolean = false>(options: Options<PostCandidateGoalActivityData, ThrowOnError>): RequestResult<PostCandidateGoalActivityResponses, PostCandidateGoalActivityErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateGoalActivityResponses, PostCandidateGoalActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals/{goal_id}/activity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Goal Tasks
 *
 * POST /api/v2/candidates/{candidate_uuid}/goals/{goal_id}/tasks
 */
export const postCandidateGoalTasks = <ThrowOnError extends boolean = false>(options: Options<PostCandidateGoalTasksData, ThrowOnError>): RequestResult<PostCandidateGoalTasksResponses, PostCandidateGoalTasksErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateGoalTasksResponses, PostCandidateGoalTasksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/goals/{goal_id}/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Recommendations Filter
 *
 * POST /api/v2/candidates/{candidate_uuid}/recommendations/filter
 */
export const postCandidateRecommendationsFilter = <ThrowOnError extends boolean = false>(options: Options<PostCandidateRecommendationsFilterData, ThrowOnError>): RequestResult<PostCandidateRecommendationsFilterResponses, PostCandidateRecommendationsFilterErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateRecommendationsFilterResponses, PostCandidateRecommendationsFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/recommendations/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Intro Templates
 *
 * Create a new introduction template for a candidate
 */
export const postCandidateIntroTemplates = <ThrowOnError extends boolean = false>(options: Options<PostCandidateIntroTemplatesData, ThrowOnError>): RequestResult<PostCandidateIntroTemplatesResponses, PostCandidateIntroTemplatesErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateIntroTemplatesResponses, PostCandidateIntroTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/introduction-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Highlights V2
 *
 * Create a new highlight for a candidate
 */
export const postCandidateHighlightsV2 = <ThrowOnError extends boolean = false>(options: Options<PostCandidateHighlightsV2Data, ThrowOnError>): RequestResult<PostCandidateHighlightsV2Responses, PostCandidateHighlightsV2Errors, ThrowOnError> => (options.client ?? client).post<PostCandidateHighlightsV2Responses, PostCandidateHighlightsV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/highlights',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate Stats
 *
 * GET /api/v2/candidates/{candidate_uuid}/stats
 */
export const getCandidateStats = <ThrowOnError extends boolean = false>(options: Options<GetCandidateStatsData, ThrowOnError>): RequestResult<GetCandidateStatsResponses, GetCandidateStatsErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateStatsResponses, GetCandidateStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/stats',
    ...options
});

/**
 * Get Recsys Candidate Opportunities
 *
 * GET /api/v2/candidates/{candidate_uuid}/recsys-opportunities
 *
 * Fetch this exec's RecSys opportunity queue — the open pipelines RecSys rates them a good
 * fit for, best fit first — and hydrate each into Contender pipeline data. Read-through:
 * nothing is stored on the Contender side. `already_recommended` flags pipelines the exec is
 * already on (so the UI can disable quick add). Empty when RecSys's sweep hasn't reached this
 * exec yet; a 502/503 when the RecSys service is unavailable or unconfigured.
 *
 * Paging happens HERE, not in RecSys: rows whose pipeline is closed or unknown to
 * Contender are dropped, and paging RecSys-side would make `total` count rows that never
 * render and leave pages short. The queue is small by construction (top-of-ranking pairs,
 * well under the bridge's 100 cap), so we read it whole, filter, then slice.
 */
export const getRecsysCandidateOpportunities = <ThrowOnError extends boolean = false>(options: Options<GetRecsysCandidateOpportunitiesData, ThrowOnError>): RequestResult<GetRecsysCandidateOpportunitiesResponses, GetRecsysCandidateOpportunitiesErrors, ThrowOnError> => (options.client ?? client).get<GetRecsysCandidateOpportunitiesResponses, GetRecsysCandidateOpportunitiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/recsys-opportunities',
    ...options
});

/**
 * Get Recsys Opportunity Rationale
 *
 * GET /api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/rationale
 *
 * Why RecSys thinks this exec fits this search. RecSys writes it on first ask and caches it,
 * so a pair whose `has_rationale` is false costs a model call — fetch this when a row is
 * expanded, never for a whole page.
 */
export const getRecsysOpportunityRationale = <ThrowOnError extends boolean = false>(options: Options<GetRecsysOpportunityRationaleData, ThrowOnError>): RequestResult<GetRecsysOpportunityRationaleResponses, GetRecsysOpportunityRationaleErrors, ThrowOnError> => (options.client ?? client).get<GetRecsysOpportunityRationaleResponses, GetRecsysOpportunityRationaleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/rationale',
    ...options
});

/**
 * Post Recsys Opportunity Reviewed
 *
 * POST /api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/reviewed
 *
 * Mark this opportunity reviewed, or clear it. The state lives in RecSys and is keyed on the
 * (candidate, pipeline) pair, so a row an advisor works here stops being offered in the RecSys
 * app too. Clearing fully resets the pair — any bad-match verdict goes with it.
 */
export const postRecsysOpportunityReviewed = <ThrowOnError extends boolean = false>(options: Options<PostRecsysOpportunityReviewedData, ThrowOnError>): RequestResult<PostRecsysOpportunityReviewedResponses, PostRecsysOpportunityReviewedErrors, ThrowOnError> => (options.client ?? client).post<PostRecsysOpportunityReviewedResponses, PostRecsysOpportunityReviewedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/reviewed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Recsys Opportunity Bad Match
 *
 * POST /api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/bad
 *
 * Record that this pipeline is a bad fit for the exec, with an optional reason. Stored in
 * RecSys against the pair and used to steer future suggestions; it deliberately does not
 * touch the pipeline's own recommendation feedback, so a candidate-side verdict never
 * re-ranks somebody else's search.
 */
export const postRecsysOpportunityBadMatch = <ThrowOnError extends boolean = false>(options: Options<PostRecsysOpportunityBadMatchData, ThrowOnError>): RequestResult<PostRecsysOpportunityBadMatchResponses, PostRecsysOpportunityBadMatchErrors, ThrowOnError> => (options.client ?? client).post<PostRecsysOpportunityBadMatchResponses, PostRecsysOpportunityBadMatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/{candidate_uuid}/recsys-opportunities/{pipeline_uuid}/bad',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidates Trending Filter
 *
 * POST /api/v2/candidates/trending/filter
 */
export const postCandidatesTrendingFilter = <ThrowOnError extends boolean = false>(options: Options<PostCandidatesTrendingFilterData, ThrowOnError>): RequestResult<PostCandidatesTrendingFilterResponses, PostCandidatesTrendingFilterErrors, ThrowOnError> => (options.client ?? client).post<PostCandidatesTrendingFilterResponses, PostCandidatesTrendingFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/trending/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Companies Search V2
 *
 * POST /api/v2/companies/search
 *
 * Returns a list of companies with their teams and users.
 * Supports filtering by payment_status, type, has_members and active.
 * Supports sorting by name, payment_status, type, users_count, teams_count.
 * Supports searching by phrase (case-insensitive match on name or industry_keywords).
 */
export const postCompaniesSearchV2 = <ThrowOnError extends boolean = false>(options?: Options<PostCompaniesSearchV2Data, ThrowOnError>): RequestResult<PostCompaniesSearchV2Responses, PostCompaniesSearchV2Errors, ThrowOnError> => (options?.client ?? client).post<PostCompaniesSearchV2Responses, PostCompaniesSearchV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/companies/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Post Company Teams
 *
 * POST /api/v2/companies/{company_slug}/teams
 *
 * Also reachable by the Contender Actions connector (service key + acting
 * user), which may only add a team: the ``company`` block, which overwrites
 * the company's name, type and payment status, is refused on that path.
 */
export const postCompanyTeams = <ThrowOnError extends boolean = false>(options: Options<PostCompanyTeamsData, ThrowOnError>): RequestResult<PostCompanyTeamsResponses, PostCompanyTeamsErrors, ThrowOnError> => (options.client ?? client).post<PostCompanyTeamsResponses, PostCompanyTeamsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/companies/{company_slug}/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Comment
 *
 * DELETE /api/v2/comments/{comment_uuid}
 *
 * Soft delete (sets ``deleted_at``); author-only.
 */
export const deleteComment = <ThrowOnError extends boolean = false>(options: Options<DeleteCommentData, ThrowOnError>): RequestResult<DeleteCommentResponses, DeleteCommentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCommentResponses, DeleteCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/comments/{comment_uuid}',
    ...options
});

/**
 * Put Comment
 *
 * PUT /api/v2/comments/{comment_uuid}
 */
export const putComment = <ThrowOnError extends boolean = false>(options: Options<PutCommentData, ThrowOnError>): RequestResult<PutCommentResponses, PutCommentErrors, ThrowOnError> => (options.client ?? client).put<PutCommentResponses, PutCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/comments/{comment_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Internal Comment
 *
 * DELETE /api/v2/internal-comments/{comment_uuid}
 */
export const deleteInternalComment = <ThrowOnError extends boolean = false>(options: Options<DeleteInternalCommentData, ThrowOnError>): RequestResult<DeleteInternalCommentResponses, DeleteInternalCommentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInternalCommentResponses, DeleteInternalCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/internal-comments/{comment_uuid}',
    ...options
});

/**
 * Put Internal Comment
 *
 * PUT /api/v2/internal-comments/{comment_uuid}
 */
export const putInternalComment = <ThrowOnError extends boolean = false>(options: Options<PutInternalCommentData, ThrowOnError>): RequestResult<PutInternalCommentResponses, PutInternalCommentErrors, ThrowOnError> => (options.client ?? client).put<PutInternalCommentResponses, PutInternalCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/internal-comments/{comment_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Evaluation History Introduction
 *
 * Edit who an existing intro request is for, in place.
 *
 * The subject — an external person or a platform user the request was made
 * on behalf of — is stored in the COMPLETED entry's context and snapshotted
 * into any FACILITATED / INTRODUCTION_NOT_FACILITATED entries of the same
 * request cycle and into every paired candidate_activity_log message, so all
 * of them are rewritten together. Timestamps are never touched: this is the
 * supported way to backfill or correct an introduction without rewriting
 * feed history (unlike revert + re-request, which stamps new dates).
 *
 * The entry's person_id (and the logs' actor_id) is a logging value: it
 * becomes the new on-behalf person, or the acting admin for an external
 * subject — matching what creating the request that way would have recorded.
 *
 * Recommendation-level fields (requested_on_behalf_id, requested_intro)
 * describe the latest request, so they are only rewritten when the edited
 * entry is the latest COMPLETED entry in its scope.
 */
export const putEvaluationHistoryIntroduction = <ThrowOnError extends boolean = false>(options: Options<PutEvaluationHistoryIntroductionData, ThrowOnError>): RequestResult<PutEvaluationHistoryIntroductionResponses, PutEvaluationHistoryIntroductionErrors, ThrowOnError> => (options.client ?? client).put<PutEvaluationHistoryIntroductionResponses, PutEvaluationHistoryIntroductionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/evaluation-history/{evaluation_history_uuid}/introduction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revert Evaluation History
 *
 * Revert a specific evaluation history entry and recalculate recommendation state.
 *
 * Supports:
 * - NOT_LIKED and NOT_LIKED_UNDO actions: Recalculates recommendation's is_liked state
 * - COMPLETED (intro request): Removes intro request and resets submission_candidate fields
 * - FACILITATED (intro facilitated): Removes facilitated status
 * - INTRODUCTION_NOT_FACILITATED (intro unavailable): Removes unavailable status
 *
 * For pipeline intro requests (with recommendation_uuid):
 * - Only ONE intro request (COMPLETED) is allowed per recommendation
 * - Lifecycle: COMPLETED -> FACILITATED or INTRODUCTION_NOT_FACILITATED (one cycle)
 * - Resets submission_candidate fields only if all intro-related entries are removed
 *
 * For global intro requests (without recommendation_uuid):
 * - Multiple cycles are allowed: COMPLETED -> FACILITATED -> COMPLETED (new cycle) -> ...
 * - Only one pending (COMPLETED) request at a time
 * - Only deletes evaluation_history and candidate_activity_log entries (no field resets)
 *
 * Deletes all associated candidate_activity_log entries.
 */
export const revertEvaluationHistory = <ThrowOnError extends boolean = false>(options: Options<RevertEvaluationHistoryData, ThrowOnError>): RequestResult<RevertEvaluationHistoryResponses, RevertEvaluationHistoryErrors, ThrowOnError> => (options.client ?? client).post<RevertEvaluationHistoryResponses, RevertEvaluationHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/evaluation-history/{evaluation_history_uuid}/revert',
    ...options
});

/**
 * Delete Highlight
 *
 * DELETE /api/v2/highlights/{highlight_uuid}
 */
export const deleteHighlight = <ThrowOnError extends boolean = false>(options: Options<DeleteHighlightData, ThrowOnError>): RequestResult<DeleteHighlightResponses, DeleteHighlightErrors, ThrowOnError> => (options.client ?? client).delete<DeleteHighlightResponses, DeleteHighlightErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/highlights/{highlight_uuid}',
    ...options
});

/**
 * Put Highlight
 *
 * PUT /api/v2/highlights/{highlight_uuid}
 */
export const putHighlight = <ThrowOnError extends boolean = false>(options: Options<PutHighlightData, ThrowOnError>): RequestResult<PutHighlightResponses, PutHighlightErrors, ThrowOnError> => (options.client ?? client).put<PutHighlightResponses, PutHighlightErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/highlights/{highlight_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Introduction Template
 *
 * DELETE /api/v2/introduction-templates/{template_uuid}
 */
export const deleteIntroductionTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteIntroductionTemplateData, ThrowOnError>): RequestResult<DeleteIntroductionTemplateResponses, DeleteIntroductionTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIntroductionTemplateResponses, DeleteIntroductionTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/introduction-templates/{template_uuid}',
    ...options
});

/**
 * Put Introduction Template
 *
 * PUT /api/v2/introduction-templates/{template_uuid}
 */
export const putIntroductionTemplate = <ThrowOnError extends boolean = false>(options: Options<PutIntroductionTemplateData, ThrowOnError>): RequestResult<PutIntroductionTemplateResponses, PutIntroductionTemplateErrors, ThrowOnError> => (options.client ?? client).put<PutIntroductionTemplateResponses, PutIntroductionTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/introduction-templates/{template_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Linkedin Sync Candidate
 *
 * POST /api/v2/linkedin_sync/candidates/{candidate_id}
 *
 * Pull the candidate's LinkedIn profile into their resume, headline and photo.
 * The photo is filled in when the candidate has none; with `replace_photo` it
 * replaces the current one. A profile fetched within the last hour (by a
 * preview, typically) is used instead of fetching it again. Otherwise the
 * provider serves its stored copy, however old, unless `fresh` asks it to
 * re-read one it last saw over a month ago (about one credit more). The body
 * is optional: without one, both options are off. 204 means LinkedIn had
 * nothing new for the resume; the headline and photo may still have changed.
 * 404 means LinkedIn has no profile at the candidate's link, and 503 without
 * Retry-After that lookups are out of credits. 503 with Retry-After means
 * LinkedIn is slow: the sync finishes in the background, and syncing again a
 * minute later uses what it fetched.
 */
export const postLinkedinSyncCandidate = <ThrowOnError extends boolean = false>(options: Options<PostLinkedinSyncCandidateData, ThrowOnError>): RequestResult<PostLinkedinSyncCandidateResponses, PostLinkedinSyncCandidateErrors, ThrowOnError> => (options.client ?? client).post<PostLinkedinSyncCandidateResponses, PostLinkedinSyncCandidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/linkedin_sync/candidates/{candidate_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Linkedin Preview
 *
 * POST /api/v2/linkedin_sync/preview
 *
 * Show a LinkedIn profile before anyone syncs it onto a candidate: by its URL,
 * or found by name and company. Writes nothing to any candidate. The fetch is
 * kept as a profile-cache entry, so syncing the same profile straight after
 * costs no second lookup. 503 with Retry-After means LinkedIn is slow: the
 * fetch finishes in the background and previewing again uses what it stored.
 */
export const postLinkedinPreview = <ThrowOnError extends boolean = false>(options: Options<PostLinkedinPreviewData, ThrowOnError>): RequestResult<PostLinkedinPreviewResponses, PostLinkedinPreviewErrors, ThrowOnError> => (options.client ?? client).post<PostLinkedinPreviewResponses, PostLinkedinPreviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/linkedin_sync/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Autotag Preview
 *
 * POST /api/v2/candidates/autotag/preview
 *
 * Enqueue async tagging of the call notes (+ optional identity), or of a Notion
 * meeting-note row when `notion_page_id` is given (notes + identity read from Notion).
 * Writes nothing; returns a task_id to poll for the proposal.
 */
export const postAutotagPreview = <ThrowOnError extends boolean = false>(options: Options<PostAutotagPreviewData, ThrowOnError>): RequestResult<PostAutotagPreviewResponses, PostAutotagPreviewErrors, ThrowOnError> => (options.client ?? client).post<PostAutotagPreviewResponses, PostAutotagPreviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/autotag/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Autotag Preview Status
 *
 * GET /api/v2/candidates/autotag/preview/status/{task_id}
 *
 * Return the TagProposal once the task completes.
 * Task states: PENDING, SUCCESS, FAILURE.
 */
export const getAutotagPreviewStatus = <ThrowOnError extends boolean = false>(options: Options<GetAutotagPreviewStatusData, ThrowOnError>): RequestResult<GetAutotagPreviewStatusResponses, GetAutotagPreviewStatusErrors, ThrowOnError> => (options.client ?? client).get<GetAutotagPreviewStatusResponses, GetAutotagPreviewStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/candidates/autotag/preview/status/{task_id}',
    ...options
});

/**
 * Post Pipelines Filter
 *
 * POST /api/v2/pipelines/filter
 */
export const postPipelinesFilter = <ThrowOnError extends boolean = false>(options: Options<PostPipelinesFilterData, ThrowOnError>): RequestResult<PostPipelinesFilterResponses, PostPipelinesFilterErrors, ThrowOnError> => (options.client ?? client).post<PostPipelinesFilterResponses, PostPipelinesFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/pipelines/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Multiple Recommendation Drafts
 *
 * PUT /api/v2/recommendations/drafts
 */
export const putMultipleRecommendationDrafts = <ThrowOnError extends boolean = false>(options: Options<PutMultipleRecommendationDraftsData, ThrowOnError>): RequestResult<PutMultipleRecommendationDraftsResponses, PutMultipleRecommendationDraftsErrors, ThrowOnError> => (options.client ?? client).put<PutMultipleRecommendationDraftsResponses, PutMultipleRecommendationDraftsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/recommendations/drafts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Recommendation
 *
 * DELETE /api/v2/recommendations/{recommendation_uuid}
 */
export const deleteRecommendation = <ThrowOnError extends boolean = false>(options: Options<DeleteRecommendationData, ThrowOnError>): RequestResult<DeleteRecommendationResponses, DeleteRecommendationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRecommendationResponses, DeleteRecommendationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/recommendations/{recommendation_uuid}',
    ...options
});

/**
 * Get Recommendation
 *
 * GET /api/v2/recommendations/{recommendation_uuid}
 */
export const getRecommendation = <ThrowOnError extends boolean = false>(options: Options<GetRecommendationData, ThrowOnError>): RequestResult<GetRecommendationResponses, GetRecommendationErrors, ThrowOnError> => (options.client ?? client).get<GetRecommendationResponses, GetRecommendationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/recommendations/{recommendation_uuid}',
    ...options
});

/**
 * Put Recommendation Commentary
 *
 * PUT /api/v2/recommendations/{recommendation_uuid}/commentary
 */
export const putRecommendationCommentary = <ThrowOnError extends boolean = false>(options: Options<PutRecommendationCommentaryData, ThrowOnError>): RequestResult<PutRecommendationCommentaryResponses, PutRecommendationCommentaryErrors, ThrowOnError> => (options.client ?? client).put<PutRecommendationCommentaryResponses, PutRecommendationCommentaryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/recommendations/{recommendation_uuid}/commentary',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Recommendation Status V2
 *
 * PUT /api/v2/recommendations/{recommendation_uuid}/status
 */
export const putRecommendationStatusV2 = <ThrowOnError extends boolean = false>(options: Options<PutRecommendationStatusV2Data, ThrowOnError>): RequestResult<PutRecommendationStatusV2Responses, PutRecommendationStatusV2Errors, ThrowOnError> => (options.client ?? client).put<PutRecommendationStatusV2Responses, PutRecommendationStatusV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/recommendations/{recommendation_uuid}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Recommendation Assignee
 *
 * DELETE /api/v2/recommendations/{recommendation_uuid}/assignee
 */
export const deleteRecommendationAssignee = <ThrowOnError extends boolean = false>(options: Options<DeleteRecommendationAssigneeData, ThrowOnError>): RequestResult<DeleteRecommendationAssigneeResponses, DeleteRecommendationAssigneeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRecommendationAssigneeResponses, DeleteRecommendationAssigneeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/recommendations/{recommendation_uuid}/assignee',
    ...options
});

/**
 * Post Recsys Recommendations
 *
 * POST /api/v2/integrations/recsys/recommendations
 *
 * Receive candidate suggestions from the RecSys (Brief Match) app and add them
 * to a pipeline's internal view as `suggested` draft recommendations. The
 * sending advisor (`author_person_uuid`) is recorded as the actor for the
 * submission, recommendation, evaluation history and internal comment. Each
 * candidate may carry its own `assignee_person_uuid` (the advisor the draft is
 * assigned to); it defaults to the author when omitted. The call is idempotent:
 * candidates already on the pipeline are skipped. Candidates off-limits to the
 * pipeline's search team are never added; they come back in `off_limits`.
 */
export const postRecsysRecommendations = <ThrowOnError extends boolean = false>(options: Options<PostRecsysRecommendationsData, ThrowOnError>): RequestResult<PostRecsysRecommendationsResponses, PostRecsysRecommendationsErrors, ThrowOnError> => (options.client ?? client).post<PostRecsysRecommendationsResponses, PostRecsysRecommendationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'X-RecSys-API-Key', type: 'apiKey' }],
    url: '/api/v2/integrations/recsys/recommendations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Recsys Candidate Context
 *
 * POST /api/v2/integrations/recsys/candidate-team-context
 *
 * Team-relationship context for a batch of (candidate, pipeline) pairs: a `warm`
 * flag, the most significant `last_action` between the candidate and the pipeline's
 * search team (a facilitated introduction, else being added to a recommendation),
 * and candidate-level referrers.
 *
 * Read-only sibling of the recsys write bridge (`.../recommendations`,
 * `.../assignees`), authenticated by the same `X-RecSys-API-Key` service key so the
 * RecSys (Brief Match) app can surface this context alongside its recommendations
 * without a team-scoped user session.
 *
 * Pairs let one request cover every RecSys surface: a pipeline's candidate slate
 * (one pipeline, many candidates), a candidate's opportunity queue / pipeline
 * targets (one candidate, many pipelines), or an arbitrary mix. Warmth and
 * last-action mirror the warm_case + priority logic of the internal
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates view — computed
 * set-based here (see _batch_team_context) so the batch resolves in a few queries
 * regardless of team count, rather than one per team. The exec-only intro paths still
 * reuse that view's shared helper. Net: the numbers match what advisors see in Contender.
 */
export const postRecsysCandidateContext = <ThrowOnError extends boolean = false>(options: Options<PostRecsysCandidateContextData, ThrowOnError>): RequestResult<PostRecsysCandidateContextResponses, PostRecsysCandidateContextErrors, ThrowOnError> => (options.client ?? client).post<PostRecsysCandidateContextResponses, PostRecsysCandidateContextErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'X-RecSys-API-Key', type: 'apiKey' }],
    url: '/api/v2/integrations/recsys/candidate-team-context',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Recsys Assignees
 *
 * GET /api/v2/integrations/recsys/assignees
 *
 * The advisors a RecSys suggestion can be assigned to — the internal
 * customer-success team, i.e. the same set the webapp's assignee picker and
 * `GET /api/v2/people/internal/customer_success` return. Exposed under the RecSys
 * service key so Brief Match can fetch valid options for whichever environment it
 * is sending to.
 */
export const getRecsysAssignees = <ThrowOnError extends boolean = false>(options?: Options<GetRecsysAssigneesData, ThrowOnError>): RequestResult<GetRecsysAssigneesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRecsysAssigneesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'X-RecSys-API-Key', type: 'apiKey' }],
    url: '/api/v2/integrations/recsys/assignees',
    ...options
});

/**
 * Post Submissions Filter
 *
 * POST /api/v2/submissions/filter
 */
export const postSubmissionsFilter = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionsFilterData, ThrowOnError>): RequestResult<PostSubmissionsFilterResponses, PostSubmissionsFilterErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionsFilterResponses, PostSubmissionsFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/submissions/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Submission Filter
 *
 * POST /api/v2/submissions/{submission_uuid}/filter
 */
export const postSubmissionFilter = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionFilterData, ThrowOnError>): RequestResult<PostSubmissionFilterResponses, PostSubmissionFilterErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionFilterResponses, PostSubmissionFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/submissions/{submission_uuid}/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Teams V2
 *
 * POST /api/v2/teams
 */
export const postTeamsV2 = <ThrowOnError extends boolean = false>(options: Options<PostTeamsV2Data, ThrowOnError>): RequestResult<PostTeamsV2Responses, PostTeamsV2Errors, ThrowOnError> => (options.client ?? client).post<PostTeamsV2Responses, PostTeamsV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Team
 *
 * PUT /api/v2/teams/{team_slug}
 */
export const putTeam = <ThrowOnError extends boolean = false>(options: Options<PutTeamData, ThrowOnError>): RequestResult<PutTeamResponses, PutTeamErrors, ThrowOnError> => (options.client ?? client).put<PutTeamResponses, PutTeamErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Teams Filter
 *
 * POST /api/v2/teams/filter
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTeamsFilter = <ThrowOnError extends boolean = false>(options: Options<PostTeamsFilterData, ThrowOnError>): RequestResult<PostTeamsFilterResponses, PostTeamsFilterErrors, ThrowOnError> => (options.client ?? client).post<PostTeamsFilterResponses, PostTeamsFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Teams Suggested
 *
 * POST /api/v2/teams/suggested
 *
 * The top of the ranked team-suggestion pool for a trending campaign for one
 * candidate: the trending hygiene exclusions (empty / inactive / basic-investor
 * teams, illegal trending teams, off-limits, teams that declined this
 * candidate, teams already trended to) followed by the backtested hybrid
 * scorer (see app/helpers/team_suggestions.py). Serves the compact "don't miss
 * these teams" module; the wizard's browsable list uses the same ranking
 * through POST /api/v2/teams/filter `suggested`, which pages the whole pool and
 * composes it with phrase and filters.
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postTeamsSuggested = <ThrowOnError extends boolean = false>(options: Options<PostTeamsSuggestedData, ThrowOnError>): RequestResult<PostTeamsSuggestedResponses, PostTeamsSuggestedErrors, ThrowOnError> => (options.client ?? client).post<PostTeamsSuggestedResponses, PostTeamsSuggestedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/suggested',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Teams
 *
 * POST /api/v2/teams/{team_uuid}/teams
 */
export const postTeamTeams = <ThrowOnError extends boolean = false>(options: Options<PostTeamTeamsData, ThrowOnError>): RequestResult<PostTeamTeamsResponses, PostTeamTeamsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamTeamsResponses, PostTeamTeamsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Candidate
 *
 * GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}
 */
export const getTeamCandidate = <ThrowOnError extends boolean = false>(options: Options<GetTeamCandidateData, ThrowOnError>): RequestResult<GetTeamCandidateResponses, GetTeamCandidateErrors, ThrowOnError> => (options.client ?? client).get<GetTeamCandidateResponses, GetTeamCandidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/candidates/{candidate_uuid}',
    ...options
});

/**
 * Get Team Candidate Activity
 *
 * GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/activity
 */
export const getTeamCandidateActivity = <ThrowOnError extends boolean = false>(options: Options<GetTeamCandidateActivityData, ThrowOnError>): RequestResult<GetTeamCandidateActivityResponses, GetTeamCandidateActivityErrors, ThrowOnError> => (options.client ?? client).get<GetTeamCandidateActivityResponses, GetTeamCandidateActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/activity',
    ...options
});

/**
 * Post Team Candidate Favorite
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/favorite
 */
export const postTeamCandidateFavorite = <ThrowOnError extends boolean = false>(options: Options<PostTeamCandidateFavoriteData, ThrowOnError>): RequestResult<PostTeamCandidateFavoriteResponses, PostTeamCandidateFavoriteErrors, ThrowOnError> => (options.client ?? client).post<PostTeamCandidateFavoriteResponses, PostTeamCandidateFavoriteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/favorite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Candidate Pipelines
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/pipelines
 */
export const postTeamCandidatePipelines = <ThrowOnError extends boolean = false>(options: Options<PostTeamCandidatePipelinesData, ThrowOnError>): RequestResult<PostTeamCandidatePipelinesResponses, PostTeamCandidatePipelinesErrors, ThrowOnError> => (options.client ?? client).post<PostTeamCandidatePipelinesResponses, PostTeamCandidatePipelinesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/pipelines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Candidate Recommendations
 *
 * GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/recommendations
 */
export const getTeamCandidateRecommendations = <ThrowOnError extends boolean = false>(options: Options<GetTeamCandidateRecommendationsData, ThrowOnError>): RequestResult<GetTeamCandidateRecommendationsResponses, GetTeamCandidateRecommendationsErrors, ThrowOnError> => (options.client ?? client).get<GetTeamCandidateRecommendationsResponses, GetTeamCandidateRecommendationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/recommendations',
    ...options
});

/**
 * Post Team Candidate Status
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/status
 */
export const postTeamCandidateStatus = <ThrowOnError extends boolean = false>(options: Options<PostTeamCandidateStatusData, ThrowOnError>): RequestResult<PostTeamCandidateStatusResponses, PostTeamCandidateStatusErrors, ThrowOnError> => (options.client ?? client).post<PostTeamCandidateStatusResponses, PostTeamCandidateStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Team Candidate Status
 *
 * PUT /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/status
 */
export const putTeamCandidateStatus = <ThrowOnError extends boolean = false>(options: Options<PutTeamCandidateStatusData, ThrowOnError>): RequestResult<PutTeamCandidateStatusResponses, PutTeamCandidateStatusErrors, ThrowOnError> => (options.client ?? client).put<PutTeamCandidateStatusResponses, PutTeamCandidateStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Candidate Views
 *
 * POST /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/views
 */
export const postTeamCandidateViews = <ThrowOnError extends boolean = false>(options: Options<PostTeamCandidateViewsData, ThrowOnError>): RequestResult<PostTeamCandidateViewsResponses, PostTeamCandidateViewsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamCandidateViewsResponses, PostTeamCandidateViewsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/candidates/{candidate_uuid}/views',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Contact Comments
 *
 * GET /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments
 *
 * Every live comment this team has on this contact, newest first.
 */
export const getTeamContactComments = <ThrowOnError extends boolean = false>(options: Options<GetTeamContactCommentsData, ThrowOnError>): RequestResult<GetTeamContactCommentsResponses, GetTeamContactCommentsErrors, ThrowOnError> => (options.client ?? client).get<GetTeamContactCommentsResponses, GetTeamContactCommentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments',
    ...options
});

/**
 * Post Team Contact Comment
 *
 * POST /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments
 */
export const postTeamContactComment = <ThrowOnError extends boolean = false>(options: Options<PostTeamContactCommentData, ThrowOnError>): RequestResult<PostTeamContactCommentResponses, PostTeamContactCommentErrors, ThrowOnError> => (options.client ?? client).post<PostTeamContactCommentResponses, PostTeamContactCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Team Contact Comment
 *
 * DELETE /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments/{comment_uuid}
 *
 * Soft delete (sets ``deleted_at``); author-only.
 */
export const deleteTeamContactComment = <ThrowOnError extends boolean = false>(options: Options<DeleteTeamContactCommentData, ThrowOnError>): RequestResult<DeleteTeamContactCommentResponses, DeleteTeamContactCommentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTeamContactCommentResponses, DeleteTeamContactCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments/{comment_uuid}',
    ...options
});

/**
 * Put Team Contact Comment
 *
 * PUT /api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments/{comment_uuid}
 */
export const putTeamContactComment = <ThrowOnError extends boolean = false>(options: Options<PutTeamContactCommentData, ThrowOnError>): RequestResult<PutTeamContactCommentResponses, PutTeamContactCommentErrors, ThrowOnError> => (options.client ?? client).put<PutTeamContactCommentResponses, PutTeamContactCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/contacts/{identity_uuid}/comments/{comment_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Company Contact Tags
 *
 * GET /api/v2/companies/{company_id}/contacts/tags — list company tag vocabulary.
 */
export const listCompanyContactTags = <ThrowOnError extends boolean = false>(options: Options<ListCompanyContactTagsData, ThrowOnError>): RequestResult<ListCompanyContactTagsResponses, ListCompanyContactTagsErrors, ThrowOnError> => (options.client ?? client).get<ListCompanyContactTagsResponses, ListCompanyContactTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/companies/{company_id}/contacts/tags',
    ...options
});

/**
 * Add Company Contact Tag
 *
 * POST .../contacts/{candidate_uuid}/tags — link one tag to a candidate.
 */
export const addCompanyContactTag = <ThrowOnError extends boolean = false>(options: Options<AddCompanyContactTagData, ThrowOnError>): RequestResult<AddCompanyContactTagResponses, AddCompanyContactTagErrors, ThrowOnError> => (options.client ?? client).post<AddCompanyContactTagResponses, AddCompanyContactTagErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/companies/{company_id}/contacts/{candidate_uuid}/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Company Contact Tag
 *
 * DELETE .../contacts/{candidate_uuid}/tags/{tag_definition_uuid}.
 */
export const removeCompanyContactTag = <ThrowOnError extends boolean = false>(options: Options<RemoveCompanyContactTagData, ThrowOnError>): RequestResult<RemoveCompanyContactTagResponses, RemoveCompanyContactTagErrors, ThrowOnError> => (options.client ?? client).delete<RemoveCompanyContactTagResponses, RemoveCompanyContactTagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/companies/{company_id}/contacts/{candidate_uuid}/tags/{tag_definition_uuid}',
    ...options
});

/**
 * Post Team Pipelines
 *
 * POST /api/v2/teams/{team_uuid}/pipelines
 *
 * Also reachable by the Contender Actions connector (service key + acting
 * user), which always sends ``is_notification_enabled: false``.
 */
export const postTeamPipelines = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelinesData, ThrowOnError>): RequestResult<PostTeamPipelinesResponses, PostTeamPipelinesErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelinesResponses, PostTeamPipelinesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Pipeline
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}
 */
export const getTeamPipeline = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelineData, ThrowOnError>): RequestResult<GetTeamPipelineResponses, GetTeamPipelineErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelineResponses, GetTeamPipelineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}',
    ...options
});

/**
 * Put Team Pipeline
 *
 * PUT /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}
 */
export const putTeamPipeline = <ThrowOnError extends boolean = false>(options: Options<PutTeamPipelineData, ThrowOnError>): RequestResult<PutTeamPipelineResponses, PutTeamPipelineErrors, ThrowOnError> => (options.client ?? client).put<PutTeamPipelineResponses, PutTeamPipelineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Pipeline Views
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/views
 */
export const postTeamPipelineViews = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelineViewsData, ThrowOnError>): RequestResult<PostTeamPipelineViewsResponses, PostTeamPipelineViewsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelineViewsResponses, PostTeamPipelineViewsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/views',
    ...options
});

/**
 * Get Team Pipeline Candidates
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates
 */
export const getTeamPipelineCandidates = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelineCandidatesData, ThrowOnError>): RequestResult<GetTeamPipelineCandidatesResponses, GetTeamPipelineCandidatesErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelineCandidatesResponses, GetTeamPipelineCandidatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates',
    ...options
});

/**
 * Post Pipeline Candidates
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates
 */
export const postPipelineCandidates = <ThrowOnError extends boolean = false>(options: Options<PostPipelineCandidatesData, ThrowOnError>): RequestResult<PostPipelineCandidatesResponses, PostPipelineCandidatesErrors, ThrowOnError> => (options.client ?? client).post<PostPipelineCandidatesResponses, PostPipelineCandidatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Pipeline Candidates Off Limits
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates/off_limits
 */
export const getTeamPipelineCandidatesOffLimits = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelineCandidatesOffLimitsData, ThrowOnError>): RequestResult<GetTeamPipelineCandidatesOffLimitsResponses, GetTeamPipelineCandidatesOffLimitsErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelineCandidatesOffLimitsResponses, GetTeamPipelineCandidatesOffLimitsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/candidates/off_limits',
    ...options
});

/**
 * Post Team Pipeline Submission
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/submissions
 */
export const postTeamPipelineSubmission = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelineSubmissionData, ThrowOnError>): RequestResult<PostTeamPipelineSubmissionResponses, PostTeamPipelineSubmissionErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelineSubmissionResponses, PostTeamPipelineSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Tailored Highlights
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/tailored-highlights
 *
 * Queue AI-drafted highlights for one candidate, written for this pipeline from
 * its details, the candidate's LinkedIn resume and their advisor-written
 * highlights and Abouts. Poll `status_url`.
 */
export const postTailoredHighlights = <ThrowOnError extends boolean = false>(options: Options<PostTailoredHighlightsData, ThrowOnError>): RequestResult<PostTailoredHighlightsResponses, PostTailoredHighlightsErrors, ThrowOnError> => (options.client ?? client).post<PostTailoredHighlightsResponses, PostTailoredHighlightsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/tailored-highlights',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Tailored Highlights Status
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/tailored-highlights/status/{task_id}
 *
 * The drafts once the task has finished. States: PENDING, SUCCESS, FAILURE.
 */
export const getTailoredHighlightsStatus = <ThrowOnError extends boolean = false>(options: Options<GetTailoredHighlightsStatusData, ThrowOnError>): RequestResult<GetTailoredHighlightsStatusResponses, GetTailoredHighlightsStatusErrors, ThrowOnError> => (options.client ?? client).get<GetTailoredHighlightsStatusResponses, GetTailoredHighlightsStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/tailored-highlights/status/{task_id}',
    ...options
});

/**
 * Get Team Pipeline Recommendation
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}
 */
export const getTeamPipelineRecommendation = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelineRecommendationData, ThrowOnError>): RequestResult<GetTeamPipelineRecommendationResponses, GetTeamPipelineRecommendationErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelineRecommendationResponses, GetTeamPipelineRecommendationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}',
    ...options
});

/**
 * Put Team Pipeline Recommendation Intro Email Type
 *
 * PUT /api/v2/teams/{team_slug}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}
 */
export const putTeamPipelineRecommendationIntroEmailType = <ThrowOnError extends boolean = false>(options: Options<PutTeamPipelineRecommendationIntroEmailTypeData, ThrowOnError>): RequestResult<PutTeamPipelineRecommendationIntroEmailTypeResponses, PutTeamPipelineRecommendationIntroEmailTypeErrors, ThrowOnError> => (options.client ?? client).put<PutTeamPipelineRecommendationIntroEmailTypeResponses, PutTeamPipelineRecommendationIntroEmailTypeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Pipeline Recommendation Comments
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/comments
 */
export const postTeamPipelineRecommendationComments = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelineRecommendationCommentsData, ThrowOnError>): RequestResult<PostTeamPipelineRecommendationCommentsResponses, PostTeamPipelineRecommendationCommentsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelineRecommendationCommentsResponses, PostTeamPipelineRecommendationCommentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Pipeline Recommendation Dislike
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/dislike
 */
export const postTeamPipelineRecommendationDislike = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelineRecommendationDislikeData, ThrowOnError>): RequestResult<PostTeamPipelineRecommendationDislikeResponses, PostTeamPipelineRecommendationDislikeErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelineRecommendationDislikeResponses, PostTeamPipelineRecommendationDislikeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/dislike',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Pipeline Recommendation Favorite
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/favorite
 */
export const postTeamPipelineRecommendationFavorite = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelineRecommendationFavoriteData, ThrowOnError>): RequestResult<PostTeamPipelineRecommendationFavoriteResponses, PostTeamPipelineRecommendationFavoriteErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelineRecommendationFavoriteResponses, PostTeamPipelineRecommendationFavoriteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/favorite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Pipeline Recommendation Views
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/views
 */
export const postTeamPipelineRecommendationViews = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelineRecommendationViewsData, ThrowOnError>): RequestResult<PostTeamPipelineRecommendationViewsResponses, PostTeamPipelineRecommendationViewsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelineRecommendationViewsResponses, PostTeamPipelineRecommendationViewsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/views',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Pipeline Recommendation Internal Comments
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/internal-comments
 */
export const getTeamPipelineRecommendationInternalComments = <ThrowOnError extends boolean = false>(options: Options<GetTeamPipelineRecommendationInternalCommentsData, ThrowOnError>): RequestResult<GetTeamPipelineRecommendationInternalCommentsResponses, GetTeamPipelineRecommendationInternalCommentsErrors, ThrowOnError> => (options.client ?? client).get<GetTeamPipelineRecommendationInternalCommentsResponses, GetTeamPipelineRecommendationInternalCommentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/internal-comments',
    ...options
});

/**
 * Post Team Pipeline Recommendation Internal Comments
 *
 * POST /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/internal-comments
 */
export const postTeamPipelineRecommendationInternalComments = <ThrowOnError extends boolean = false>(options: Options<PostTeamPipelineRecommendationInternalCommentsData, ThrowOnError>): RequestResult<PostTeamPipelineRecommendationInternalCommentsResponses, PostTeamPipelineRecommendationInternalCommentsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamPipelineRecommendationInternalCommentsResponses, PostTeamPipelineRecommendationInternalCommentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recommendations/{recommendation_uuid}/internal-comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Recsys Pipeline Recommendations
 *
 * GET /api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recsys-recommendations
 *
 * Fetch the RecSys (Brief Match) scheduler-computed recommendations for this pipeline and
 * hydrate each into Contender candidate data. Read-through: nothing is stored on the Contender
 * side. `already_on_pipeline` flags candidates already recommended on this pipeline (so the UI
 * can disable "Add as draft"). Empty when RecSys has no run for the pipeline yet; a 502/503 when
 * the RecSys service is unavailable or unconfigured.
 */
export const getRecsysPipelineRecommendations = <ThrowOnError extends boolean = false>(options: Options<GetRecsysPipelineRecommendationsData, ThrowOnError>): RequestResult<GetRecsysPipelineRecommendationsResponses, GetRecsysPipelineRecommendationsErrors, ThrowOnError> => (options.client ?? client).get<GetRecsysPipelineRecommendationsResponses, GetRecsysPipelineRecommendationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recsys-recommendations',
    ...options
});

/**
 * Post Recsys Recommendation Feedback
 *
 * POST .../pipelines/{pipeline_uuid}/recsys-recommendations/{recommendation_id}/feedback
 *
 * Record Good/Bad feedback on a RecSys recommendation, proxied to the RecSys feedback routine
 * (persists there and steers future runs). `recommendation_id` is the id returned by the fetch
 * endpoint. Read-through: nothing is stored on the Contender side.
 */
export const postRecsysRecommendationFeedback = <ThrowOnError extends boolean = false>(options: Options<PostRecsysRecommendationFeedbackData, ThrowOnError>): RequestResult<PostRecsysRecommendationFeedbackResponses, PostRecsysRecommendationFeedbackErrors, ThrowOnError> => (options.client ?? client).post<PostRecsysRecommendationFeedbackResponses, PostRecsysRecommendationFeedbackErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/pipelines/{pipeline_uuid}/recsys-recommendations/{recommendation_id}/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Trending
 *
 * GET /api/v2/teams/{team_uuid}/trending
 */
export const getTeamTrending = <ThrowOnError extends boolean = false>(options: Options<GetTeamTrendingData, ThrowOnError>): RequestResult<GetTeamTrendingResponses, GetTeamTrendingErrors, ThrowOnError> => (options.client ?? client).get<GetTeamTrendingResponses, GetTeamTrendingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/trending',
    ...options
});

/**
 * Get Team Trending Recommendation
 *
 * GET /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}
 */
export const getTeamTrendingRecommendation = <ThrowOnError extends boolean = false>(options: Options<GetTeamTrendingRecommendationData, ThrowOnError>): RequestResult<GetTeamTrendingRecommendationResponses, GetTeamTrendingRecommendationErrors, ThrowOnError> => (options.client ?? client).get<GetTeamTrendingRecommendationResponses, GetTeamTrendingRecommendationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/trending/{recommendation_uuid}',
    ...options
});

/**
 * Get Team Trending Recommendation Activity
 *
 * GET /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/activity
 */
export const getTeamTrendingRecommendationActivity = <ThrowOnError extends boolean = false>(options: Options<GetTeamTrendingRecommendationActivityData, ThrowOnError>): RequestResult<GetTeamTrendingRecommendationActivityResponses, GetTeamTrendingRecommendationActivityErrors, ThrowOnError> => (options.client ?? client).get<GetTeamTrendingRecommendationActivityResponses, GetTeamTrendingRecommendationActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/activity',
    ...options
});

/**
 * Get Team Trending Recommendation Comments
 *
 * GET /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/comments
 */
export const getTeamTrendingRecommendationComments = <ThrowOnError extends boolean = false>(options: Options<GetTeamTrendingRecommendationCommentsData, ThrowOnError>): RequestResult<GetTeamTrendingRecommendationCommentsResponses, GetTeamTrendingRecommendationCommentsErrors, ThrowOnError> => (options.client ?? client).get<GetTeamTrendingRecommendationCommentsResponses, GetTeamTrendingRecommendationCommentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/comments',
    ...options
});

/**
 * Post Team Trending Recommendation Comments
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/comments
 */
export const postTeamTrendingRecommendationComments = <ThrowOnError extends boolean = false>(options: Options<PostTeamTrendingRecommendationCommentsData, ThrowOnError>): RequestResult<PostTeamTrendingRecommendationCommentsResponses, PostTeamTrendingRecommendationCommentsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamTrendingRecommendationCommentsResponses, PostTeamTrendingRecommendationCommentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Trending Recommendation Dislike
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/dislike
 */
export const postTeamTrendingRecommendationDislike = <ThrowOnError extends boolean = false>(options: Options<PostTeamTrendingRecommendationDislikeData, ThrowOnError>): RequestResult<PostTeamTrendingRecommendationDislikeResponses, PostTeamTrendingRecommendationDislikeErrors, ThrowOnError> => (options.client ?? client).post<PostTeamTrendingRecommendationDislikeResponses, PostTeamTrendingRecommendationDislikeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/dislike',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Trending Recommendation Favorite
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/favorite
 */
export const postTeamTrendingRecommendationFavorite = <ThrowOnError extends boolean = false>(options: Options<PostTeamTrendingRecommendationFavoriteData, ThrowOnError>): RequestResult<PostTeamTrendingRecommendationFavoriteResponses, PostTeamTrendingRecommendationFavoriteErrors, ThrowOnError> => (options.client ?? client).post<PostTeamTrendingRecommendationFavoriteResponses, PostTeamTrendingRecommendationFavoriteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/favorite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Trending Recommendation Views
 *
 * POST /api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/views
 */
export const postTeamTrendingRecommendationViews = <ThrowOnError extends boolean = false>(options: Options<PostTeamTrendingRecommendationViewsData, ThrowOnError>): RequestResult<PostTeamTrendingRecommendationViewsResponses, PostTeamTrendingRecommendationViewsErrors, ThrowOnError> => (options.client ?? client).post<PostTeamTrendingRecommendationViewsResponses, PostTeamTrendingRecommendationViewsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/trending/{recommendation_uuid}/views',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Merge
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/merge
 *
 * Merge another candidate record (``source_candidate_uuid``) into this one:
 * recommendations, highlights, activity and every other row that points at
 * the source move here; the source's identity is folded into this record's
 * identity (logins, referrals, feedback, email events, with a log row and a
 * signpost); the source is deactivated, its email released, and it points at
 * this record through ``merged_into_uuid``. Not undoable.
 *
 * ``dry_run`` reports counts per table and blockers and writes nothing. A
 * real merge with a blocker is a 409 with the same body. Merging a record
 * into itself is a 422. Reachable by the webapp and by the Contender Actions
 * connector acting for a named advisor.
 */
export const postCandidateMerge = <ThrowOnError extends boolean = false>(options: Options<PostCandidateMergeData, ThrowOnError>): RequestResult<PostCandidateMergeResponses, PostCandidateMergeErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateMergeResponses, PostCandidateMergeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get New Candidates
 *
 * GET /api/v2/admin/candidates/new
 */
export const getNewCandidates = <ThrowOnError extends boolean = false>(options?: Options<GetNewCandidatesData, ThrowOnError>): RequestResult<GetNewCandidatesResponses, GetNewCandidatesErrors, ThrowOnError> => (options?.client ?? client).get<GetNewCandidatesResponses, GetNewCandidatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/new',
    ...options
});

/**
 * Find Identity
 *
 * GET /api/v2/admin/identities?person_uuid=… | ?candidate_uuid=…
 *
 * The identity a login or a candidate belongs to. Pass exactly one of the
 * two; passing both or neither is a 422.
 */
export const findIdentity = <ThrowOnError extends boolean = false>(options?: Options<FindIdentityData, ThrowOnError>): RequestResult<FindIdentityResponses, FindIdentityErrors, ThrowOnError> => (options?.client ?? client).get<FindIdentityResponses, FindIdentityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities',
    ...options
});

/**
 * Post Identity
 *
 * POST /api/v2/admin/identities
 *
 * A new human with its first login: an executive (activated, with no
 * candidate profile; one can be attached later), an enterprise user (on the
 * team given, or none yet) or an admin. Refused (409) when the email is
 * already a login, or is on a candidate profile (the login belongs to that
 * person), with that identity in the detail.
 */
export const postIdentity = <ThrowOnError extends boolean = false>(options: Options<PostIdentityData, ThrowOnError>): RequestResult<PostIdentityResponses, PostIdentityErrors, ThrowOnError> => (options.client ?? client).post<PostIdentityResponses, PostIdentityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Identity
 *
 * GET /api/v2/admin/identities/{identity_uuid}
 *
 * Every login in the identity, the activated executive first, plus the one
 * candidate it holds, if any.
 */
export const getIdentity = <ThrowOnError extends boolean = false>(options: Options<GetIdentityData, ThrowOnError>): RequestResult<GetIdentityResponses, GetIdentityErrors, ThrowOnError> => (options.client ?? client).get<GetIdentityResponses, GetIdentityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities/{identity_uuid}',
    ...options
});

/**
 * Get Identity Email Events
 *
 * GET /api/v2/admin/identities/{identity_uuid}/email-events
 *
 * Every email sent to this human, one item per email with its lifecycle
 * (delivered, opened, clicked, bounced or dropped). Newest send first.
 *
 * An email belongs to the identity stamped on it at send time, so the emails
 * sent to each of the human's logins, at whatever address, are all here.
 * Pass `batch_uuid` to keep one send run, `event_uuid` to keep the emails
 * about one event, `email_event_type` to keep some kinds of email (summaries,
 * invites), `sendgrid_event` to keep only the emails delivered, opened,
 * bounced and so on.
 */
export const getIdentityEmailEvents = <ThrowOnError extends boolean = false>(options: Options<GetIdentityEmailEventsData, ThrowOnError>): RequestResult<GetIdentityEmailEventsResponses, GetIdentityEmailEventsErrors, ThrowOnError> => (options.client ?? client).get<GetIdentityEmailEventsResponses, GetIdentityEmailEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities/{identity_uuid}/email-events',
    ...options
});

/**
 * Post Identity Person
 *
 * POST /api/v2/admin/identities/{identity_uuid}/persons
 *
 * Move a login into this identity. Membership only: a login becomes the
 * candidate's executive by being activated, not by being added. 409 when the
 * login already shares a different candidate or a second activated executive
 * would result.
 */
export const postIdentityPerson = <ThrowOnError extends boolean = false>(options: Options<PostIdentityPersonData, ThrowOnError>): RequestResult<PostIdentityPersonResponses, PostIdentityPersonErrors, ThrowOnError> => (options.client ?? client).post<PostIdentityPersonResponses, PostIdentityPersonErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities/{identity_uuid}/persons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Identity Person
 *
 * DELETE /api/v2/admin/identities/{identity_uuid}/persons/{person_uuid}
 *
 * Move a login out of this identity into a fresh, empty one. 409 for an
 * activated executive (undo the activation first) or a login that is not a
 * member.
 */
export const deleteIdentityPerson = <ThrowOnError extends boolean = false>(options: Options<DeleteIdentityPersonData, ThrowOnError>): RequestResult<DeleteIdentityPersonResponses, DeleteIdentityPersonErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIdentityPersonResponses, DeleteIdentityPersonErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities/{identity_uuid}/persons/{person_uuid}',
    ...options
});

/**
 * Delete Identity Candidate
 *
 * DELETE /api/v2/admin/identities/{identity_uuid}/candidate
 *
 * Take the candidate out of this identity; it gets a fresh identity of its
 * own. 409 when the identity has no candidate, or has an activated executive
 * (undo the activation first).
 */
export const deleteIdentityCandidate = <ThrowOnError extends boolean = false>(options: Options<DeleteIdentityCandidateData, ThrowOnError>): RequestResult<DeleteIdentityCandidateResponses, DeleteIdentityCandidateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIdentityCandidateResponses, DeleteIdentityCandidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities/{identity_uuid}/candidate',
    ...options
});

/**
 * Put Identity Candidate
 *
 * PUT /api/v2/admin/identities/{identity_uuid}/candidate
 *
 * Make this candidate the one candidate of the identity. The candidate's old
 * identity is left behind, empty. 409 when the identity already holds a
 * different candidate (merge the candidates first).
 */
export const putIdentityCandidate = <ThrowOnError extends boolean = false>(options: Options<PutIdentityCandidateData, ThrowOnError>): RequestResult<PutIdentityCandidateResponses, PutIdentityCandidateErrors, ThrowOnError> => (options.client ?? client).put<PutIdentityCandidateResponses, PutIdentityCandidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities/{identity_uuid}/candidate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Identity Merge
 *
 * POST /api/v2/admin/identities/{identity_uuid}/merge
 *
 * Merge another identity (``from_identity_uuid``) into this one: every login,
 * the candidate if this identity has none, and every pointer (referrals,
 * feedback, email events) move here; the other identity stays behind as an
 * empty signpost. ``dry_run`` reports what would move and writes nothing.
 *
 * Only the uncomplicated case: at most one candidate and one activated
 * executive between the two. Otherwise 409, with the same body and
 * ``blockers`` saying why. Merging an identity into itself is a 422.
 */
export const postIdentityMerge = <ThrowOnError extends boolean = false>(options: Options<PostIdentityMergeData, ThrowOnError>): RequestResult<PostIdentityMergeResponses, PostIdentityMergeErrors, ThrowOnError> => (options.client ?? client).post<PostIdentityMergeResponses, PostIdentityMergeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities/{identity_uuid}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Identity Login
 *
 * POST /api/v2/admin/identities/{identity_uuid}/logins
 *
 * A new login for this human, created in its identity: an executive
 * (activated; refused when the identity already has one), an enterprise
 * user (on the team given, or none yet) or an admin. Refused (409) when the
 * email is already a login, here or on someone else, or is on another
 * person's candidate profile, with that identity in the detail.
 */
export const postIdentityLogin = <ThrowOnError extends boolean = false>(options: Options<PostIdentityLoginData, ThrowOnError>): RequestResult<PostIdentityLoginResponses, PostIdentityLoginErrors, ThrowOnError> => (options.client ?? client).post<PostIdentityLoginResponses, PostIdentityLoginErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/identities/{identity_uuid}/logins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Contact Lists
 *
 * POST /api/v2/admin/contact-lists — create the dated Internal and External SendGrid lists.
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postContactLists = <ThrowOnError extends boolean = false>(options?: Options<PostContactListsData, ThrowOnError>): RequestResult<PostContactListsResponses, PostContactListsErrors, ThrowOnError> => (options?.client ?? client).post<PostContactListsResponses, PostContactListsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/contact-lists',
    ...options
});

/**
 * Get Pathway Activity Defaults
 *
 * GET /api/v2/admin/pathway-activity-defaults
 */
export const getPathwayActivityDefaults = <ThrowOnError extends boolean = false>(options?: Options<GetPathwayActivityDefaultsData, ThrowOnError>): RequestResult<GetPathwayActivityDefaultsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPathwayActivityDefaultsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/pathway-activity-defaults',
    ...options
});

/**
 * Put Pathway Activity Defaults
 *
 * PUT /api/v2/admin/pathway-activity-defaults — upsert rows by pathway + activity_type.
 */
export const putPathwayActivityDefaults = <ThrowOnError extends boolean = false>(options: Options<PutPathwayActivityDefaultsData, ThrowOnError>): RequestResult<PutPathwayActivityDefaultsResponses, PutPathwayActivityDefaultsErrors, ThrowOnError> => (options.client ?? client).put<PutPathwayActivityDefaultsResponses, PutPathwayActivityDefaultsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/pathway-activity-defaults',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate Activity Logs
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/logs
 */
export const getCandidateActivityLogs = <ThrowOnError extends boolean = false>(options: Options<GetCandidateActivityLogsData, ThrowOnError>): RequestResult<GetCandidateActivityLogsResponses, GetCandidateActivityLogsErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateActivityLogsResponses, GetCandidateActivityLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/logs',
    ...options
});

/**
 * Post Candidate Activity Log
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/logs
 */
export const postCandidateActivityLog = <ThrowOnError extends boolean = false>(options: Options<PostCandidateActivityLogData, ThrowOnError>): RequestResult<PostCandidateActivityLogResponses, PostCandidateActivityLogErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateActivityLogResponses, PostCandidateActivityLogErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/logs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate Activity Logs Search
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/logs/search
 */
export const getCandidateActivityLogsSearch = <ThrowOnError extends boolean = false>(options: Options<GetCandidateActivityLogsSearchData, ThrowOnError>): RequestResult<GetCandidateActivityLogsSearchResponses, GetCandidateActivityLogsSearchErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateActivityLogsSearchResponses, GetCandidateActivityLogsSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/logs/search',
    ...options
});

/**
 * Post Candidate Tasks Filter
 *
 * POST /api/v2/admin/candidates/{candidate_uuid}/tasks/filter
 */
export const postCandidateTasksFilter = <ThrowOnError extends boolean = false>(options: Options<PostCandidateTasksFilterData, ThrowOnError>): RequestResult<PostCandidateTasksFilterResponses, PostCandidateTasksFilterErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateTasksFilterResponses, PostCandidateTasksFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/tasks/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Candidate Tasks Onboarding
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/tasks/onboarding-status
 */
export const getCandidateTasksOnboarding = <ThrowOnError extends boolean = false>(options: Options<GetCandidateTasksOnboardingData, ThrowOnError>): RequestResult<GetCandidateTasksOnboardingResponses, GetCandidateTasksOnboardingErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateTasksOnboardingResponses, GetCandidateTasksOnboardingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/tasks/onboarding-status',
    ...options
});

/**
 * Delete All Candidate Pathway Activity Targets
 *
 * DELETE …/pathway-activity-targets — remove all overrides (revert to pathway defaults).
 */
export const deleteAllCandidatePathwayActivityTargets = <ThrowOnError extends boolean = false>(options: Options<DeleteAllCandidatePathwayActivityTargetsData, ThrowOnError>): RequestResult<DeleteAllCandidatePathwayActivityTargetsResponses, DeleteAllCandidatePathwayActivityTargetsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAllCandidatePathwayActivityTargetsResponses, DeleteAllCandidatePathwayActivityTargetsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/pathway-activity-targets',
    ...options
});

/**
 * Get Candidate Pathway Activity Targets
 *
 * GET /api/v2/admin/candidates/{candidate_uuid}/pathway-activity-targets
 */
export const getCandidatePathwayActivityTargets = <ThrowOnError extends boolean = false>(options: Options<GetCandidatePathwayActivityTargetsData, ThrowOnError>): RequestResult<GetCandidatePathwayActivityTargetsResponses, GetCandidatePathwayActivityTargetsErrors, ThrowOnError> => (options.client ?? client).get<GetCandidatePathwayActivityTargetsResponses, GetCandidatePathwayActivityTargetsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/pathway-activity-targets',
    ...options
});

/**
 * Put Candidate Pathway Activity Targets
 *
 * PUT /api/v2/admin/candidates/{candidate_uuid}/pathway-activity-targets — upsert overrides.
 */
export const putCandidatePathwayActivityTargets = <ThrowOnError extends boolean = false>(options: Options<PutCandidatePathwayActivityTargetsData, ThrowOnError>): RequestResult<PutCandidatePathwayActivityTargetsResponses, PutCandidatePathwayActivityTargetsErrors, ThrowOnError> => (options.client ?? client).put<PutCandidatePathwayActivityTargetsResponses, PutCandidatePathwayActivityTargetsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/pathway-activity-targets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Candidate Pathway Activity Target
 *
 * DELETE …/pathway-activity-targets/{activity_type} — remove one override.
 */
export const deleteCandidatePathwayActivityTarget = <ThrowOnError extends boolean = false>(options: Options<DeleteCandidatePathwayActivityTargetData, ThrowOnError>): RequestResult<DeleteCandidatePathwayActivityTargetResponses, DeleteCandidatePathwayActivityTargetErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCandidatePathwayActivityTargetResponses, DeleteCandidatePathwayActivityTargetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/candidates/{candidate_uuid}/pathway-activity-targets/{activity_type}',
    ...options
});

/**
 * Get Home Activity Logs
 *
 * GET /api/v2/admin/home/logs
 */
export const getHomeActivityLogs = <ThrowOnError extends boolean = false>(options?: Options<GetHomeActivityLogsData, ThrowOnError>): RequestResult<GetHomeActivityLogsResponses, GetHomeActivityLogsErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeActivityLogsResponses, GetHomeActivityLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/home/logs',
    ...options
});

/**
 * Get Home All Intros
 *
 * GET /api/v2/admin/home/intros
 */
export const getHomeAllIntros = <ThrowOnError extends boolean = false>(options?: Options<GetHomeAllIntrosData, ThrowOnError>): RequestResult<GetHomeAllIntrosResponses, GetHomeAllIntrosErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeAllIntrosResponses, GetHomeAllIntrosErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/home/intros',
    ...options
});

/**
 * Post Admin Peers Filter
 *
 * POST /api/v2/admin/peers/filter
 */
export const postAdminPeersFilter = <ThrowOnError extends boolean = false>(options: Options<PostAdminPeersFilterData, ThrowOnError>): RequestResult<PostAdminPeersFilterResponses, PostAdminPeersFilterErrors, ThrowOnError> => (options.client ?? client).post<PostAdminPeersFilterResponses, PostAdminPeersFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Compare About
 *
 * POST /api/v2/admin/peers/compare/about
 */
export const postCandidateCompareAbout = <ThrowOnError extends boolean = false>(options: Options<PostCandidateCompareAboutData, ThrowOnError>): RequestResult<PostCandidateCompareAboutResponses, PostCandidateCompareAboutErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateCompareAboutResponses, PostCandidateCompareAboutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/compare/about',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Compare Goals
 *
 * POST /api/v2/admin/peers/compare/goals
 *
 * Goals of every compared candidate, in the order the candidates were
 * requested. Active goals come first, completed ones last, newest first
 * within each group - the same ordering the candidate's own goals page uses.
 */
export const postCandidateCompareGoals = <ThrowOnError extends boolean = false>(options: Options<PostCandidateCompareGoalsData, ThrowOnError>): RequestResult<PostCandidateCompareGoalsResponses, PostCandidateCompareGoalsErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateCompareGoalsResponses, PostCandidateCompareGoalsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/compare/goals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Candidate Compare P2P
 *
 * POST /api/v2/admin/peers/compare/p2p
 */
export const postCandidateCompareP2P = <ThrowOnError extends boolean = false>(options: Options<PostCandidateCompareP2pData, ThrowOnError>): RequestResult<PostCandidateCompareP2pResponses, PostCandidateCompareP2pErrors, ThrowOnError> => (options.client ?? client).post<PostCandidateCompareP2pResponses, PostCandidateCompareP2pErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/compare/p2p',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Admin Peers Matches
 *
 * POST /api/v2/admin/peers/{candidate_uuid}/matches
 */
export const postAdminPeersMatches = <ThrowOnError extends boolean = false>(options: Options<PostAdminPeersMatchesData, ThrowOnError>): RequestResult<PostAdminPeersMatchesResponses, PostAdminPeersMatchesErrors, ThrowOnError> => (options.client ?? client).post<PostAdminPeersMatchesResponses, PostAdminPeersMatchesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{candidate_uuid}/matches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Admin Peers Candidates Filter
 *
 * POST /api/v2/admin/peers/{candidate_uuid}/candidates/filter
 */
export const postAdminPeersCandidatesFilter = <ThrowOnError extends boolean = false>(options: Options<PostAdminPeersCandidatesFilterData, ThrowOnError>): RequestResult<PostAdminPeersCandidatesFilterResponses, PostAdminPeersCandidatesFilterErrors, ThrowOnError> => (options.client ?? client).post<PostAdminPeersCandidatesFilterResponses, PostAdminPeersCandidatesFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{candidate_uuid}/candidates/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Admin Peers Publish
 *
 * POST /api/v2/admin/peers/{candidate_uuid}
 */
export const postAdminPeersPublish = <ThrowOnError extends boolean = false>(options: Options<PostAdminPeersPublishData, ThrowOnError>): RequestResult<PostAdminPeersPublishResponses, PostAdminPeersPublishErrors, ThrowOnError> => (options.client ?? client).post<PostAdminPeersPublishResponses, PostAdminPeersPublishErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{candidate_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Peer
 *
 * DELETE /api/v2/admin/peers/{peer_id}
 */
export const deletePeer = <ThrowOnError extends boolean = false>(options: Options<DeletePeerData, ThrowOnError>): RequestResult<DeletePeerResponses, DeletePeerErrors, ThrowOnError> => (options.client ?? client).delete<DeletePeerResponses, DeletePeerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{peer_id}',
    ...options
});

/**
 * Get Peer
 *
 * GET /api/v2/admin/peers/{peer_id}
 */
export const getPeer = <ThrowOnError extends boolean = false>(options: Options<GetPeerData, ThrowOnError>): RequestResult<GetPeerResponses, GetPeerErrors, ThrowOnError> => (options.client ?? client).get<GetPeerResponses, GetPeerErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{peer_id}',
    ...options
});

/**
 * Put Peer Status
 *
 * PUT /api/v2/admin/peers/{peer_id}/status
 */
export const putPeerStatus = <ThrowOnError extends boolean = false>(options: Options<PutPeerStatusData, ThrowOnError>): RequestResult<PutPeerStatusResponses, PutPeerStatusErrors, ThrowOnError> => (options.client ?? client).put<PutPeerStatusResponses, PutPeerStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{peer_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Peer Assignees
 *
 * PUT /api/v2/admin/peers/{peer_id}/assignees
 */
export const putPeerAssignees = <ThrowOnError extends boolean = false>(options: Options<PutPeerAssigneesData, ThrowOnError>): RequestResult<PutPeerAssigneesResponses, PutPeerAssigneesErrors, ThrowOnError> => (options.client ?? client).put<PutPeerAssigneesResponses, PutPeerAssigneesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{peer_id}/assignees',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Peer Introduction
 *
 * PUT /api/v2/admin/peers/{peer_id}/introduction
 */
export const putPeerIntroduction = <ThrowOnError extends boolean = false>(options: Options<PutPeerIntroductionData, ThrowOnError>): RequestResult<PutPeerIntroductionResponses, PutPeerIntroductionErrors, ThrowOnError> => (options.client ?? client).put<PutPeerIntroductionResponses, PutPeerIntroductionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{peer_id}/introduction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Peer Activity
 *
 * GET /api/v2/admin/peers/{peer_id}/activity
 */
export const getPeerActivity = <ThrowOnError extends boolean = false>(options: Options<GetPeerActivityData, ThrowOnError>): RequestResult<GetPeerActivityResponses, GetPeerActivityErrors, ThrowOnError> => (options.client ?? client).get<GetPeerActivityResponses, GetPeerActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{peer_id}/activity',
    ...options
});

/**
 * Post Peer Comment
 *
 * POST /api/v2/admin/peers/{peer_id}/comments
 */
export const postPeerComment = <ThrowOnError extends boolean = false>(options: Options<PostPeerCommentData, ThrowOnError>): RequestResult<PostPeerCommentResponses, PostPeerCommentErrors, ThrowOnError> => (options.client ?? client).post<PostPeerCommentResponses, PostPeerCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{peer_id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Peer Comment
 *
 * DELETE /api/v2/admin/peers/{peer_id}/comments/{peer_comment_id}
 */
export const deletePeerComment = <ThrowOnError extends boolean = false>(options: Options<DeletePeerCommentData, ThrowOnError>): RequestResult<DeletePeerCommentResponses, DeletePeerCommentErrors, ThrowOnError> => (options.client ?? client).delete<DeletePeerCommentResponses, DeletePeerCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/peers/{peer_id}/comments/{peer_comment_id}',
    ...options
});

/**
 * Post Tasks
 *
 * POST /api/v2/admin/tasks
 */
export const postTasks = <ThrowOnError extends boolean = false>(options: Options<PostTasksData, ThrowOnError>): RequestResult<PostTasksResponses, PostTasksErrors, ThrowOnError> => (options.client ?? client).post<PostTasksResponses, PostTasksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Tasks Filter
 *
 * POST /api/v2/admin/tasks/filter
 */
export const postTasksFilter = <ThrowOnError extends boolean = false>(options: Options<PostTasksFilterData, ThrowOnError>): RequestResult<PostTasksFilterResponses, PostTasksFilterErrors, ThrowOnError> => (options.client ?? client).post<PostTasksFilterResponses, PostTasksFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/tasks/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Task
 *
 * DELETE /api/v2/admin/tasks/{task_id}
 */
export const deleteTask = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskData, ThrowOnError>): RequestResult<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/tasks/{task_id}',
    ...options
});

/**
 * Get Task
 *
 * GET /api/v2/admin/tasks/{task_id}
 */
export const getTask = <ThrowOnError extends boolean = false>(options: Options<GetTaskData, ThrowOnError>): RequestResult<GetTaskResponses, GetTaskErrors, ThrowOnError> => (options.client ?? client).get<GetTaskResponses, GetTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/tasks/{task_id}',
    ...options
});

/**
 * Put Task
 *
 * PUT /api/v2/admin/tasks/{task_id}
 */
export const putTask = <ThrowOnError extends boolean = false>(options: Options<PutTaskData, ThrowOnError>): RequestResult<PutTaskResponses, PutTaskErrors, ThrowOnError> => (options.client ?? client).put<PutTaskResponses, PutTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/tasks/{task_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Task Status
 *
 * PUT /api/v2/admin/tasks/{task_id}/status
 */
export const putTaskStatus = <ThrowOnError extends boolean = false>(options: Options<PutTaskStatusData, ThrowOnError>): RequestResult<PutTaskStatusResponses, PutTaskStatusErrors, ThrowOnError> => (options.client ?? client).put<PutTaskStatusResponses, PutTaskStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/tasks/{task_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Transfer To Company
 *
 * POST /api/v2/admin/teams/{team_uuid}/transfer-to-company
 *
 * Transfer a team from one company to another.
 *
 * Updates:
 * - SearchTeam.company_id, team_name, slug
 * - Pipeline.company (the displayed company name) for all team pipelines
 * - PersonRole.company_id for all team members
 * - Feedback.company_id for all team feedback
 *
 * ES indices are automatically updated:
 * - teams index: via SearchTeam event listener (model_registry)
 * - pipelines index: via SearchTeam -> TeamInnerDoc sync
 * - recommendations index: via SearchTeam -> TeamInnerDoc sync
 * - people index: manually synced after commit
 */
export const postTeamTransferToCompany = <ThrowOnError extends boolean = false>(options: Options<PostTeamTransferToCompanyData, ThrowOnError>): RequestResult<PostTeamTransferToCompanyResponses, PostTeamTransferToCompanyErrors, ThrowOnError> => (options.client ?? client).post<PostTeamTransferToCompanyResponses, PostTeamTransferToCompanyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/teams/{team_uuid}/transfer-to-company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Merge
 *
 * POST /api/v2/admin/teams/{team_uuid}/merge
 *
 * Merge a source team into the target (path) team. The path team is the
 * base team that survives; the source team is folded into it and then
 * deactivated. Both teams must belong to the same company.
 *
 * Re-points every reference (pipelines, recommendations, feedback,
 * members, comments, invitations, intros, evaluations, email events) from
 * the source onto the target. ES teams/pipelines/recommendations indices
 * sync automatically on commit; the aggregate candidates / team-candidates
 * indices are refreshed via a separate reindex.
 */
export const postTeamMerge = <ThrowOnError extends boolean = false>(options: Options<PostTeamMergeData, ThrowOnError>): RequestResult<PostTeamMergeResponses, PostTeamMergeErrors, ThrowOnError> => (options.client ?? client).post<PostTeamMergeResponses, PostTeamMergeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/teams/{team_uuid}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Task Modules
 *
 * POST /api/v2/admin/task-modules
 */
export const postTaskModules = <ThrowOnError extends boolean = false>(options: Options<PostTaskModulesData, ThrowOnError>): RequestResult<PostTaskModulesResponses, PostTaskModulesErrors, ThrowOnError> => (options.client ?? client).post<PostTaskModulesResponses, PostTaskModulesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/task-modules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Task Module
 *
 * DELETE /api/v2/admin/task-modules/{task_module_id}
 */
export const deleteTaskModule = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskModuleData, ThrowOnError>): RequestResult<DeleteTaskModuleResponses, DeleteTaskModuleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaskModuleResponses, DeleteTaskModuleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/task-modules/{task_module_id}',
    ...options
});

/**
 * Get Task Module
 *
 * GET /api/v2/admin/task-modules/{task_module_id}
 */
export const getTaskModule = <ThrowOnError extends boolean = false>(options: Options<GetTaskModuleData, ThrowOnError>): RequestResult<GetTaskModuleResponses, GetTaskModuleErrors, ThrowOnError> => (options.client ?? client).get<GetTaskModuleResponses, GetTaskModuleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/task-modules/{task_module_id}',
    ...options
});

/**
 * Put Task Module
 *
 * PUT /api/v2/admin/task-modules/{task_module_id}
 */
export const putTaskModule = <ThrowOnError extends boolean = false>(options: Options<PutTaskModuleData, ThrowOnError>): RequestResult<PutTaskModuleResponses, PutTaskModuleErrors, ThrowOnError> => (options.client ?? client).put<PutTaskModuleResponses, PutTaskModuleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/task-modules/{task_module_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Task Module Status
 *
 * PUT /api/v2/admin/task-modules/{task_module_id}/status
 */
export const putTaskModuleStatus = <ThrowOnError extends boolean = false>(options: Options<PutTaskModuleStatusData, ThrowOnError>): RequestResult<PutTaskModuleStatusResponses, PutTaskModuleStatusErrors, ThrowOnError> => (options.client ?? client).put<PutTaskModuleStatusResponses, PutTaskModuleStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/task-modules/{task_module_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Admin Pipeline Candidates Filter
 *
 * POST /api/v2/pipelines/{pipeline_uuid}/candidates/filter
 */
export const postAdminPipelineCandidatesFilter = <ThrowOnError extends boolean = false>(options: Options<PostAdminPipelineCandidatesFilterData, ThrowOnError>): RequestResult<PostAdminPipelineCandidatesFilterResponses, PostAdminPipelineCandidatesFilterErrors, ThrowOnError> => (options.client ?? client).post<PostAdminPipelineCandidatesFilterResponses, PostAdminPipelineCandidatesFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/pipelines/{pipeline_uuid}/candidates/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Pipeline Transfer To Team
 *
 * POST /api/v2/admin/pipelines/transfer-to-team
 *
 * Transfer pipelines to another team.
 *
 * Updates (ORM-style for automatic ES sync):
 * - Pipeline.search_team_id
 * - Pipeline.company (set to target team's company name; cleared when the
 * target is an executive personal team, whose internal account-company
 * name must not surface on the pipeline)
 * - Pipeline.point_of_contact_person_id (set to NULL)
 * - SubmissionCandidate.search_team_id and team_uuid
 *
 * Updates (bulk SQL - no event listeners):
 * - RecommendationComment.team_uuid (comments move with the pipeline)
 * - Feedback.team_id and team_uuid
 * - InternalRecommendationComment.team_uuid
 * - EvaluationHistory.team_uuid
 *
 * Preserves:
 * - Pipeline.creator_person_id
 * - RecommendationComment author, content and timestamps (only team_uuid moves)
 *
 * Blocked if pipeline has:
 * - Pending RequestedIntro (introduced IS NULL - must be resolved first)
 *
 * Transfers:
 * - Completed RequestedIntro records (introduced IS NOT NULL) get team_id updated
 *
 * ES indices are automatically updated via event listeners:
 * - pipelines index: via Pipeline model listener
 * - recommendations index: via SubmissionCandidate model listener (rebuilt from
 * post-commit DB state, so it also reflects the moved comments)
 *
 * The team_candidates and candidates indices are not refreshed by this endpoint
 * (pre-existing behavior for moved recommendations); reindex them if the stale
 * (candidate, source team) rollups matter.
 */
export const postPipelineTransferToTeam = <ThrowOnError extends boolean = false>(options: Options<PostPipelineTransferToTeamData, ThrowOnError>): RequestResult<PostPipelineTransferToTeamResponses, PostPipelineTransferToTeamErrors, ThrowOnError> => (options.client ?? client).post<PostPipelineTransferToTeamResponses, PostPipelineTransferToTeamErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/pipelines/transfer-to-team',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch User Role Remove Company
 *
 * PATCH /api/v2/admin/users/{person_uuid}/roles/{role_id}/remove-company
 *
 * Remove company association from an ANYMEMBR or APPADMIN role.
 * Sets company_id to None for the specified role.
 */
export const patchUserRoleRemoveCompany = <ThrowOnError extends boolean = false>(options: Options<PatchUserRoleRemoveCompanyData, ThrowOnError>): RequestResult<PatchUserRoleRemoveCompanyResponses, PatchUserRoleRemoveCompanyErrors, ThrowOnError> => (options.client ?? client).patch<PatchUserRoleRemoveCompanyResponses, PatchUserRoleRemoveCompanyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/users/{person_uuid}/roles/{role_id}/remove-company',
    ...options
});

/**
 * Patch User
 *
 * PATCH /api/v2/admin/users/{person_uuid}
 *
 * Update user/person fields. All fields are optional - only provided fields will be updated.
 */
export const patchUser = <ThrowOnError extends boolean = false>(options: Options<PatchUserData, ThrowOnError>): RequestResult<PatchUserResponses, PatchUserErrors, ThrowOnError> => (options.client ?? client).patch<PatchUserResponses, PatchUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/users/{person_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post User Company
 *
 * POST /api/v2/admin/users/{person_uuid}/company
 *
 * Put a login in a company: the ANYMEMBR role with that company. No
 * invitation is sent. A login belongs to one company at a time, so this is
 * refused while it has one; remove its team roles, then its company role,
 * first. A leftover ANYMEMBR role with no company (what removing a company
 * leaves) is filled in rather than joined by a second one. An admin's or
 * an executive's login is refused.
 */
export const postUserCompany = <ThrowOnError extends boolean = false>(options: Options<PostUserCompanyData, ThrowOnError>): RequestResult<PostUserCompanyResponses, PostUserCompanyErrors, ThrowOnError> => (options.client ?? client).post<PostUserCompanyResponses, PostUserCompanyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/users/{person_uuid}/company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post User Team
 *
 * POST /api/v2/admin/users/{person_uuid}/teams
 *
 * Give a login a seat on a team, as a member or (``lead``) a lead, with the
 * role that fits the team's company type. No invitation is sent. The team
 * must belong to the login's company; a login with no company joins the
 * team's. An admin's or an executive's login is refused.
 */
export const postUserTeam = <ThrowOnError extends boolean = false>(options: Options<PostUserTeamData, ThrowOnError>): RequestResult<PostUserTeamResponses, PostUserTeamErrors, ThrowOnError> => (options.client ?? client).post<PostUserTeamResponses, PostUserTeamErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/users/{person_uuid}/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Candidate Company Metadata
 *
 * DELETE /api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata
 */
export const deleteCandidateCompanyMetadata = <ThrowOnError extends boolean = false>(options: Options<DeleteCandidateCompanyMetadataData, ThrowOnError>): RequestResult<DeleteCandidateCompanyMetadataResponses, DeleteCandidateCompanyMetadataErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCandidateCompanyMetadataResponses, DeleteCandidateCompanyMetadataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata',
    ...options
});

/**
 * Get Candidate Company Metadata
 *
 * GET /api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata
 */
export const getCandidateCompanyMetadata = <ThrowOnError extends boolean = false>(options: Options<GetCandidateCompanyMetadataData, ThrowOnError>): RequestResult<GetCandidateCompanyMetadataResponses, GetCandidateCompanyMetadataErrors, ThrowOnError> => (options.client ?? client).get<GetCandidateCompanyMetadataResponses, GetCandidateCompanyMetadataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata',
    ...options
});

/**
 * Upsert Candidate Company Metadata
 *
 * POST /api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata
 *
 * ``custom_keywords`` are applied via company tag vocabulary + associations,
 * then projected onto this row (and Elasticsearch) like member tag routes.
 */
export const upsertCandidateCompanyMetadata = <ThrowOnError extends boolean = false>(options: Options<UpsertCandidateCompanyMetadataData, ThrowOnError>): RequestResult<UpsertCandidateCompanyMetadataResponses, UpsertCandidateCompanyMetadataErrors, ThrowOnError> => (options.client ?? client).post<UpsertCandidateCompanyMetadataResponses, UpsertCandidateCompanyMetadataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/companies/{company_id}/candidates/{candidate_uuid}/metadata',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import Candidate Company Metadata
 *
 * POST /api/v2/admin/companies/{company_id}/candidate-metadata/import
 *
 * Batch-import company-scoped tags and comments for existing candidates.
 * The client parses CSV/spreadsheet rows and sends them in ``rows``.
 *
 * Each row requires ``candidate_uuid`` (resolved on the client), plus
 * ``custom_keywords`` and/or ``custom_notes``.
 */
export const importCandidateCompanyMetadata = <ThrowOnError extends boolean = false>(options: Options<ImportCandidateCompanyMetadataData, ThrowOnError>): RequestResult<ImportCandidateCompanyMetadataResponses, ImportCandidateCompanyMetadataErrors, ThrowOnError> => (options.client ?? client).post<ImportCandidateCompanyMetadataResponses, ImportCandidateCompanyMetadataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/companies/{company_id}/candidate-metadata/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Candidate Company Metadata
 *
 * GET /api/v2/admin/companies/{company_id}/candidate-metadata
 *
 * Returns active company-scoped metadata rows with an embedded candidate
 * summary. Sorted by ``last_modified`` descending. Rows whose candidate no
 * longer exists are omitted.
 */
export const listCandidateCompanyMetadata = <ThrowOnError extends boolean = false>(options: Options<ListCandidateCompanyMetadataData, ThrowOnError>): RequestResult<ListCandidateCompanyMetadataResponses, ListCandidateCompanyMetadataErrors, ThrowOnError> => (options.client ?? client).get<ListCandidateCompanyMetadataResponses, ListCandidateCompanyMetadataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/companies/{company_id}/candidate-metadata',
    ...options
});

/**
 * Post Company People Filter
 *
 * POST /api/v2/admin/companies/{company_id}/people/filter
 *
 * Company-scoped people list combining metadata prep rows and candidates
 * shared on any company team (pipeline or trending recommendations).
 */
export const postCompanyPeopleFilter = <ThrowOnError extends boolean = false>(options: Options<PostCompanyPeopleFilterData, ThrowOnError>): RequestResult<PostCompanyPeopleFilterResponses, PostCompanyPeopleFilterErrors, ThrowOnError> => (options.client ?? client).post<PostCompanyPeopleFilterResponses, PostCompanyPeopleFilterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/companies/{company_id}/people/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Activate Executive
 *
 * POST /api/v2/admin/executives/{candidate_uuid}/activate
 *
 * Activate an executive candidate for platform access.
 * Creates Person + ExecutiveSettings + Clerk invitation.
 * Idempotent: returns existing settings if already activated.
 */
export const postActivateExecutive = <ThrowOnError extends boolean = false>(options: Options<PostActivateExecutiveData, ThrowOnError>): RequestResult<PostActivateExecutiveResponses, PostActivateExecutiveErrors, ThrowOnError> => (options.client ?? client).post<PostActivateExecutiveResponses, PostActivateExecutiveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/executives/{candidate_uuid}/activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Bulk Activate Executives
 *
 * POST /api/v2/admin/executives/bulk-activate
 *
 * Activate a batch of executive candidates by UUID. Per-candidate failures
 * are reported in the response without aborting the batch.
 */
export const postBulkActivateExecutives = <ThrowOnError extends boolean = false>(options: Options<PostBulkActivateExecutivesData, ThrowOnError>): RequestResult<PostBulkActivateExecutivesResponses, PostBulkActivateExecutivesErrors, ThrowOnError> => (options.client ?? client).post<PostBulkActivateExecutivesResponses, PostBulkActivateExecutivesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/executives/bulk-activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Executive Activation
 *
 * DELETE /api/v2/admin/executives/{person_uuid}/activation
 *
 * Undo a silent activation: deletes ExecutiveSettings and the
 * EXECUTIVE/EXECLEAD roles, deactivates the exec's empty personal team,
 * and deactivates the person if activation created it (no Clerk login,
 * no other roles). The candidate<->person link is untouched.
 *
 * 409 when the invitation was already sent, or when the exec team still
 * owns pipelines/recommendations (transfer them away first).
 */
export const deleteExecutiveActivation = <ThrowOnError extends boolean = false>(options: Options<DeleteExecutiveActivationData, ThrowOnError>): RequestResult<DeleteExecutiveActivationResponses, DeleteExecutiveActivationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteExecutiveActivationResponses, DeleteExecutiveActivationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/executives/{person_uuid}/activation',
    ...options
});

/**
 * Post Send Executive Invitation
 *
 * POST /api/v2/admin/executives/{person_uuid}/send-invitation
 *
 * Send (or resend) the Clerk invitation email to an already-activated
 * executive. On resend, revokes the prior Clerk invitation and replaces
 * it so only one live invite exists at a time.
 */
export const postSendExecutiveInvitation = <ThrowOnError extends boolean = false>(options: Options<PostSendExecutiveInvitationData, ThrowOnError>): RequestResult<PostSendExecutiveInvitationResponses, PostSendExecutiveInvitationErrors, ThrowOnError> => (options.client ?? client).post<PostSendExecutiveInvitationResponses, PostSendExecutiveInvitationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/executives/{person_uuid}/send-invitation',
    ...options
});

/**
 * Get Executives
 *
 * GET /api/v2/admin/executives
 *
 * List all activated executives.
 */
export const getExecutives = <ThrowOnError extends boolean = false>(options?: Options<GetExecutivesData, ThrowOnError>): RequestResult<GetExecutivesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetExecutivesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/executives',
    ...options
});

/**
 * Get Executive
 *
 * GET /api/v2/admin/executives/{person_uuid}
 *
 * Get a specific executive by person UUID.
 */
export const getExecutive = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveData, ThrowOnError>): RequestResult<GetExecutiveResponses, GetExecutiveErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveResponses, GetExecutiveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/executives/{person_uuid}',
    ...options
});

/**
 * Patch Executive Settings
 *
 * PATCH /api/v2/admin/executives/{person_uuid}/settings
 *
 * Update executive settings and/or login email.
 */
export const patchExecutiveSettings = <ThrowOnError extends boolean = false>(options: Options<PatchExecutiveSettingsData, ThrowOnError>): RequestResult<PatchExecutiveSettingsResponses, PatchExecutiveSettingsErrors, ThrowOnError> => (options.client ?? client).patch<PatchExecutiveSettingsResponses, PatchExecutiveSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/admin/executives/{person_uuid}/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Executive Client Settings
 *
 * GET /api/v2/clients/{person_uuid}/settings
 *
 * View executive profile and preferences.
 */
export const getExecutiveClientSettings = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveClientSettingsData, ThrowOnError>): RequestResult<GetExecutiveClientSettingsResponses, GetExecutiveClientSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveClientSettingsResponses, GetExecutiveClientSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/settings',
    ...options
});

/**
 * Patch Executive Client Settings
 *
 * PATCH /api/v2/clients/{person_uuid}/settings
 *
 * Update executive-editable settings (name, email, email preferences).
 */
export const patchExecutiveClientSettings = <ThrowOnError extends boolean = false>(options: Options<PatchExecutiveClientSettingsData, ThrowOnError>): RequestResult<PatchExecutiveClientSettingsResponses, PatchExecutiveClientSettingsErrors, ThrowOnError> => (options.client ?? client).patch<PatchExecutiveClientSettingsResponses, PatchExecutiveClientSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Executive Client Team
 *
 * GET /api/v2/clients/{person_uuid}/team
 *
 * Return the exec's personal SearchTeam UUID, creating it lazily on first call.
 * The returned team_uuid is used with the standard team pipeline endpoints.
 */
export const getExecutiveClientTeam = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveClientTeamData, ThrowOnError>): RequestResult<GetExecutiveClientTeamResponses, GetExecutiveClientTeamErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveClientTeamResponses, GetExecutiveClientTeamErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/team',
    ...options
});

/**
 * Post Executive Client Contact Pipelines
 *
 * POST /api/v2/clients/{person_uuid}/contacts/{contact_uuid}/pipelines
 *
 * Add one of the exec's own contacts to one or more of their own requests.
 *
 * The team-scoped equivalent requires the candidate to already have a published
 * recommendation on the team, which is never true for the events, P2P and
 * referral contacts that make up most of an exec's network — so it 404s and the
 * exec cannot add their own contacts to their own requests. Here the exec having
 * the contact resolves that, and pipelines are still constrained to the exec's
 * own team by ``add_candidate_to_pipelines``.
 *
 * The actor is the caller, not the exec, so an advisor acting on the exec's
 * behalf is recorded as themselves.
 */
export const postExecutiveClientContactPipelines = <ThrowOnError extends boolean = false>(options: Options<PostExecutiveClientContactPipelinesData, ThrowOnError>): RequestResult<PostExecutiveClientContactPipelinesResponses, PostExecutiveClientContactPipelinesErrors, ThrowOnError> => (options.client ?? client).post<PostExecutiveClientContactPipelinesResponses, PostExecutiveClientContactPipelinesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/contacts/{contact_uuid}/pipelines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Executive Client Person Detail
 *
 * GET /api/v2/clients/{person_uuid}/people/{contact_person_uuid}
 *
 * Return detail for a person-only contact (no candidate record) when that person
 * appears in the executive's gathered contacts.
 *
 * Deprecated: use the unified
 * ``GET /api/v2/clients/{person_uuid}/contacts/{contact_uuid}`` instead, which
 * returns this person under ``person`` alongside the canonical contact fields.
 *
 * @deprecated
 */
export const getExecutiveClientPersonDetail = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveClientPersonDetailData, ThrowOnError>): RequestResult<GetExecutiveClientPersonDetailResponses, GetExecutiveClientPersonDetailErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveClientPersonDetailResponses, GetExecutiveClientPersonDetailErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/people/{contact_person_uuid}',
    ...options
});

/**
 * Post Executive Client People Search
 *
 * POST /api/v2/clients/{person_uuid}/people/search
 *
 * Search and sort the exec's contacts across all sources
 * (P2P, events, B4B intros, referrals).
 * Contacts with a candidate record are searched via the candidates index.
 * Person-only contacts (no candidate record) are searched via the people index.
 * All results are merged before sorting and pagination so that both work
 * across the full combined set.
 */
export const postExecutiveClientPeopleSearch = <ThrowOnError extends boolean = false>(options: Options<PostExecutiveClientPeopleSearchData, ThrowOnError>): RequestResult<PostExecutiveClientPeopleSearchResponses, PostExecutiveClientPeopleSearchErrors, ThrowOnError> => (options.client ?? client).post<PostExecutiveClientPeopleSearchResponses, PostExecutiveClientPeopleSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/people/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Executive Client Candidate
 *
 * GET /api/v2/clients/{person_uuid}/candidates/{candidate_uuid}
 *
 * Same payload as ``GET /api/v2/teams/{team_uuid}/candidates/{candidate_uuid}`` for
 * the executive's personal team, when the candidate appears in their people list
 * (``gather_contacts``).
 *
 * Deprecated: use the unified
 * ``GET /api/v2/clients/{person_uuid}/contacts/{contact_uuid}`` instead, which
 * embeds this candidate profile under ``candidate`` and also exposes the
 * canonical ``was_introduced`` / ``is_favorite`` fields.
 *
 * @deprecated
 */
export const getExecutiveClientCandidate = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveClientCandidateData, ThrowOnError>): RequestResult<GetExecutiveClientCandidateResponses, GetExecutiveClientCandidateErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveClientCandidateResponses, GetExecutiveClientCandidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/candidates/{candidate_uuid}',
    ...options
});

/**
 * Get Executive Client Contact
 *
 * GET /api/v2/clients/{person_uuid}/contacts/{contact_uuid}
 *
 * Unified detail for one of the exec's contacts. ``contact_uuid`` accepts
 * either a ``Person.uuid`` or a ``ContenderCandidate.uuid`` (the People page
 * returns both kinds). Returns one canonical envelope exposing
 * ``was_introduced`` / ``is_favorite`` / gated ``email`` / ``source_types`` /
 * ``personal_tags`` consistently, embedding the full candidate profile and/or
 * the linked person when present.
 */
export const getExecutiveClientContact = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveClientContactData, ThrowOnError>): RequestResult<GetExecutiveClientContactResponses, GetExecutiveClientContactErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveClientContactResponses, GetExecutiveClientContactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/contacts/{contact_uuid}',
    ...options
});

/**
 * Get Executive Client Trending
 *
 * GET /api/v2/clients/{person_uuid}/trending
 *
 * Return Banff-curated trending candidates published to the exec's personal
 * SearchTeam.
 */
export const getExecutiveClientTrending = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveClientTrendingData, ThrowOnError>): RequestResult<GetExecutiveClientTrendingResponses, GetExecutiveClientTrendingErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveClientTrendingResponses, GetExecutiveClientTrendingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/trending',
    ...options
});

/**
 * Get Executive Client Trending Recommendation
 *
 * GET /api/v2/clients/{person_uuid}/trending/{recommendation_uuid}
 *
 * Return a single trending recommendation published to the exec's personal
 * SearchTeam. Mirrors `GET /api/v2/teams/{team_uuid}/trending/{rec}` but
 * scopes to the exec's ghost team instead of an arbitrary team slug.
 */
export const getExecutiveClientTrendingRecommendation = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveClientTrendingRecommendationData, ThrowOnError>): RequestResult<GetExecutiveClientTrendingRecommendationResponses, GetExecutiveClientTrendingRecommendationErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveClientTrendingRecommendationResponses, GetExecutiveClientTrendingRecommendationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/trending/{recommendation_uuid}',
    ...options
});

/**
 * Post Admin Executive Client Activity
 *
 * POST /api/v2/clients/{person_uuid}/activity
 *
 * Admin-only full activity feed for an executive client.
 */
export const postAdminExecutiveClientActivity = <ThrowOnError extends boolean = false>(options: Options<PostAdminExecutiveClientActivityData, ThrowOnError>): RequestResult<PostAdminExecutiveClientActivityResponses, PostAdminExecutiveClientActivityErrors, ThrowOnError> => (options.client ?? client).post<PostAdminExecutiveClientActivityResponses, PostAdminExecutiveClientActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/activity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Executive Client Activity
 *
 * POST /api/v2/clients/{person_uuid}/contacts/{contact_uuid}/activity
 *
 * Unified activity feed for the exec. Mixes `CandidateActivityLog` rows
 * with synthetic items from connection-source models (events attended,
 * P2P intros, B4B pipeline intros, uploaded-network referrals), narrowed
 * to interactions involving the path `contact_uuid`.
 * `contact_uuid` accepts either a `Person.uuid` or a
 * `ContenderCandidate.uuid` — the People-page returns both kinds.
 * Items are ordered by `date` DESC. Pagination is body-driven via
 * `page` / `size`.
 */
export const postExecutiveClientActivity = <ThrowOnError extends boolean = false>(options: Options<PostExecutiveClientActivityData, ThrowOnError>): RequestResult<PostExecutiveClientActivityResponses, PostExecutiveClientActivityErrors, ThrowOnError> => (options.client ?? client).post<PostExecutiveClientActivityResponses, PostExecutiveClientActivityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/contacts/{contact_uuid}/activity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Executive Client Events
 *
 * GET /api/v2/clients/{person_uuid}/events
 *
 * List the published events the executive is a guest of (any date),
 * paginated and sortable by event date or event name. Each item carries the
 * same event info and the exec's own RSVP status as the detail view, plus
 * headline attendee counts — without the per-attendee detail the detail
 * endpoint returns.
 */
export const listExecutiveClientEvents = <ThrowOnError extends boolean = false>(options: Options<ListExecutiveClientEventsData, ThrowOnError>): RequestResult<ListExecutiveClientEventsResponses, ListExecutiveClientEventsErrors, ThrowOnError> => (options.client ?? client).get<ListExecutiveClientEventsResponses, ListExecutiveClientEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/events',
    ...options
});

/**
 * Get Executive Client Event
 *
 * GET /api/v2/clients/{person_uuid}/events/{event_uuid}
 *
 * View a published event the executive is a guest of (any date). Returns the
 * public event detail plus an attendee list scoped by the rules in
 * :class:`ExecutiveClientEventResponse`.
 */
export const getExecutiveClientEvent = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveClientEventData, ThrowOnError>): RequestResult<GetExecutiveClientEventResponses, GetExecutiveClientEventErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveClientEventResponses, GetExecutiveClientEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/events/{event_uuid}',
    ...options
});

/**
 * Update Executive Client Event Rsvp
 *
 * PATCH /api/v2/clients/{person_uuid}/events/{event_uuid}/rsvp
 *
 * Set the executive's own RSVP (going / cant_go) for a published event they
 * are a guest of. An exec may RSVP regardless of invite state — the invite
 * email is only a notification; visibility implies the right to respond.
 *
 * Guards mirror the public token flow: the event must be published (enforced
 * by the loader), have RSVP enabled, and not have already started.
 */
export const updateExecutiveClientEventRsvp = <ThrowOnError extends boolean = false>(options: Options<UpdateExecutiveClientEventRsvpData, ThrowOnError>): RequestResult<UpdateExecutiveClientEventRsvpResponses, UpdateExecutiveClientEventRsvpErrors, ThrowOnError> => (options.client ?? client).patch<UpdateExecutiveClientEventRsvpResponses, UpdateExecutiveClientEventRsvpErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/clients/{person_uuid}/events/{event_uuid}/rsvp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post People V2
 *
 * POST /api/v2/people
 */
export const postPeopleV2 = <ThrowOnError extends boolean = false>(options: Options<PostPeopleV2Data, ThrowOnError>): RequestResult<PostPeopleV2Responses, PostPeopleV2Errors, ThrowOnError> => (options.client ?? client).post<PostPeopleV2Responses, PostPeopleV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Person Metadata V2
 *
 * POST /api/v2/people/metadata
 */
export const updatePersonMetadataV2 = <ThrowOnError extends boolean = false>(options: Options<UpdatePersonMetadataV2Data, ThrowOnError>): RequestResult<UpdatePersonMetadataV2Responses, UpdatePersonMetadataV2Errors, ThrowOnError> => (options.client ?? client).post<UpdatePersonMetadataV2Responses, UpdatePersonMetadataV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/metadata',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch People Current
 *
 * PATCH /api/v2/people/current
 *
 * Self-service update for external person fields. Response shape matches GET
 * ``/people/current``.
 */
export const patchPeopleCurrent = <ThrowOnError extends boolean = false>(options: Options<PatchPeopleCurrentData, ThrowOnError>): RequestResult<PatchPeopleCurrentResponses, PatchPeopleCurrentErrors, ThrowOnError> => (options.client ?? client).patch<PatchPeopleCurrentResponses, PatchPeopleCurrentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/current',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put People Current Password
 *
 * PUT /api/v2/people/current/password
 *
 * Self-service Clerk password update for the authenticated user.
 */
export const putPeopleCurrentPassword = <ThrowOnError extends boolean = false>(options: Options<PutPeopleCurrentPasswordData, ThrowOnError>): RequestResult<PutPeopleCurrentPasswordResponses, PutPeopleCurrentPasswordErrors, ThrowOnError> => (options.client ?? client).put<PutPeopleCurrentPasswordResponses, PutPeopleCurrentPasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/current/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Person Clerk User
 *
 * Create a Clerk user for an existing person record.
 */
export const postPersonClerkUser = <ThrowOnError extends boolean = false>(options: Options<PostPersonClerkUserData, ThrowOnError>): RequestResult<PostPersonClerkUserResponses, PostPersonClerkUserErrors, ThrowOnError> => (options.client ?? client).post<PostPersonClerkUserResponses, PostPersonClerkUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/clerk-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch Person Email Notifications
 *
 * PATCH /api/v2/people/{person_uuid}/email-notifications
 *
 * Enable or disable preregistration notifications for a person.
 *
 * Admin-only endpoint to control whether pending users receive preregistration emails.
 */
export const patchPersonEmailNotifications = <ThrowOnError extends boolean = false>(options: Options<PatchPersonEmailNotificationsData, ThrowOnError>): RequestResult<PatchPersonEmailNotificationsResponses, PatchPersonEmailNotificationsErrors, ThrowOnError> => (options.client ?? client).patch<PatchPersonEmailNotificationsResponses, PatchPersonEmailNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/email-notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch Person
 *
 * PATCH /api/v2/people/{person_uuid}
 *
 * Partially update person fields.
 */
export const patchPerson = <ThrowOnError extends boolean = false>(options: Options<PatchPersonData, ThrowOnError>): RequestResult<PatchPersonResponses, PatchPersonErrors, ThrowOnError> => (options.client ?? client).patch<PatchPersonResponses, PatchPersonErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get People Internal
 *
 * GET /api/v2/people/internal/customer_success - Get all Banff team members (APPADMIN role)
 */
export const getPeopleInternal = <ThrowOnError extends boolean = false>(options?: Options<GetPeopleInternalData, ThrowOnError>): RequestResult<GetPeopleInternalResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPeopleInternalResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/internal/customer_success',
    ...options
});

/**
 * Resolve Person Candidate By Email
 *
 * POST /api/v2/people/resolve-by-email
 *
 * Advisor-only lookup that resolves an email to `person_uuid` and/or
 * `candidate_uuid` in one request.
 */
export const resolvePersonCandidateByEmail = <ThrowOnError extends boolean = false>(options: Options<ResolvePersonCandidateByEmailData, ThrowOnError>): RequestResult<ResolvePersonCandidateByEmailResponses, ResolvePersonCandidateByEmailErrors, ThrowOnError> => (options.client ?? client).post<ResolvePersonCandidateByEmailResponses, ResolvePersonCandidateByEmailErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/resolve-by-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Person Contact Tags
 *
 * GET /api/v2/people/{person_uuid}/contacts/tags — list this person's tag vocabulary.
 */
export const listPersonContactTags = <ThrowOnError extends boolean = false>(options: Options<ListPersonContactTagsData, ThrowOnError>): RequestResult<ListPersonContactTagsResponses, ListPersonContactTagsErrors, ThrowOnError> => (options.client ?? client).get<ListPersonContactTagsResponses, ListPersonContactTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/contacts/tags',
    ...options
});

/**
 * Create Person Contact Tag Definition
 *
 * POST /api/v2/people/{person_uuid}/contacts/tags — create a tag label (vocabulary only).
 */
export const createPersonContactTagDefinition = <ThrowOnError extends boolean = false>(options: Options<CreatePersonContactTagDefinitionData, ThrowOnError>): RequestResult<CreatePersonContactTagDefinitionResponses, CreatePersonContactTagDefinitionErrors, ThrowOnError> => (options.client ?? client).post<CreatePersonContactTagDefinitionResponses, CreatePersonContactTagDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/contacts/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Person Contact Tag Definition
 *
 * DELETE .../contacts/tags/{tag_definition_uuid} — remove tag and associations.
 */
export const deletePersonContactTagDefinition = <ThrowOnError extends boolean = false>(options: Options<DeletePersonContactTagDefinitionData, ThrowOnError>): RequestResult<DeletePersonContactTagDefinitionResponses, DeletePersonContactTagDefinitionErrors, ThrowOnError> => (options.client ?? client).delete<DeletePersonContactTagDefinitionResponses, DeletePersonContactTagDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/contacts/tags/{tag_definition_uuid}',
    ...options
});

/**
 * Patch Person Contact Tag Definition
 *
 * PATCH /api/v2/people/{person_uuid}/contacts/tags/{tag_definition_uuid} — rename a tag.
 */
export const patchPersonContactTagDefinition = <ThrowOnError extends boolean = false>(options: Options<PatchPersonContactTagDefinitionData, ThrowOnError>): RequestResult<PatchPersonContactTagDefinitionResponses, PatchPersonContactTagDefinitionErrors, ThrowOnError> => (options.client ?? client).patch<PatchPersonContactTagDefinitionResponses, PatchPersonContactTagDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/contacts/tags/{tag_definition_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Person Contact Tag
 *
 * POST .../contacts/{contact_uuid}/tags — link one tag to a contact.
 */
export const addPersonContactTag = <ThrowOnError extends boolean = false>(options: Options<AddPersonContactTagData, ThrowOnError>): RequestResult<AddPersonContactTagResponses, AddPersonContactTagErrors, ThrowOnError> => (options.client ?? client).post<AddPersonContactTagResponses, AddPersonContactTagErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/contacts/{contact_uuid}/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Person Contact Tag
 *
 * DELETE /api/v2/people/{person_uuid}/contacts/{contact_uuid}/tags/{tag_definition_uuid}.
 */
export const removePersonContactTag = <ThrowOnError extends boolean = false>(options: Options<RemovePersonContactTagData, ThrowOnError>): RequestResult<RemovePersonContactTagResponses, RemovePersonContactTagErrors, ThrowOnError> => (options.client ?? client).delete<RemovePersonContactTagResponses, RemovePersonContactTagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/contacts/{contact_uuid}/tags/{tag_definition_uuid}',
    ...options
});

/**
 * Post Person Contact Favorite
 *
 * POST /api/v2/people/{person_uuid}/contacts/{contact_uuid}/favorite
 *
 * Scoped to ``user:only-self``: favorites are owned by the person whose feed
 * they appear on, and the people feed reads ``is_favorite`` for that person.
 * Advisors are deliberately not allowed to favorite on behalf of an exec —
 * an advisor's favorite would be stored under the advisor and never surface
 * in the exec's feed, so the action is blocked rather than silently lost.
 */
export const postPersonContactFavorite = <ThrowOnError extends boolean = false>(options: Options<PostPersonContactFavoriteData, ThrowOnError>): RequestResult<PostPersonContactFavoriteResponses, PostPersonContactFavoriteErrors, ThrowOnError> => (options.client ?? client).post<PostPersonContactFavoriteResponses, PostPersonContactFavoriteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/people/{person_uuid}/contacts/{contact_uuid}/favorite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Events
 *
 * List events where this user (person) is a guest. Optionally filter by
 * event_date bounds. Sorted by event_date (direction via sort_event_date),
 * then created descending.
 */
export const getUserEvents = <ThrowOnError extends boolean = false>(options: Options<GetUserEventsData, ThrowOnError>): RequestResult<GetUserEventsResponses, GetUserEventsErrors, ThrowOnError> => (options.client ?? client).get<GetUserEventsResponses, GetUserEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/users/{user_uuid}/events',
    ...options
});

/**
 * Delete User V2
 *
 * DELETE /api/v2/users/{user_uuid}
 *
 * Deletes a user only when they are not currently a member of any team or
 * company (no PersonRole with team/company foreign keys). Any person can be
 * deleted, whether or not they appear in the Users list.
 */
export const deleteUserV2 = <ThrowOnError extends boolean = false>(options: Options<DeleteUserV2Data, ThrowOnError>): RequestResult<DeleteUserV2Responses, DeleteUserV2Errors, ThrowOnError> => (options.client ?? client).delete<DeleteUserV2Responses, DeleteUserV2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/users/{user_uuid}',
    ...options
});

/**
 * Get User V2
 *
 * GET /api/v2/users/{user_uuid}
 *
 * Returns detailed information about a single user including their roles,
 * company, and teams.
 */
export const getUserV2 = <ThrowOnError extends boolean = false>(options: Options<GetUserV2Data, ThrowOnError>): RequestResult<GetUserV2Responses, GetUserV2Errors, ThrowOnError> => (options.client ?? client).get<GetUserV2Responses, GetUserV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/users/{user_uuid}',
    ...options
});

/**
 * Post Users Bulk Delete V2
 *
 * POST /api/v2/users/bulk-delete
 *
 * Deletes each listed person under the same rules as
 * DELETE /api/v2/users/{user_uuid}, one commit per person, so one refusal does
 * not undo the others. Choosing the rows is the caller's job.
 */
export const postUsersBulkDeleteV2 = <ThrowOnError extends boolean = false>(options: Options<PostUsersBulkDeleteV2Data, ThrowOnError>): RequestResult<PostUsersBulkDeleteV2Responses, PostUsersBulkDeleteV2Errors, ThrowOnError> => (options.client ?? client).post<PostUsersBulkDeleteV2Responses, PostUsersBulkDeleteV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/users/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Users Search V2
 *
 * POST /api/v2/users/search
 *
 * Elasticsearch-backed users list/search with highlights.
 *
 * Phrase search (with highlights), filtering, sorting and pagination are served by
 * the ``people`` index; the response payload is hydrated from Postgres. Company
 * filtering is resolved in the DB and intersected with ES results, and sorting by
 * ``teams_count`` or ``last_login`` uses a DB hybrid path.
 */
export const postUsersSearchV2 = <ThrowOnError extends boolean = false>(options?: Options<PostUsersSearchV2Data, ThrowOnError>): RequestResult<PostUsersSearchV2Responses, PostUsersSearchV2Errors, ThrowOnError> => (options?.client ?? client).post<PostUsersSearchV2Responses, PostUsersSearchV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/users/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List Email Templates
 *
 * List email templates with pagination. Admin only.
 * Optionally filter by template_type.
 */
export const listEmailTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListEmailTemplatesData, ThrowOnError>): RequestResult<ListEmailTemplatesResponses, ListEmailTemplatesErrors, ThrowOnError> => (options?.client ?? client).get<ListEmailTemplatesResponses, ListEmailTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-templates',
    ...options
});

/**
 * Create Email Template
 *
 * Create a new shared email template. Admin only. A type can have several;
 * which one is the default is chosen with PUT /defaults/{template_type}.
 * 422 when the text uses a placeholder the type does not have.
 */
export const createEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateEmailTemplateData, ThrowOnError>): RequestResult<CreateEmailTemplateResponses, CreateEmailTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateEmailTemplateResponses, CreateEmailTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Email Template Defaults
 *
 * The default template of each type that has one.
 */
export const listEmailTemplateDefaults = <ThrowOnError extends boolean = false>(options?: Options<ListEmailTemplateDefaultsData, ThrowOnError>): RequestResult<ListEmailTemplateDefaultsResponses, ListEmailTemplateDefaultsErrors, ThrowOnError> => (options?.client ?? client).get<ListEmailTemplateDefaultsResponses, ListEmailTemplateDefaultsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-templates/defaults',
    ...options
});

/**
 * Delete Email Template Default
 *
 * Delete the default template of a type, leaving the type without one.
 * Sends that would use it then refuse, and RSVP confirmations are not sent.
 * A default an email was sent from is hidden instead of deleted.
 */
export const deleteEmailTemplateDefault = <ThrowOnError extends boolean = false>(options: Options<DeleteEmailTemplateDefaultData, ThrowOnError>): RequestResult<DeleteEmailTemplateDefaultResponses, DeleteEmailTemplateDefaultErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEmailTemplateDefaultResponses, DeleteEmailTemplateDefaultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-templates/defaults/{template_type}',
    ...options
});

/**
 * Put Email Template Default
 *
 * Write the default template of a type. Event emails use it when the event
 * has no template of its own of that type.
 *
 * Edits the current default, or creates one when the type has none. Like any
 * template, a default an email was sent from is replaced by a new version
 * when edited; it stays the default. 422 when the text uses a placeholder
 * the type does not have.
 */
export const putEmailTemplateDefault = <ThrowOnError extends boolean = false>(options: Options<PutEmailTemplateDefaultData, ThrowOnError>): RequestResult<PutEmailTemplateDefaultResponses, PutEmailTemplateDefaultErrors, ThrowOnError> => (options.client ?? client).put<PutEmailTemplateDefaultResponses, PutEmailTemplateDefaultErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-templates/defaults/{template_type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Email Template
 *
 * Delete an email template. Admin only. A template an email was sent from is
 * hidden instead, so the email history can still show what was sent. Deleting
 * a type's default leaves the type without one.
 */
export const deleteEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteEmailTemplateData, ThrowOnError>): RequestResult<DeleteEmailTemplateResponses, DeleteEmailTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEmailTemplateResponses, DeleteEmailTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-templates/{template_uuid}',
    ...options
});

/**
 * Get Email Template
 *
 * Get a single email template by UUID. Admin only.
 */
export const getEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<GetEmailTemplateData, ThrowOnError>): RequestResult<GetEmailTemplateResponses, GetEmailTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetEmailTemplateResponses, GetEmailTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-templates/{template_uuid}',
    ...options
});

/**
 * Update Email Template
 *
 * Update an email template. Admin only. Only provided fields are updated.
 *
 * Changes the template in place until an email has been sent from it. After
 * that, the old version is hidden and the response is a new template, with a
 * new uuid, holding the new text.
 */
export const updateEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateEmailTemplateData, ThrowOnError>): RequestResult<UpdateEmailTemplateResponses, UpdateEmailTemplateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEmailTemplateResponses, UpdateEmailTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-templates/{template_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Email Types
 *
 * Every kind of email Contender sends (the types in sent_email), with its
 * category and, for types that can be edited as templates, the placeholders a
 * template may use. The list is defined in code; this shows what it holds.
 * Types rendered in Contender list their template variants under previews.
 */
export const listEmailTypes = <ThrowOnError extends boolean = false>(options?: Options<ListEmailTypesData, ThrowOnError>): RequestResult<ListEmailTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListEmailTypesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-types',
    ...options
});

/**
 * Get Email Preview
 *
 * GET /api/v2/email-types/previews/{key}
 *
 * One template variant rendered with fixed sample values: its subject and
 * HTML, exactly as the send renders them. Links point at this app. Nothing is
 * stored and nothing is sent.
 */
export const getEmailPreview = <ThrowOnError extends boolean = false>(options: Options<GetEmailPreviewData, ThrowOnError>): RequestResult<GetEmailPreviewResponses, GetEmailPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetEmailPreviewResponses, GetEmailPreviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/email-types/previews/{key}',
    ...options
});

/**
 * List Event Email Templates
 *
 * The event's own templates, newest first. Hidden ones are left out.
 */
export const listEventEmailTemplates = <ThrowOnError extends boolean = false>(options: Options<ListEventEmailTemplatesData, ThrowOnError>): RequestResult<ListEventEmailTemplatesResponses, ListEventEmailTemplatesErrors, ThrowOnError> => (options.client ?? client).get<ListEventEmailTemplatesResponses, ListEventEmailTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/email-templates',
    ...options
});

/**
 * Create Event Email Template
 *
 * Add a template to the event.
 */
export const createEventEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateEventEmailTemplateData, ThrowOnError>): RequestResult<CreateEventEmailTemplateResponses, CreateEventEmailTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateEventEmailTemplateResponses, CreateEventEmailTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/email-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Event Email Template
 *
 * Delete one of the event's templates. One an email was sent from is
 * hidden instead, so the email history can still show what was sent.
 */
export const deleteEventEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteEventEmailTemplateData, ThrowOnError>): RequestResult<DeleteEventEmailTemplateResponses, DeleteEventEmailTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEventEmailTemplateResponses, DeleteEventEmailTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/email-templates/{template_uuid}',
    ...options
});

/**
 * Update Event Email Template
 *
 * Edit one of the event's templates. Only provided fields change.
 *
 * Changes the template in place until an email has been sent from it. After
 * that, the old version is hidden and the response is a new template, with a
 * new uuid, holding the new text.
 */
export const updateEventEmailTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateEventEmailTemplateData, ThrowOnError>): RequestResult<UpdateEventEmailTemplateResponses, UpdateEventEmailTemplateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEventEmailTemplateResponses, UpdateEventEmailTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/email-templates/{template_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Event Email
 *
 * Send a preview of any of this event's emails, to yourself or `email`.
 *
 * Works for every template type: a saved template (the event's own or a
 * shared template), with optional edited subject/body, or unsaved text of a
 * given type. The preview is rendered like the real email, with a preview
 * RSVP link, and is not logged.
 */
export const previewEventEmail = <ThrowOnError extends boolean = false>(options: Options<PreviewEventEmailData, ThrowOnError>): RequestResult<PreviewEventEmailResponses, PreviewEventEmailErrors, ThrowOnError> => (options.client ?? client).post<PreviewEventEmailResponses, PreviewEventEmailErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/email-templates/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Potential Guests
 *
 * List potential guests for event guest lists.
 *
 * Performance: event aggregates use indexes and LATERAL/grouped subqueries.
 * For fastest time-to-results, use include_total=false, include_aggregations=false
 * to get only the current page; then request total and/or aggregations in
 * parallel with include_results=false and the same filter/sort params.
 *
 * Returns a unified pool of:
 * - B4B users (same as users endpoint but excluding advisory/APPADMIN)
 * - Candidates (executives in the candidate pool)
 * - Standalone event guests from previous events (not linked to a person or candidate)
 *
 * When a person is both a user and a candidate, they appear once as a user with
 * optional candidate_uuid. Search phrase matches name, role, company, keyword,
 * notes, or location (PRD).
 *
 * Supports filters: source_type, client_type, tier, advisor_id, event_uuids, company_ids,
 * has_attended_events, has_invited_events,
 * events_attended_count min/max, events_invited_count min/max, last_event_date range.
 * Supports sort_rules (name, email, created, source_type, tier, warm, underrepresented,
 * advisor_name, last_event_date,
 * events_attended_count, events_invited_count, advisor_name). When include_aggregations=true,
 * returns counts per source_type, client_type, tier, advisor_id, event_uuids, company_ids,
 * has_attended_events, and has_invited_events.
 *
 * Each result carries client_types: server-computed classification mirroring
 * the users-table company-type taxonomy (executive, search, investor,
 * corporate, advisory; enterprise roles win over candidate linkage).
 */
export const postPotentialGuests = <ThrowOnError extends boolean = false>(options?: Options<PostPotentialGuestsData, ThrowOnError>): RequestResult<PostPotentialGuestsResponses, PostPotentialGuestsErrors, ThrowOnError> => (options?.client ?? client).post<PostPotentialGuestsResponses, PostPotentialGuestsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/potential-guests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Post Potential Guests Selection
 *
 * Resolve selected potential guest rows with minimal fields for email actions.
 *
 * Reuses the exact potential guest search/filter logic. selection_mode:
 * - explicit: return only included_items
 * - all_matching: return all filtered rows except excluded_items
 */
export const postPotentialGuestsSelection = <ThrowOnError extends boolean = false>(options: Options<PostPotentialGuestsSelectionData, ThrowOnError>): RequestResult<PostPotentialGuestsSelectionResponses, PostPotentialGuestsSelectionErrors, ThrowOnError> => (options.client ?? client).post<PostPotentialGuestsSelectionResponses, PostPotentialGuestsSelectionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/potential-guests/selection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Events
 *
 * List events with pagination. Optionally filter by draft status, event_date
 * bounds, and search phrase. Sorted by event_date (direction via sort_event_date,
 * nulls last), then created descending.
 */
export const getEvents = <ThrowOnError extends boolean = false>(options?: Options<GetEventsData, ThrowOnError>): RequestResult<GetEventsResponses, GetEventsErrors, ThrowOnError> => (options?.client ?? client).get<GetEventsResponses, GetEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events',
    ...options
});

/**
 * Post Event
 *
 * Create a new event. Events default to draft mode (draft=true).
 */
export const postEvent = <ThrowOnError extends boolean = false>(options: Options<PostEventData, ThrowOnError>): RequestResult<PostEventResponses, PostEventErrors, ThrowOnError> => (options.client ?? client).post<PostEventResponses, PostEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Event Guests
 *
 * List all event guests (participants) across all events, with pagination.
 *
 * Each item includes the event's uuid and title plus the guest record with
 * resolved name, role, company, email, and status. Sorted by event date
 * (desc, nulls last), then event created (desc), then guest created (asc).
 */
export const getAllEventGuests = <ThrowOnError extends boolean = false>(options?: Options<GetAllEventGuestsData, ThrowOnError>): RequestResult<GetAllEventGuestsResponses, GetAllEventGuestsErrors, ThrowOnError> => (options?.client ?? client).get<GetAllEventGuestsResponses, GetAllEventGuestsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/guests',
    ...options
});

/**
 * Get Event Rsvp Landing
 *
 * Public endpoint: get event details and guest's current RSVP status by invite token.
 * Returns 404 when the event is still in draft (unpublished). No authentication required.
 */
export const getEventRsvpLanding = <ThrowOnError extends boolean = false>(options: Options<GetEventRsvpLandingData, ThrowOnError>): RequestResult<GetEventRsvpLandingResponses, GetEventRsvpLandingErrors, ThrowOnError> => (options.client ?? client).get<GetEventRsvpLandingResponses, GetEventRsvpLandingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v2/events/rsvp',
    ...options
});

/**
 * Patch Event Rsvp
 *
 * Public endpoint: submit or update RSVP (going / cant_go) using the invite token.
 * Returns 404 when the event is still in draft. No authentication required.
 */
export const patchEventRsvp = <ThrowOnError extends boolean = false>(options: Options<PatchEventRsvpData, ThrowOnError>): RequestResult<PatchEventRsvpResponses, PatchEventRsvpErrors, ThrowOnError> => (options.client ?? client).patch<PatchEventRsvpResponses, PatchEventRsvpErrors, ThrowOnError>({
    url: '/api/v2/events/rsvp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Event Rsvp Landing Image
 *
 * Public: full-resolution landing hero image (no square crop). Same access rules as GET /rsvp.
 */
export const getEventRsvpLandingImage = <ThrowOnError extends boolean = false>(options: Options<GetEventRsvpLandingImageData, ThrowOnError>): RequestResult<GetEventRsvpLandingImageResponses, GetEventRsvpLandingImageErrors, ThrowOnError> => (options.client ?? client).get<GetEventRsvpLandingImageResponses, GetEventRsvpLandingImageErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/v2/events/rsvp/landing-image',
    ...options
});

/**
 * Get Event Rsvp Preview
 *
 * Admin-only: return event landing data for invite preview. Same shape as GET /events/rsvp
 * but without a real guest; use when the user opened the preview link from a preview email.
 * Frontend should show a preview banner and disable RSVP actions when is_preview is true.
 */
export const getEventRsvpPreview = <ThrowOnError extends boolean = false>(options: Options<GetEventRsvpPreviewData, ThrowOnError>): RequestResult<GetEventRsvpPreviewResponses, GetEventRsvpPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetEventRsvpPreviewResponses, GetEventRsvpPreviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/rsvp-preview',
    ...options
});

/**
 * Post Event Rsvp Preview
 *
 * Send the authenticated user a preview of the RSVP confirmation email (going or cant_go).
 * No RSVP is created or updated. Requires advisor auth.
 */
export const postEventRsvpPreview = <ThrowOnError extends boolean = false>(options: Options<PostEventRsvpPreviewData, ThrowOnError>): RequestResult<PostEventRsvpPreviewResponses, PostEventRsvpPreviewErrors, ThrowOnError> => (options.client ?? client).post<PostEventRsvpPreviewResponses, PostEventRsvpPreviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/rsvp-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Event
 *
 * Delete an event.
 */
export const deleteEvent = <ThrowOnError extends boolean = false>(options: Options<DeleteEventData, ThrowOnError>): RequestResult<DeleteEventResponses, DeleteEventErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEventResponses, DeleteEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}',
    ...options
});

/**
 * Get Event
 *
 * Get an event by UUID with its polymorphic guest list.
 *
 * Each guest includes source_type, linking ids (person_uuid/candidate_uuid),
 * resolved display fields (name, role, company, email), and event-guest metadata.
 */
export const getEvent = <ThrowOnError extends boolean = false>(options: Options<GetEventData, ThrowOnError>): RequestResult<GetEventResponses, GetEventErrors, ThrowOnError> => (options.client ?? client).get<GetEventResponses, GetEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}',
    ...options
});

/**
 * Patch Event
 *
 * Update an event. Only provided fields are updated.
 */
export const patchEvent = <ThrowOnError extends boolean = false>(options: Options<PatchEventData, ThrowOnError>): RequestResult<PatchEventResponses, PatchEventErrors, ThrowOnError> => (options.client ?? client).patch<PatchEventResponses, PatchEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Event Landing Image Public
 *
 * Public: landing hero by event UUID (no auth, no square crop).
 */
export const getEventLandingImagePublic = <ThrowOnError extends boolean = false>(options: Options<GetEventLandingImagePublicData, ThrowOnError>): RequestResult<GetEventLandingImagePublicResponses, GetEventLandingImagePublicErrors, ThrowOnError> => (options.client ?? client).get<GetEventLandingImagePublicResponses, GetEventLandingImagePublicErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/v2/events/{event_uuid}/landing-image',
    ...options
});

/**
 * Delete Event Landing Image
 *
 * Advisor: remove landing image; deletes storage object only if no other
 * event references it.
 */
export const deleteEventLandingImage = <ThrowOnError extends boolean = false>(options: Options<DeleteEventLandingImageData, ThrowOnError>): RequestResult<DeleteEventLandingImageResponses, DeleteEventLandingImageErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEventLandingImageResponses, DeleteEventLandingImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/image',
    ...options
});

/**
 * Post Event Landing Image
 *
 * Advisor: upload a landing hero image in one step; replaces prior image when unshared.
 */
export const postEventLandingImage = <ThrowOnError extends boolean = false>(options: Options<PostEventLandingImageData, ThrowOnError>): RequestResult<PostEventLandingImageResponses, PostEventLandingImageErrors, ThrowOnError> => (options.client ?? client).post<PostEventLandingImageResponses, PostEventLandingImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Post Event Invite Send
 *
 * Queue sending the event's saved invite email. Send to all guests with emails, to
 * guest_uuids only, or to the single guest_uuid (legacy).
 * The invite body can contain {{event_link}}; it is replaced with a per-guest RSVP URL
 * using the app's web URL (WEB_URL env) or the request origin passed to the Celery task.
 */
export const postEventInviteSend = <ThrowOnError extends boolean = false>(options: Options<PostEventInviteSendData, ThrowOnError>): RequestResult<PostEventInviteSendResponses, PostEventInviteSendErrors, ThrowOnError> => (options.client ?? client).post<PostEventInviteSendResponses, PostEventInviteSendErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/invite/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Event Invite Preview
 *
 * Send the event's invite email to the current user (or optional email) as a preview.
 * Uses the same content resolution as invite/send (event or default template).
 * {{event_link}} is replaced with a preview URL (see GET /events/{event_uuid}/rsvp-preview).
 */
export const postEventInvitePreview = <ThrowOnError extends boolean = false>(options: Options<PostEventInvitePreviewData, ThrowOnError>): RequestResult<PostEventInvitePreviewResponses, PostEventInvitePreviewErrors, ThrowOnError> => (options.client ?? client).post<PostEventInvitePreviewResponses, PostEventInvitePreviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/invite/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Event Reminder Preview
 *
 * Send a preview of the RSVP reminder (nudge) email to the current user or optional email.
 * Uses the event_rsvp_reminder template from the email_template table. Requires a default
 * reminder template to exist. Event links use WEB_URL.
 */
export const postEventReminderPreview = <ThrowOnError extends boolean = false>(options: Options<PostEventReminderPreviewData, ThrowOnError>): RequestResult<PostEventReminderPreviewResponses, PostEventReminderPreviewErrors, ThrowOnError> => (options.client ?? client).post<PostEventReminderPreviewResponses, PostEventReminderPreviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/reminder/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Event Reminder Send
 *
 * Queue RSVP reminder emails for guests who were invited but have not responded.
 * Uses the default event_rsvp_reminder template. Omit guest targeting fields to remind
 * all eligible guests; use guest_uuids or guest_uuid (legacy) for a subset.
 */
export const postEventReminderSend = <ThrowOnError extends boolean = false>(options: Options<PostEventReminderSendData, ThrowOnError>): RequestResult<PostEventReminderSendResponses, PostEventReminderSendErrors, ThrowOnError> => (options.client ?? client).post<PostEventReminderSendResponses, PostEventReminderSendErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/reminder/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Event Announcement Send
 *
 * Queue an announcement to the selected guests: any guest with an email
 * address, whatever their RSVP and whether or not they were sent an invite.
 * Uses the given event_announcement template (the event's own or a shared
 * default). Allowed when RSVP is off, if the text has no {{event_link}}.
 */
export const postEventAnnouncementSend = <ThrowOnError extends boolean = false>(options: Options<PostEventAnnouncementSendData, ThrowOnError>): RequestResult<PostEventAnnouncementSendResponses, PostEventAnnouncementSendErrors, ThrowOnError> => (options.client ?? client).post<PostEventAnnouncementSendResponses, PostEventAnnouncementSendErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/announcement/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Event Email Events
 *
 * List the emails sent for an event (invites, reminders, RSVP confirmations),
 * one item per email with its lifecycle. Admin only. Newest send first.
 * Paginated by email, not by SendGrid event. Pass `batch_uuid` to expand one
 * send run (see /email-batches), `to_identity_uuid` to keep one person's
 * emails, `email_event_type` to keep some kinds of email (invites,
 * reminders), `sendgrid_event` to keep only the emails delivered, opened,
 * bounced and so on.
 */
export const getEventEmailEvents = <ThrowOnError extends boolean = false>(options: Options<GetEventEmailEventsData, ThrowOnError>): RequestResult<GetEventEmailEventsResponses, GetEventEmailEventsErrors, ThrowOnError> => (options.client ?? client).get<GetEventEmailEventsResponses, GetEventEmailEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/email-events',
    ...options
});

/**
 * Get Event Email Batches
 *
 * The event's email log as send runs: one row per batch (the invites sent in
 * one go, one reminder pass, one RSVP confirmation), newest first, with how
 * many emails it sent and how many were delivered, opened, clicked or failed.
 * Expand a run with `/email-events?batch_uuid=`.
 *
 * Takes the same filters as `/email-events`. A run is kept when any of its
 * emails matches them (`sendgrid_event=dropped`: the runs with a dropped
 * email), and its counts are still of all its emails.
 *
 * Each run comes with its first matching emails (`first_emails`), so the
 * page can show a run's emails without a request per run.
 */
export const getEventEmailBatches = <ThrowOnError extends boolean = false>(options: Options<GetEventEmailBatchesData, ThrowOnError>): RequestResult<GetEventEmailBatchesResponses, GetEventEmailBatchesErrors, ThrowOnError> => (options.client ?? client).get<GetEventEmailBatchesResponses, GetEventEmailBatchesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/email-batches',
    ...options
});

/**
 * Get Event Guests
 *
 * List guests for an event, filtered by status/client_type(s)/phrase, with
 * per-status totals. sort=name orders by resolved display name (candidate
 * name, else person name, else standalone guest name); sort=status orders
 * by workflow progress (need_invite, invited, going, cant_go); sort=created
 * is the plain creation order. order=desc reverses the primary sort key
 * only -- the id tiebreaker stays ascending.
 *
 * With a phrase and no sort, results rank by best match; passing sort
 * overrides. (There is no "best match" sort value to request -- it's the
 * implicit ranking while searching: name-prefix, then name-contains, then
 * email-contains, then everything else.) With no phrase and no sort,
 * results are in created order, same as before this feature existed.
 *
 * client_type may be repeated (e.g. ?client_type=executive&client_type=investor)
 * to match guests of ANY of the given types (OR).
 */
export const getEventGuests = <ThrowOnError extends boolean = false>(options: Options<GetEventGuestsData, ThrowOnError>): RequestResult<GetEventGuestsResponses, GetEventGuestsErrors, ThrowOnError> => (options.client ?? client).get<GetEventGuestsResponses, GetEventGuestsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/guests',
    ...options
});

/**
 * Patch Event Guests
 *
 * Set one status on many guests of an event (bulk action from the
 * selection pane). All-or-nothing: any unknown/foreign uuid fails the batch.
 */
export const patchEventGuests = <ThrowOnError extends boolean = false>(options: Options<PatchEventGuestsData, ThrowOnError>): RequestResult<PatchEventGuestsResponses, PatchEventGuestsErrors, ThrowOnError> => (options.client ?? client).patch<PatchEventGuestsResponses, PatchEventGuestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/guests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Event Guests
 *
 * Add guests to an event. Each guest is specified by person_uuid, candidate_uuid,
 * or standalone: guest_first_name + guest_last_name + guest_email
 * (and optional guest_role, guest_company).
 *
 * Batch-friendly: lookups, inserts, and response loading are set-based, so
 * large payloads (e.g. "add all" selections of a few thousand guests) run in
 * a handful of queries rather than several per guest.
 */
export const postEventGuests = <ThrowOnError extends boolean = false>(options: Options<PostEventGuestsData, ThrowOnError>): RequestResult<PostEventGuestsResponses, PostEventGuestsErrors, ThrowOnError> => (options.client ?? client).post<PostEventGuestsResponses, PostEventGuestsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/guests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Event Guests Selection
 *
 * Resolve the full guest set matching the filters (select-all support).
 * Same filter semantics as GET /{event_uuid}/guests.
 */
export const postEventGuestsSelection = <ThrowOnError extends boolean = false>(options: Options<PostEventGuestsSelectionData, ThrowOnError>): RequestResult<PostEventGuestsSelectionResponses, PostEventGuestsSelectionErrors, ThrowOnError> => (options.client ?? client).post<PostEventGuestsSelectionResponses, PostEventGuestsSelectionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/guests/selection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Event Guest
 *
 * Remove a guest from an event. The guest record is deleted. If they were
 * already invited, their RSVP link will no longer work.
 */
export const deleteEventGuest = <ThrowOnError extends boolean = false>(options: Options<DeleteEventGuestData, ThrowOnError>): RequestResult<DeleteEventGuestResponses, DeleteEventGuestErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEventGuestResponses, DeleteEventGuestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/guests/{guest_uuid}',
    ...options
});

/**
 * Patch Event Guest
 *
 * Update an event guest (e.g. RSVP). Banff Admin only.
 */
export const patchEventGuest = <ThrowOnError extends boolean = false>(options: Options<PatchEventGuestData, ThrowOnError>): RequestResult<PatchEventGuestResponses, PatchEventGuestErrors, ThrowOnError> => (options.client ?? client).patch<PatchEventGuestResponses, PatchEventGuestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/events/{event_uuid}/guests/{guest_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Members V2
 *
 * POST /api/v2/teams/{team_slug}/members
 */
export const postTeamMembersV2 = <ThrowOnError extends boolean = false>(options: Options<PostTeamMembersV2Data, ThrowOnError>): RequestResult<PostTeamMembersV2Responses, PostTeamMembersV2Errors, ThrowOnError> => (options.client ?? client).post<PostTeamMembersV2Responses, PostTeamMembersV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_slug}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Members Bulk V2
 *
 * POST /api/v2/teams/{team_slug}/members/bulk
 */
export const postTeamMembersBulkV2 = <ThrowOnError extends boolean = false>(options: Options<PostTeamMembersBulkV2Data, ThrowOnError>): RequestResult<PostTeamMembersBulkV2Responses, PostTeamMembersBulkV2Errors, ThrowOnError> => (options.client ?? client).post<PostTeamMembersBulkV2Responses, PostTeamMembersBulkV2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_slug}/members/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Intro Insight
 *
 * GET /api/v2/teams/{team_slug}/intro-insight
 *
 * Live list of the team's up-to-10 most recent intro requests + the stored AI summary.
 */
export const getTeamIntroInsight = <ThrowOnError extends boolean = false>(options: Options<GetTeamIntroInsightData, ThrowOnError>): RequestResult<GetTeamIntroInsightResponses, GetTeamIntroInsightErrors, ThrowOnError> => (options.client ?? client).get<GetTeamIntroInsightResponses, GetTeamIntroInsightErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/teams/{team_uuid}/intro-insight',
    ...options
});

/**
 * Post Submissions
 *
 * POST /api/v3/submissions
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const postSubmissions = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionsData, ThrowOnError>): RequestResult<PostSubmissionsResponses, PostSubmissionsErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionsResponses, PostSubmissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Submission Email Preview
 *
 * POST /api/v3/submissions/email-preview
 *
 * Render the trending email for an unsaved draft, exactly as a registered team
 * member would receive it. Nothing in the email depends on the recipient except
 * the links, so the preview is exact. Nothing is stored and nothing is sent.
 * ``payload`` is the same body the form saves; ``team_uuid`` picks which team's
 * links to render (default: the draft's first team; with no team yet the links
 * point at the app root).
 * The email is laid out as ``payload.notification_type`` says. A Plain v2
 * subject and message are checked as they would be at publish; text that could
 * not be sent is refused with what to fix (400). The recipient is not known, so
 * ``{{first_name}}`` is left blank.
 */
export const postSubmissionEmailPreview = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionEmailPreviewData, ThrowOnError>): RequestResult<PostSubmissionEmailPreviewResponses, PostSubmissionEmailPreviewErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionEmailPreviewResponses, PostSubmissionEmailPreviewErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions/email-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Trending Message Keys
 *
 * GET /api/v3/submissions/trending-message-keys
 *
 * The keys a Plain trending email's subject and message can use, and the
 * subject and message a new campaign starts from.
 */
export const getTrendingMessageKeys = <ThrowOnError extends boolean = false>(options?: Options<GetTrendingMessageKeysData, ThrowOnError>): RequestResult<GetTrendingMessageKeysResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTrendingMessageKeysResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions/trending-message-keys',
    ...options
});

/**
 * Get Trending Messages
 *
 * GET /api/v3/submissions/trending-messages
 *
 * The messages advisors have sent in this candidate's Trending campaigns,
 * newest first, so a new campaign can start from one. The message is stored on
 * the submission when the campaign is published or scheduled. Campaigns that
 * sent the same body text (ignoring leading and trailing whitespace) are one
 * message; its subject and advisor are those of the latest campaign.
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const getTrendingMessages = <ThrowOnError extends boolean = false>(options: Options<GetTrendingMessagesData, ThrowOnError>): RequestResult<GetTrendingMessagesResponses, GetTrendingMessagesErrors, ThrowOnError> => (options.client ?? client).get<GetTrendingMessagesResponses, GetTrendingMessagesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions/trending-messages',
    ...options
});

/**
 * Post Submission Cancel Recommendations
 *
 * DELETE /api/v3/submissions/{submission_uuid}/scheduled
 */
export const postSubmissionCancelRecommendations = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionCancelRecommendationsData, ThrowOnError>): RequestResult<PostSubmissionCancelRecommendationsResponses, PostSubmissionCancelRecommendationsErrors, ThrowOnError> => (options.client ?? client).delete<PostSubmissionCancelRecommendationsResponses, PostSubmissionCancelRecommendationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions/{submission_uuid}/scheduled',
    ...options
});

/**
 * Delete Submission
 *
 * DELETE /api/v3/submissions/{submission_uuid}
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const deleteSubmission = <ThrowOnError extends boolean = false>(options: Options<DeleteSubmissionData, ThrowOnError>): RequestResult<DeleteSubmissionResponses, DeleteSubmissionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSubmissionResponses, DeleteSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions/{submission_uuid}',
    ...options
});

/**
 * Get Submission
 *
 * GET /api/v3/submissions/{submission_uuid}
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const getSubmission = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionData, ThrowOnError>): RequestResult<GetSubmissionResponses, GetSubmissionErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionResponses, GetSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions/{submission_uuid}',
    ...options
});

/**
 * Put Submission
 *
 * PUT /api/v3/submissions/{submission_uuid}
 */
export const putSubmission = <ThrowOnError extends boolean = false>(options: Options<PutSubmissionData, ThrowOnError>): RequestResult<PutSubmissionResponses, PutSubmissionErrors, ThrowOnError> => (options.client ?? client).put<PutSubmissionResponses, PutSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions/{submission_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Submission Status
 *
 * PUT /api/v3/submissions/{submission_uuid}/status
 *
 * Also open to the Contender Actions connector (``X-MCP-API-Key`` +
 * ``X-Acting-User-Email``, see ``app.api.deps.auth.agent``).
 */
export const putSubmissionStatus = <ThrowOnError extends boolean = false>(options: Options<PutSubmissionStatusData, ThrowOnError>): RequestResult<PutSubmissionStatusResponses, PutSubmissionStatusErrors, ThrowOnError> => (options.client ?? client).put<PutSubmissionStatusResponses, PutSubmissionStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/submissions/{submission_uuid}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Team Candidates Filter V3
 *
 * POST /api/v3/teams/{team_uuid}/candidates/filter
 */
export const postTeamCandidatesFilterV3 = <ThrowOnError extends boolean = false>(options: Options<PostTeamCandidatesFilterV3Data, ThrowOnError>): RequestResult<PostTeamCandidatesFilterV3Responses, PostTeamCandidatesFilterV3Errors, ThrowOnError> => (options.client ?? client).post<PostTeamCandidatesFilterV3Responses, PostTeamCandidatesFilterV3Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/teams/{team_uuid}/candidates/filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
